import { SynonymsType } from "./synonyms-types";

export const SYNONYMS: SynonymsType = {
    "ARCHIVES": {
       "ArchiveType": {
          "borehole": {
             "id": "http://linked.earth/ontology/archive#Borehole",
             "label": "Borehole"
          },
          "coral": {
             "id": "http://linked.earth/ontology/archive#Coral",
             "label": "Coral"
          },
          "fluvial sediment": {
             "id": "http://linked.earth/ontology/archive#FluvialSediment",
             "label": "Fluvial sediment"
          },
          "fluvialsediment": {
             "id": "http://linked.earth/ontology/archive#FluvialSediment",
             "label": "Fluvial sediment"
          },
          "creek": {
             "id": "http://linked.earth/ontology/archive#FluvialSediment",
             "label": "Fluvial sediment"
          },
          "fluvial": {
             "id": "http://linked.earth/ontology/archive#FluvialSediment",
             "label": "Fluvial sediment"
          },
          "river": {
             "id": "http://linked.earth/ontology/archive#FluvialSediment",
             "label": "Fluvial sediment"
          },
          "stream": {
             "id": "http://linked.earth/ontology/archive#FluvialSediment",
             "label": "Fluvial sediment"
          },
          "glacier ice": {
             "id": "http://linked.earth/ontology/archive#GlacierIce",
             "label": "Glacier ice"
          },
          "glacierice": {
             "id": "http://linked.earth/ontology/archive#GlacierIce",
             "label": "Glacier ice"
          },
          "ice cores": {
             "id": "http://linked.earth/ontology/archive#GlacierIce",
             "label": "Glacier ice"
          },
          "ground ice": {
             "id": "http://linked.earth/ontology/archive#GroundIce",
             "label": "Ground ice"
          },
          "groundice": {
             "id": "http://linked.earth/ontology/archive#GroundIce",
             "label": "Ground ice"
          },
          "bulk ice": {
             "id": "http://linked.earth/ontology/archive#GroundIce",
             "label": "Ground ice"
          },
          "lake sediment": {
             "id": "http://linked.earth/ontology/archive#LakeSediment",
             "label": "Lake sediment"
          },
          "lakesediment": {
             "id": "http://linked.earth/ontology/archive#LakeSediment",
             "label": "Lake sediment"
          },
          "lagoon": {
             "id": "http://linked.earth/ontology/archive#LakeSediment",
             "label": "Lake sediment"
          },
          "lake": {
             "id": "http://linked.earth/ontology/archive#LakeSediment",
             "label": "Lake sediment"
          },
          "marine sediment": {
             "id": "http://linked.earth/ontology/archive#MarineSediment",
             "label": "Marine sediment"
          },
          "marinesediment": {
             "id": "http://linked.earth/ontology/archive#MarineSediment",
             "label": "Marine sediment"
          },
          "delta": {
             "id": "http://linked.earth/ontology/archive#MarineSediment",
             "label": "Marine sediment"
          },
          "marine": {
             "id": "http://linked.earth/ontology/archive#MarineSediment",
             "label": "Marine sediment"
          },
          "midden": {
             "id": "http://linked.earth/ontology/archive#Midden",
             "label": "Midden"
          },
          "mollusk shell": {
             "id": "http://linked.earth/ontology/archive#MolluskShell",
             "label": "Mollusk shell"
          },
          "molluskshell": {
             "id": "http://linked.earth/ontology/archive#MolluskShell",
             "label": "Mollusk shell"
          },
          "bivalve": {
             "id": "http://linked.earth/ontology/archive#MolluskShell",
             "label": "Mollusk shell"
          },
          "molluskshells": {
             "id": "http://linked.earth/ontology/archive#MolluskShell",
             "label": "Mollusk shell"
          },
          "peat": {
             "id": "http://linked.earth/ontology/archive#Peat",
             "label": "Peat"
          },
          "bog": {
             "id": "http://linked.earth/ontology/archive#Peat",
             "label": "Peat"
          },
          "fen": {
             "id": "http://linked.earth/ontology/archive#Peat",
             "label": "Peat"
          },
          "marsh": {
             "id": "http://linked.earth/ontology/archive#Peat",
             "label": "Peat"
          },
          "mire": {
             "id": "http://linked.earth/ontology/archive#Peat",
             "label": "Peat"
          },
          "swamp": {
             "id": "http://linked.earth/ontology/archive#Peat",
             "label": "Peat"
          },
          "sclerosponge": {
             "id": "http://linked.earth/ontology/archive#Sclerosponge",
             "label": "Sclerosponge"
          },
          "shoreline": {
             "id": "http://linked.earth/ontology/archive#Shoreline",
             "label": "Shoreline"
          },
          "lake levels": {
             "id": "http://linked.earth/ontology/archive#Shoreline",
             "label": "Shoreline"
          },
          "lakedeposit": {
             "id": "http://linked.earth/ontology/archive#Shoreline",
             "label": "Shoreline"
          },
          "lakedeposits": {
             "id": "http://linked.earth/ontology/archive#Shoreline",
             "label": "Shoreline"
          },
          "speleothem": {
             "id": "http://linked.earth/ontology/archive#Speleothem",
             "label": "Speleothem"
          },
          "speleothems": {
             "id": "http://linked.earth/ontology/archive#Speleothem",
             "label": "Speleothem"
          },
          "cave": {
             "id": "http://linked.earth/ontology/archive#Speleothem",
             "label": "Speleothem"
          },
          "terrestrial sediment": {
             "id": "http://linked.earth/ontology/archive#TerrestrialSediment",
             "label": "Terrestrial sediment"
          },
          "terrestrialsediment": {
             "id": "http://linked.earth/ontology/archive#TerrestrialSediment",
             "label": "Terrestrial sediment"
          },
          "dune": {
             "id": "http://linked.earth/ontology/archive#TerrestrialSediment",
             "label": "Terrestrial sediment"
          },
          "loess": {
             "id": "http://linked.earth/ontology/archive#TerrestrialSediment",
             "label": "Terrestrial sediment"
          },
          "wood": {
             "id": "http://linked.earth/ontology/archive#Wood",
             "label": "Wood"
          },
          "tree ring": {
             "id": "http://linked.earth/ontology/archive#Wood",
             "label": "Wood"
          },
          "tree": {
             "id": "http://linked.earth/ontology/archive#Wood",
             "label": "Wood"
          },
          "documents": {
             "id": "http://linked.earth/ontology/archive#Documents",
             "label": "Documents"
          },
          "other": {
             "id": "http://linked.earth/ontology/archive#Other",
             "label": "Other"
          }
       }
    },
    "INTERPRETATION": {
       "InterpretationVariable": {
          "c3c4ratio": {
             "id": "http://linked.earth/ontology/interpretation#C3C4Ratio",
             "label": "C3C4Ratio"
          },
          "composition c3-c4 plants": {
             "id": "http://linked.earth/ontology/interpretation#C3C4Ratio",
             "label": "C3C4Ratio"
          },
          "circulationindex": {
             "id": "http://linked.earth/ontology/interpretation#circulationIndex",
             "label": "circulationIndex"
          },
          "circulation index": {
             "id": "http://linked.earth/ontology/interpretation#circulationIndex",
             "label": "circulationIndex"
          },
          "mode": {
             "id": "http://linked.earth/ontology/interpretation#circulationIndex",
             "label": "circulationIndex"
          },
          "nao index": {
             "id": "http://linked.earth/ontology/interpretation#circulationIndex",
             "label": "circulationIndex"
          },
          "circulationvariable": {
             "id": "http://linked.earth/ontology/interpretation#circulationVariable",
             "label": "circulationVariable"
          },
          "circulation variable": {
             "id": "http://linked.earth/ontology/interpretation#circulationVariable",
             "label": "circulationVariable"
          },
          "changes in monsoon intensity.": {
             "id": "http://linked.earth/ontology/interpretation#circulationVariable",
             "label": "circulationVariable"
          },
          "circulation": {
             "id": "http://linked.earth/ontology/interpretation#circulationVariable",
             "label": "circulationVariable"
          },
          "dissolvedoxygen": {
             "id": "http://linked.earth/ontology/interpretation#dissolvedOxygen",
             "label": "dissolvedOxygen"
          },
          "dissolved oxygen": {
             "id": "http://linked.earth/ontology/interpretation#dissolvedOxygen",
             "label": "dissolvedOxygen"
          },
          "suboxia": {
             "id": "http://linked.earth/ontology/interpretation#dissolvedOxygen",
             "label": "dissolvedOxygen"
          },
          "dust": {
             "id": "http://linked.earth/ontology/interpretation#dust",
             "label": "dust"
          },
          "ela": {
             "id": "http://linked.earth/ontology/interpretation#ELA",
             "label": "ELA"
          },
          "equilibrium line altitude": {
             "id": "http://linked.earth/ontology/interpretation#ELA",
             "label": "ELA"
          },
          "evaporation": {
             "id": "http://linked.earth/ontology/interpretation#evaporation",
             "label": "evaporation"
          },
          "fire": {
             "id": "http://linked.earth/ontology/interpretation#fire",
             "label": "fire"
          },
          "fire history": {
             "id": "http://linked.earth/ontology/interpretation#fire",
             "label": "fire"
          },
          "growingdegreedays": {
             "id": "http://linked.earth/ontology/interpretation#growingDegreeDays",
             "label": "growingDegreeDays"
          },
          "growing degree days": {
             "id": "http://linked.earth/ontology/interpretation#growingDegreeDays",
             "label": "growingDegreeDays"
          },
          "gdd": {
             "id": "http://linked.earth/ontology/interpretation#growingDegreeDays",
             "label": "growingDegreeDays"
          },
          "hydrologicbalance": {
             "id": "http://linked.earth/ontology/interpretation#hydrologicBalance",
             "label": "hydrologicBalance"
          },
          "gw-e": {
             "id": "http://linked.earth/ontology/interpretation#hydrologicBalance",
             "label": "hydrologicBalance"
          },
          "i_e": {
             "id": "http://linked.earth/ontology/interpretation#hydrologicBalance",
             "label": "hydrologicBalance"
          },
          "hydrology": {
             "id": "http://linked.earth/ontology/interpretation#hydrologicBalance",
             "label": "hydrologicBalance"
          },
          "lakewaterisotope": {
             "id": "http://linked.earth/ontology/interpretation#lakeWaterIsotope",
             "label": "lakeWaterIsotope"
          },
          "lake water and precipitation d2h": {
             "id": "http://linked.earth/ontology/interpretation#lakeWaterIsotope",
             "label": "lakeWaterIsotope"
          },
          "lake water d18o": {
             "id": "http://linked.earth/ontology/interpretation#lakeWaterIsotope",
             "label": "lakeWaterIsotope"
          },
          "lake water d2h": {
             "id": "http://linked.earth/ontology/interpretation#lakeWaterIsotope",
             "label": "lakeWaterIsotope"
          },
          "liso": {
             "id": "http://linked.earth/ontology/interpretation#lakeWaterIsotope",
             "label": "lakeWaterIsotope"
          },
          "meltwater": {
             "id": "http://linked.earth/ontology/interpretation#meltwater",
             "label": "meltwater"
          },
          "ice melt": {
             "id": "http://linked.earth/ontology/interpretation#meltwater",
             "label": "meltwater"
          },
          "needstobereplaced": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "anoxia": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "carbonate_ion_concentration": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "export-productivity": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "gdgt": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "mixed": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "precipitation d2h + evap": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "t+ela": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "plant community composition": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "liso/p-e": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "organic matter source": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeReplaced",
             "label": "needsToBeReplaced"
          },
          "p-e": {
             "id": "http://linked.earth/ontology/interpretation#P-E",
             "label": "P-E"
          },
          "precipitation minus evaporation": {
             "id": "http://linked.earth/ontology/interpretation#P-E",
             "label": "P-E"
          },
          "effective moisture": {
             "id": "http://linked.earth/ontology/interpretation#P-E",
             "label": "P-E"
          },
          "m": {
             "id": "http://linked.earth/ontology/interpretation#P-E",
             "label": "P-E"
          },
          "p_e": {
             "id": "http://linked.earth/ontology/interpretation#P-E",
             "label": "P-E"
          },
          "p=e": {
             "id": "http://linked.earth/ontology/interpretation#P-E",
             "label": "P-E"
          },
          "precipitation": {
             "id": "http://linked.earth/ontology/interpretation#precipitation",
             "label": "precipitation"
          },
          "pmax": {
             "id": "http://linked.earth/ontology/interpretation#precipitation",
             "label": "precipitation"
          },
          "pmin": {
             "id": "http://linked.earth/ontology/interpretation#precipitation",
             "label": "precipitation"
          },
          "p": {
             "id": "http://linked.earth/ontology/interpretation#precipitation",
             "label": "precipitation"
          },
          "p_amount": {
             "id": "http://linked.earth/ontology/interpretation#precipitation",
             "label": "precipitation"
          },
          "precipitationdeuteriumexcess": {
             "id": "http://linked.earth/ontology/interpretation#precipitationDeuteriumExcess",
             "label": "precipitationDeuteriumExcess"
          },
          "precipitation d-excess": {
             "id": "http://linked.earth/ontology/interpretation#precipitationDeuteriumExcess",
             "label": "precipitationDeuteriumExcess"
          },
          "precipitationisotope": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "dd": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "d18o of precipitation": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "p_isotope": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "piso": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "precipitation d18o": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "precipitation d2h": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "precipitation isotope": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "source": {
             "id": "http://linked.earth/ontology/interpretation#precipitationIsotope",
             "label": "precipitationIsotope"
          },
          "productivity": {
             "id": "http://linked.earth/ontology/interpretation#productivity",
             "label": "productivity"
          },
          "algal productivity": {
             "id": "http://linked.earth/ontology/interpretation#productivity",
             "label": "productivity"
          },
          "relativehumidity": {
             "id": "http://linked.earth/ontology/interpretation#relativeHumidity",
             "label": "relativeHumidity"
          },
          "relative humidity": {
             "id": "http://linked.earth/ontology/interpretation#relativeHumidity",
             "label": "relativeHumidity"
          },
          "rh": {
             "id": "http://linked.earth/ontology/interpretation#relativeHumidity",
             "label": "relativeHumidity"
          },
          "salinity": {
             "id": "http://linked.earth/ontology/interpretation#salinity",
             "label": "salinity"
          },
          "s": {
             "id": "http://linked.earth/ontology/interpretation#salinity",
             "label": "salinity"
          },
          "sss": {
             "id": "http://linked.earth/ontology/interpretation#salinity",
             "label": "salinity"
          },
          "seaice": {
             "id": "http://linked.earth/ontology/interpretation#seaIce",
             "label": "seaIce"
          },
          "sea ice cover": {
             "id": "http://linked.earth/ontology/interpretation#seaIce",
             "label": "seaIce"
          },
          "ice": {
             "id": "http://linked.earth/ontology/interpretation#seaIce",
             "label": "seaIce"
          },
          "seasonality": {
             "id": "http://linked.earth/ontology/interpretation#seasonality",
             "label": "seasonality"
          },
          "seawaterisotope": {
             "id": "http://linked.earth/ontology/interpretation#seawaterIsotope",
             "label": "seawaterIsotope"
          },
          "seawater_isotope": {
             "id": "http://linked.earth/ontology/interpretation#seawaterIsotope",
             "label": "seawaterIsotope"
          },
          "streamflow": {
             "id": "http://linked.earth/ontology/interpretation#streamflow",
             "label": "streamflow"
          },
          "q": {
             "id": "http://linked.earth/ontology/interpretation#streamflow",
             "label": "streamflow"
          },
          "sunlight": {
             "id": "http://linked.earth/ontology/interpretation#sunlight",
             "label": "sunlight"
          },
          "solar irradiance": {
             "id": "http://linked.earth/ontology/interpretation#sunlight",
             "label": "sunlight"
          },
          "sun": {
             "id": "http://linked.earth/ontology/interpretation#sunlight",
             "label": "sunlight"
          },
          "surfacepressure": {
             "id": "http://linked.earth/ontology/interpretation#surfacePressure",
             "label": "surfacePressure"
          },
          "surface pressure": {
             "id": "http://linked.earth/ontology/interpretation#surfacePressure",
             "label": "surfacePressure"
          },
          "temperature": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "sst": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "subt": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "surface water temp": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "t": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "t_air": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "t_water": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "temperature_water": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "lake water temperature": {
             "id": "http://linked.earth/ontology/interpretation#temperature",
             "label": "temperature"
          },
          "upwelling": {
             "id": "http://linked.earth/ontology/interpretation#upwelling",
             "label": "upwelling"
          },
          "upwelling index": {
             "id": "http://linked.earth/ontology/interpretation#upwelling",
             "label": "upwelling"
          },
          "windspeed": {
             "id": "http://linked.earth/ontology/interpretation#windSpeed",
             "label": "windSpeed"
          },
          "wind speed": {
             "id": "http://linked.earth/ontology/interpretation#windSpeed",
             "label": "windSpeed"
          },
          "w": {
             "id": "http://linked.earth/ontology/interpretation#windSpeed",
             "label": "windSpeed"
          }
       },
       "InterpretationSeasonality": {
          "annual": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,12": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1 2 3 4 5 6 7 8 9 10 11 12": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "warmest + coldest months": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "not applicable (always)": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "annual mean": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "annual calendar year (but 80% of precipitation from nov to may)": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "coldest + warmest month": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "warmest + coldest month": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "year round": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "year-round": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "years": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,117": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,122": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,138": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,158": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,190": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,229": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,291": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,434": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,464": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,588": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,646": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "1,2,3,4,5,6,7,8,9,10,11,706": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "12 1 2; 6 7 8": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "annual (*but recently would prob be interpreted as summer-biased)": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "coldest month + summer": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "late summer/winter lake water (summer-biased mean annual precip)": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "mean annual (weighted toward ond and mam)": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "multi-annual": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "summer + winter": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "summer-biased/annual?": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "warmest + coldest": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "warmest month + winter": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "warmest month; coldest month": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "winter": {
             "id": "http://linked.earth/ontology/interpretation#Winter",
             "label": "Winter"
          },
          "summer temperature": {
             "id": "http://linked.earth/ontology/interpretation#Annual",
             "label": "Annual"
          },
          "apr": {
             "id": "http://linked.earth/ontology/interpretation#Apr",
             "label": "Apr"
          },
          "4": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "apr-aug": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Aug",
             "label": "Apr-Aug"
          },
          "april-may": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Aug",
             "label": "Apr-Aug"
          },
          "june-august": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Aug",
             "label": "Apr-Aug"
          },
          "apr-dec": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Dec",
             "label": "Apr-Dec"
          },
          "4 5 6 7 8 9 10 12": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Dec",
             "label": "Apr-Dec"
          },
          "apr-feb": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Feb",
             "label": "Apr-Feb"
          },
          "apr-jan": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jan",
             "label": "Apr-Jan"
          },
          "apr-jul": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jul",
             "label": "Apr-Jul"
          },
          "4 5 6 7": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jul",
             "label": "Apr-Jul"
          },
          "amjj": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jul",
             "label": "Apr-Jul"
          },
          "spring-summer (april-july)": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jul",
             "label": "Apr-Jul"
          },
          "apr-jun": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jun",
             "label": "Apr-Jun"
          },
          "4 5 2006": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Jun",
             "label": "Apr-Jun"
          },
          "apr-mar": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Mar",
             "label": "Apr-Mar"
          },
          "april/june to april/march": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Mar",
             "label": "Apr-Mar"
          },
          "apr-may": {
             "id": "http://linked.earth/ontology/interpretation#Apr-May",
             "label": "Apr-May"
          },
          "apr-nov": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Nov",
             "label": "Apr-Nov"
          },
          "apr-oct": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Oct",
             "label": "Apr-Oct"
          },
          "4,5,6,7,8,9,10": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Oct",
             "label": "Apr-Oct"
          },
          "amjjaso": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Oct",
             "label": "Apr-Oct"
          },
          "apr-sep": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Sep",
             "label": "Apr-Sep"
          },
          "4,5,6,7,8,9": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Sep",
             "label": "Apr-Sep"
          },
          "amjjas": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Sep",
             "label": "Apr-Sep"
          },
          "4 5 6 7 8 9": {
             "id": "http://linked.earth/ontology/interpretation#Apr-Sep",
             "label": "Apr-Sep"
          },
          "aug": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "8": {
             "id": "http://linked.earth/ontology/interpretation#Aug",
             "label": "Aug"
          },
          "aug-apr": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Apr",
             "label": "Aug-Apr"
          },
          "aug-dec": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Dec",
             "label": "Aug-Dec"
          },
          "aug-feb": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Feb",
             "label": "Aug-Feb"
          },
          "aug-jan": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Jan",
             "label": "Aug-Jan"
          },
          "aug-jul": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Jul",
             "label": "Aug-Jul"
          },
          "-12 -11 -10 -9 -8 1 2 3 4 5 6 7": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Jul",
             "label": "Aug-Jul"
          },
          "thermal year (aug-jul) (but 80% of precipitation from nov to may)": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Jul",
             "label": "Aug-Jul"
          },
          "aug-jun": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Jun",
             "label": "Aug-Jun"
          },
          "aug-mar": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Mar",
             "label": "Aug-Mar"
          },
          "aug-may": {
             "id": "http://linked.earth/ontology/interpretation#Aug-May",
             "label": "Aug-May"
          },
          "aug-nov": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Nov",
             "label": "Aug-Nov"
          },
          "aug-oct": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Oct",
             "label": "Aug-Oct"
          },
          "aug-sep": {
             "id": "http://linked.earth/ontology/interpretation#Aug-Sep",
             "label": "Aug-Sep"
          },
          "coldest month": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "coldest_month": {
             "id": "http://linked.earth/ontology/interpretation#Coldest_Month",
             "label": "Coldest Month"
          },
          "growing season": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "coldest": {
             "id": "http://linked.earth/ontology/interpretation#Coldest_Month",
             "label": "Coldest Month"
          },
          "dec-apr": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Apr",
             "label": "Dec-Apr"
          },
          "12,1,2,3,4": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Apr",
             "label": "Dec-Apr"
          },
          "dec-aug": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Aug",
             "label": "Dec-Aug"
          },
          "dec-feb": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Feb",
             "label": "Dec-Feb"
          },
          "12,1,2": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Feb",
             "label": "Dec-Feb"
          },
          "djf": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Feb",
             "label": "Dec-Feb"
          },
          "-12 1 2": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Feb",
             "label": "Dec-Feb"
          },
          "1,2,12": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Feb",
             "label": "Dec-Feb"
          },
          "dec-jan": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Jan",
             "label": "Dec-Jan"
          },
          "dec-jul": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Jul",
             "label": "Dec-Jul"
          },
          "dec-jun": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Jun",
             "label": "Dec-Jun"
          },
          "dec-mar": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Mar",
             "label": "Dec-Mar"
          },
          "12,1,2,3": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Mar",
             "label": "Dec-Mar"
          },
          "-12 1 2 3": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Mar",
             "label": "Dec-Mar"
          },
          "december - march (monsoon season)": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Mar",
             "label": "Dec-Mar"
          },
          "dec-may": {
             "id": "http://linked.earth/ontology/interpretation#Dec-May",
             "label": "Dec-May"
          },
          "djfmam": {
             "id": "http://linked.earth/ontology/interpretation#Dec-May",
             "label": "Dec-May"
          },
          "dec-oct": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Oct",
             "label": "Dec-Oct"
          },
          "dec-sep": {
             "id": "http://linked.earth/ontology/interpretation#Dec-Sep",
             "label": "Dec-Sep"
          },
          "fall": {
             "id": "http://linked.earth/ontology/interpretation#Fall",
             "label": "Fall"
          },
          "autumn": {
             "id": "http://linked.earth/ontology/interpretation#Fall",
             "label": "Fall"
          },
          "feb": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Aug",
             "label": "Feb-Aug"
          },
          "2": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "feb-apr": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Apr",
             "label": "Feb-Apr"
          },
          "feb-aug": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Aug",
             "label": "Feb-Aug"
          },
          "2 3 4 5 6 7 8": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Aug",
             "label": "Feb-Aug"
          },
          "feb-dec": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Dec",
             "label": "Feb-Dec"
          },
          "feb-jul": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Jul",
             "label": "Feb-Jul"
          },
          "feb-jun": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Jun",
             "label": "Feb-Jun"
          },
          "feb-mar": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Mar",
             "label": "Feb-Mar"
          },
          "feb-may": {
             "id": "http://linked.earth/ontology/interpretation#Feb-May",
             "label": "Feb-May"
          },
          "feb-nov": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Nov",
             "label": "Feb-Nov"
          },
          "feb-oct": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Oct",
             "label": "Feb-Oct"
          },
          "feb-sep": {
             "id": "http://linked.earth/ontology/interpretation#Feb-Sep",
             "label": "Feb-Sep"
          },
          "growing_season": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "growing season? (not stated)": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "growth season": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "mainly growing season": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "with potential addition effects of snowmelt following wet winters": {
             "id": "http://linked.earth/ontology/interpretation#Growing_Season",
             "label": "Growing Season"
          },
          "jan": {
             "id": "http://linked.earth/ontology/interpretation#Jan",
             "label": "Jan"
          },
          "1": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "jan-apr": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Apr",
             "label": "Jan-Apr"
          },
          "january": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Apr",
             "label": "Jan-Apr"
          },
          "february": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Apr",
             "label": "Jan-Apr"
          },
          "march": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Apr",
             "label": "Jan-Apr"
          },
          "april": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Apr",
             "label": "Jan-Apr"
          },
          "jfma": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Apr",
             "label": "Jan-Apr"
          },
          "jan-aug": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Aug",
             "label": "Jan-Aug"
          },
          "jan-feb": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Feb",
             "label": "Jan-Feb"
          },
          "jan-jul": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Jul",
             "label": "Jan-Jul"
          },
          "jfmamjj": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Jul",
             "label": "Jan-Jul"
          },
          "jan-jun": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Jun",
             "label": "Jan-Jun"
          },
          "january-june (spring)": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Jun",
             "label": "Jan-Jun"
          },
          "jan-mar": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Mar",
             "label": "Jan-Mar"
          },
          "1 2 2003": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Mar",
             "label": "Jan-Mar"
          },
          "jan-may": {
             "id": "http://linked.earth/ontology/interpretation#Jan-May",
             "label": "Jan-May"
          },
          "jan-nov": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Nov",
             "label": "Jan-Nov"
          },
          "jan-oct": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Oct",
             "label": "Jan-Oct"
          },
          "jan-sep": {
             "id": "http://linked.earth/ontology/interpretation#Jan-Sep",
             "label": "Jan-Sep"
          },
          "jul": {
             "id": "http://linked.earth/ontology/interpretation#Jul",
             "label": "Jul"
          },
          "july": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "7": {
             "id": "http://linked.earth/ontology/interpretation#Jul",
             "label": "Jul"
          },
          "jul-apr": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Apr",
             "label": "Jul-Apr"
          },
          "jul-aug": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Aug",
             "label": "Jul-Aug"
          },
          "jul-dec": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Dec",
             "label": "Jul-Dec"
          },
          "7 8 9 10 11 12": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Dec",
             "label": "Jul-Dec"
          },
          "jul-feb": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Feb",
             "label": "Jul-Feb"
          },
          "jul-jan": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Jan",
             "label": "Jul-Jan"
          },
          "jul-jun": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Jun",
             "label": "Jul-Jun"
          },
          "-12 -11 -10 -9 -8 -7 1 2 3 4 5 6": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Jun",
             "label": "Jul-Jun"
          },
          "jul-mar": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Mar",
             "label": "Jul-Mar"
          },
          "jul-may": {
             "id": "http://linked.earth/ontology/interpretation#Jul-May",
             "label": "Jul-May"
          },
          "jul-nov": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Nov",
             "label": "Jul-Nov"
          },
          "jul-oct": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Oct",
             "label": "Jul-Oct"
          },
          "7,8,9,10": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Oct",
             "label": "Jul-Oct"
          },
          "jul-sep": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Sep",
             "label": "Jul-Sep"
          },
          "7 8 2009": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Sep",
             "label": "Jul-Sep"
          },
          "7,8,9": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Sep",
             "label": "Jul-Sep"
          },
          "((( 7 8 2009 ))) null /// 7 8 9": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Sep",
             "label": "Jul-Sep"
          },
          "jas": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Sep",
             "label": "Jul-Sep"
          },
          "summer (jas)": {
             "id": "http://linked.earth/ontology/interpretation#Jul-Sep",
             "label": "Jul-Sep"
          },
          "jun": {
             "id": "http://linked.earth/ontology/interpretation#Jun",
             "label": "Jun"
          },
          "6": {
             "id": "http://linked.earth/ontology/interpretation#Jun",
             "label": "Jun"
          },
          "jun-apr": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Apr",
             "label": "Jun-Apr"
          },
          "jun-aug": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "jja": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "6,7,8": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "6 7 2008": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "((( 6 7 2008 ))) null /// 6 7 8": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "summer (june-august)": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "((( 6 7 2008 ))) 39606 /// 6 7 8": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "june,july": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "august": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "summer (jja)": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Aug",
             "label": "Jun-Aug"
          },
          "jun-dec": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Dec",
             "label": "Jun-Dec"
          },
          "jun-feb": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Feb",
             "label": "Jun-Feb"
          },
          "jun-jan": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Jan",
             "label": "Jun-Jan"
          },
          "jun-jul": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Jul",
             "label": "Jun-Jul"
          },
          "6 7": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Jul",
             "label": "Jun-Jul"
          },
          "6,7": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Jul",
             "label": "Jun-Jul"
          },
          "june-july minimum": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Jul",
             "label": "Jun-Jul"
          },
          "jun-mar": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Mar",
             "label": "Jun-Mar"
          },
          "jun-nov": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Nov",
             "label": "Jun-Nov"
          },
          "jjason": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Nov",
             "label": "Jun-Nov"
          },
          "jun-oct": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Oct",
             "label": "Jun-Oct"
          },
          "6,7,8,9,10": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Oct",
             "label": "Jun-Oct"
          },
          "jjaso": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Oct",
             "label": "Jun-Oct"
          },
          "jun-sep": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "jjas": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "6,7,8,9": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "6 7 8 9": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "summer (june to september)": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "growing season/jjas": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "june": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "september": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "summer (jjas)": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "((( warm season (june-sept) ))) jjas /// jjas": {
             "id": "http://linked.earth/ontology/interpretation#Jun-Sep",
             "label": "Jun-Sep"
          },
          "mar": {
             "id": "http://linked.earth/ontology/interpretation#Mar",
             "label": "Mar"
          },
          "mar-apr": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Apr",
             "label": "Mar-Apr"
          },
          "mar-aug": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Aug",
             "label": "Mar-Aug"
          },
          "3 4 5 6 7 8": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Aug",
             "label": "Mar-Aug"
          },
          "3,4,5,6,7,8": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Aug",
             "label": "Mar-Aug"
          },
          "mar-dec": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Dec",
             "label": "Mar-Dec"
          },
          "mar-jan": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Jan",
             "label": "Mar-Jan"
          },
          "mar-jul": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Jul",
             "label": "Mar-Jul"
          },
          "mar-jun": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Jun",
             "label": "Mar-Jun"
          },
          "mar-may": {
             "id": "http://linked.earth/ontology/interpretation#Mar-May",
             "label": "Mar-May"
          },
          "3 4 2005": {
             "id": "http://linked.earth/ontology/interpretation#Mar-May",
             "label": "Mar-May"
          },
          "mam": {
             "id": "http://linked.earth/ontology/interpretation#Mar-May",
             "label": "Mar-May"
          },
          "mar-nov": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Nov",
             "label": "Mar-Nov"
          },
          "march to november": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Nov",
             "label": "Mar-Nov"
          },
          "mar-oct": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Oct",
             "label": "Mar-Oct"
          },
          "3 4 5 6 7 8 9 10 11 12 13 14": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Oct",
             "label": "Mar-Oct"
          },
          "3 4 5 6 7 8 9 10": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Oct",
             "label": "Mar-Oct"
          },
          "mar-sep": {
             "id": "http://linked.earth/ontology/interpretation#Mar-Sep",
             "label": "Mar-Sep"
          },
          "may": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "5": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "may-apr": {
             "id": "http://linked.earth/ontology/interpretation#May-Apr",
             "label": "May-Apr"
          },
          "-5 -6 -7 -8 -9 -10 -11 -12 1 2 3 4": {
             "id": "http://linked.earth/ontology/interpretation#May-Apr",
             "label": "May-Apr"
          },
          "may-aug": {
             "id": "http://linked.earth/ontology/interpretation#May-Aug",
             "label": "May-Aug"
          },
          "mjja": {
             "id": "http://linked.earth/ontology/interpretation#May-Aug",
             "label": "May-Aug"
          },
          "5,6,7,8": {
             "id": "http://linked.earth/ontology/interpretation#May-Aug",
             "label": "May-Aug"
          },
          "may-dec": {
             "id": "http://linked.earth/ontology/interpretation#May-Dec",
             "label": "May-Dec"
          },
          "october": {
             "id": "http://linked.earth/ontology/interpretation#May-Oct",
             "label": "May-Oct"
          },
          "november": {
             "id": "http://linked.earth/ontology/interpretation#May-Dec",
             "label": "May-Dec"
          },
          "december": {
             "id": "http://linked.earth/ontology/interpretation#May-Dec",
             "label": "May-Dec"
          },
          "mjjasond": {
             "id": "http://linked.earth/ontology/interpretation#May-Dec",
             "label": "May-Dec"
          },
          "5 6 7 8 9 10 11 12": {
             "id": "http://linked.earth/ontology/interpretation#May-Dec",
             "label": "May-Dec"
          },
          "may-feb": {
             "id": "http://linked.earth/ontology/interpretation#May-Feb",
             "label": "May-Feb"
          },
          "may-jan": {
             "id": "http://linked.earth/ontology/interpretation#May-Jan",
             "label": "May-Jan"
          },
          "may-jul": {
             "id": "http://linked.earth/ontology/interpretation#May-Jul",
             "label": "May-Jul"
          },
          "5 6 2007": {
             "id": "http://linked.earth/ontology/interpretation#May-Jul",
             "label": "May-Jul"
          },
          "may-jun": {
             "id": "http://linked.earth/ontology/interpretation#May-Jun",
             "label": "May-Jun"
          },
          "mj": {
             "id": "http://linked.earth/ontology/interpretation#May-Jun",
             "label": "May-Jun"
          },
          "may-mar": {
             "id": "http://linked.earth/ontology/interpretation#May-Mar",
             "label": "May-Mar"
          },
          "may-nov": {
             "id": "http://linked.earth/ontology/interpretation#May-Nov",
             "label": "May-Nov"
          },
          "may-oct": {
             "id": "http://linked.earth/ontology/interpretation#May-Oct",
             "label": "May-Oct"
          },
          "mjjaso": {
             "id": "http://linked.earth/ontology/interpretation#May-Oct",
             "label": "May-Oct"
          },
          "5,6,7,8,9,10": {
             "id": "http://linked.earth/ontology/interpretation#May-Oct",
             "label": "May-Oct"
          },
          "may to october": {
             "id": "http://linked.earth/ontology/interpretation#May-Oct",
             "label": "May-Oct"
          },
          "may-sep": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "mjjas": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "may to sept": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "5,6,7,8,9": {
             "id": "http://linked.earth/ontology/interpretation#May-Sep",
             "label": "May-Sep"
          },
          "needstobechanged": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "upwelling": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "unknown": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "n/a": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "1,10": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "1,11": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "changes depending on which season provides source moisture for plants": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "depends": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "inflow@surface": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "not indicated": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "under present conditions": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wet years often have higehr amount of winter rain": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "but d18o may reflect high summer rain": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "winter rain": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "or both": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "upwelling season": {
             "id": "http://linked.earth/ontology/interpretation#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "nov-apr": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Apr",
             "label": "Nov-Apr"
          },
          "11,12,1,2,3,4": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Apr",
             "label": "Nov-Apr"
          },
          "winter (nov-april)": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Apr",
             "label": "Nov-Apr"
          },
          "-11 -12 1 2 3 4": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Apr",
             "label": "Nov-Apr"
          },
          "ndjfma": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Apr",
             "label": "Nov-Apr"
          },
          "nov-aug": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Aug",
             "label": "Nov-Aug"
          },
          "nov-dec": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Dec",
             "label": "Nov-Dec"
          },
          "nov-feb": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Feb",
             "label": "Nov-Feb"
          },
          "-11 -12 1 2": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Feb",
             "label": "Nov-Feb"
          },
          "11,12,1,2": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Feb",
             "label": "Nov-Feb"
          },
          "ndjf": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Feb",
             "label": "Nov-Feb"
          },
          "november (previous year) to february (current year)": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Feb",
             "label": "Nov-Feb"
          },
          "nov-jan": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Jan",
             "label": "Nov-Jan"
          },
          "summer (ndj)": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Jan",
             "label": "Nov-Jan"
          },
          "nov-jul": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Jul",
             "label": "Nov-Jul"
          },
          "nov-jun": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Jun",
             "label": "Nov-Jun"
          },
          "11,12,1,2,3,4,5,6": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Jun",
             "label": "Nov-Jun"
          },
          "nov-mar": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Mar",
             "label": "Nov-Mar"
          },
          "11,12,1,2,3": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Mar",
             "label": "Nov-Mar"
          },
          "nov-may": {
             "id": "http://linked.earth/ontology/interpretation#Nov-May",
             "label": "Nov-May"
          },
          "11,12,1,2,3,4,5": {
             "id": "http://linked.earth/ontology/interpretation#Nov-May",
             "label": "Nov-May"
          },
          "winter (11,12,1,2,3,4,5)": {
             "id": "http://linked.earth/ontology/interpretation#Nov-May",
             "label": "Nov-May"
          },
          "nov-oct": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Oct",
             "label": "Nov-Oct"
          },
          "-12 -11 1 2 3 4 5 6 7 8 9 10": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Oct",
             "label": "Nov-Oct"
          },
          "nov-sep": {
             "id": "http://linked.earth/ontology/interpretation#Nov-Sep",
             "label": "Nov-Sep"
          },
          "oct-apr": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Apr",
             "label": "Oct-Apr"
          },
          "10,11,12,1,2,3,4": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Apr",
             "label": "Oct-Apr"
          },
          "-10 -11 -12 1 2 3 4": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Apr",
             "label": "Oct-Apr"
          },
          "october-april (wet season)": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Apr",
             "label": "Oct-Apr"
          },
          "ondjfma": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Apr",
             "label": "Oct-Apr"
          },
          "oct-aug": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Aug",
             "label": "Oct-Aug"
          },
          "oct-dec": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Dec",
             "label": "Oct-Dec"
          },
          "ond": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Dec",
             "label": "Oct-Dec"
          },
          "oct-feb": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Feb",
             "label": "Oct-Feb"
          },
          "oct-jan": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Jan",
             "label": "Oct-Jan"
          },
          "10,11,12,1": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Jan",
             "label": "Oct-Jan"
          },
          "ondj": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Jan",
             "label": "Oct-Jan"
          },
          "oct-jul": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Jul",
             "label": "Oct-Jul"
          },
          "oct-jun": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Jun",
             "label": "Oct-Jun"
          },
          "oct-mar": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Mar",
             "label": "Oct-Mar"
          },
          "ondjfm": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Mar",
             "label": "Oct-Mar"
          },
          "10,11,12,1,2,3": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Mar",
             "label": "Oct-Mar"
          },
          "oct-may": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "10": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "11": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "12": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "3": {
             "id": "http://linked.earth/ontology/interpretation#Oct-May",
             "label": "Oct-May"
          },
          "oct-nov": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Nov",
             "label": "Oct-Nov"
          },
          "oct-sep": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Sep",
             "label": "Oct-Sep"
          },
          "oct (previous year) to sept (current year)": {
             "id": "http://linked.earth/ontology/interpretation#Oct-Sep",
             "label": "Oct-Sep"
          },
          "sep-apr": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Apr",
             "label": "Sep-Apr"
          },
          "-9 -10 -11 -12 1 2 3 4": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Apr",
             "label": "Sep-Apr"
          },
          "sep-aug": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Aug",
             "label": "Sep-Aug"
          },
          "-12 -11 -10 -9 1 2 3 4 5 6 7 8": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Aug",
             "label": "Sep-Aug"
          },
          "sep-dec": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Dec",
             "label": "Sep-Dec"
          },
          "sep-feb": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Feb",
             "label": "Sep-Feb"
          },
          "-9 -10 -11 -12 1 2 2": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Feb",
             "label": "Sep-Feb"
          },
          "sondjf": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Feb",
             "label": "Sep-Feb"
          },
          "sep-jan": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Jan",
             "label": "Sep-Jan"
          },
          "sep-jul": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Jul",
             "label": "Sep-Jul"
          },
          "sep-jun": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Jun",
             "label": "Sep-Jun"
          },
          "sep-mar": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Mar",
             "label": "Sep-Mar"
          },
          "sep-may": {
             "id": "http://linked.earth/ontology/interpretation#Sep-May",
             "label": "Sep-May"
          },
          "sep-nov": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Nov",
             "label": "Sep-Nov"
          },
          "9 10 11": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Nov",
             "label": "Sep-Nov"
          },
          "sep-oct": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Oct",
             "label": "Sep-Oct"
          },
          "9 10": {
             "id": "http://linked.earth/ontology/interpretation#Sep-Oct",
             "label": "Sep-Oct"
          },
          "spr-sum": {
             "id": "http://linked.earth/ontology/interpretation#Spr-Sum",
             "label": "Spr-Sum"
          },
          "variable": {
             "id": "http://linked.earth/ontology/interpretation#Spr-Sum",
             "label": "Spr-Sum"
          },
          "probably spring/summer": {
             "id": "http://linked.earth/ontology/interpretation#Spr-Sum",
             "label": "Spr-Sum"
          },
          "spring summer": {
             "id": "http://linked.earth/ontology/interpretation#Spr-Sum",
             "label": "Spr-Sum"
          },
          "spring-summer": {
             "id": "http://linked.earth/ontology/interpretation#Spr-Sum",
             "label": "Spr-Sum"
          },
          "spring": {
             "id": "http://linked.earth/ontology/interpretation#Spring",
             "label": "Spring"
          },
          "subannual": {
             "id": "http://linked.earth/ontology/interpretation#subannual",
             "label": "subannual"
          },
          "n/a (subannually resolved)": {
             "id": "http://linked.earth/ontology/interpretation#subannual",
             "label": "subannual"
          },
          "not applicable (subannually resolved)": {
             "id": "http://linked.earth/ontology/interpretation#subannual",
             "label": "subannual"
          },
          "summer": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "warm season": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "mostly summer": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "summer+": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "summer-bias": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "ice-free season": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "nh summer": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "((( summeronly ))) summeronly /// null": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "am&ja": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "austral summer (oct-jan)": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "early summer": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "mean summer": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "p_amount (june)": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "temperature (july": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "aug)": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "temperature (may": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "oct)": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "summer?": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "t_air (july": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "august)": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "p_amount (july)": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "warmest quarter yr": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "mar&jul": {
             "id": "http://linked.earth/ontology/interpretation#Summer",
             "label": "Summer"
          },
          "warmest month": {
             "id": "http://linked.earth/ontology/interpretation#Warmest_Month",
             "label": "Warmest Month"
          },
          "warmest_month": {
             "id": "http://linked.earth/ontology/interpretation#Warmest_Month",
             "label": "Warmest Month"
          },
          "231pa excess": {
             "id": "http://linked.earth/ontology/interpretation#Warmest_Month",
             "label": "Warmest Month"
          },
          "warmest": {
             "id": "http://linked.earth/ontology/interpretation#Warmest_Month",
             "label": "Warmest Month"
          },
          "wet season": {
             "id": "http://linked.earth/ontology/interpretation#Wet_Season",
             "label": "Wet Season"
          },
          "wet_season": {
             "id": "http://linked.earth/ontology/interpretation#Wet_Season",
             "label": "Wet Season"
          },
          "monsoon": {
             "id": "http://linked.earth/ontology/interpretation#Wet_Season",
             "label": "Wet Season"
          },
          "andean wet season": {
             "id": "http://linked.earth/ontology/interpretation#Wet_Season",
             "label": "Wet Season"
          },
          "monsoon season": {
             "id": "http://linked.earth/ontology/interpretation#Wet_Season",
             "label": "Wet Season"
          },
          "win-spr": {
             "id": "http://linked.earth/ontology/interpretation#Win-Spr",
             "label": "Win-Spr"
          },
          "winter/spring": {
             "id": "http://linked.earth/ontology/interpretation#Win-Spr",
             "label": "Win-Spr"
          },
          "winter+": {
             "id": "http://linked.earth/ontology/interpretation#Winter",
             "label": "Winter"
          },
          "mostly winter": {
             "id": "http://linked.earth/ontology/interpretation#Winter",
             "label": "Winter"
          }
       }
    },
    "PROXIES": {
       "PaleoProxy": {
          "accumulation rate": {
             "id": "http://linked.earth/ontology/paleo_proxy#accumulation_rate",
             "label": "accumulation rate"
          },
          "accumulation_rate": {
             "id": "http://linked.earth/ontology/paleo_proxy#accumulation_rate",
             "label": "accumulation rate"
          },
          "sed accumulation": {
             "id": "http://linked.earth/ontology/paleo_proxy#accumulation_rate",
             "label": "accumulation rate"
          },
          "acl": {
             "id": "http://linked.earth/ontology/paleo_proxy#ACL",
             "label": "ACL"
          },
          "average chain length": {
             "id": "http://linked.earth/ontology/paleo_proxy#ACL",
             "label": "ACL"
          },
          "al2o3": {
             "id": "http://linked.earth/ontology/paleo_proxy#Al2O3",
             "label": "Al2O3"
          },
          "aluminum oxide": {
             "id": "http://linked.earth/ontology/paleo_proxy#Al2O3",
             "label": "Al2O3"
          },
          "alkenone": {
             "id": "http://linked.earth/ontology/paleo_proxy#alkenone",
             "label": "alkenone"
          },
          "amoeba": {
             "id": "http://linked.earth/ontology/paleo_proxy#amoeba",
             "label": "amoeba"
          },
          "testate amoeba": {
             "id": "http://linked.earth/ontology/paleo_proxy#amoeba",
             "label": "amoeba"
          },
          "ba/al": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Al",
             "label": "Ba/Al"
          },
          "ba_al": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Al",
             "label": "Ba/Al"
          },
          "barium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Al",
             "label": "Ba/Al"
          },
          "ba/ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Ca",
             "label": "Ba/Ca"
          },
          "ba_ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Ca",
             "label": "Ba/Ca"
          },
          "barium/calcium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Ca",
             "label": "Ba/Ca"
          },
          "baca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ba_Ca",
             "label": "Ba/Ca"
          },
          "biomarker": {
             "id": "http://linked.earth/ontology/paleo_proxy#biomarker",
             "label": "biomarker"
          },
          "organic compound": {
             "id": "http://linked.earth/ontology/paleo_proxy#biomarker",
             "label": "biomarker"
          },
          "c15 fatty alcohols": {
             "id": "http://linked.earth/ontology/paleo_proxy#biomarker",
             "label": "biomarker"
          },
          "c37.concentration": {
             "id": "http://linked.earth/ontology/paleo_proxy#biomarker",
             "label": "biomarker"
          },
          "bit": {
             "id": "http://linked.earth/ontology/paleo_proxy#BIT",
             "label": "BIT"
          },
          "branched and isoprenoid tetraether index": {
             "id": "http://linked.earth/ontology/paleo_proxy#BIT",
             "label": "BIT"
          },
          "bitindex": {
             "id": "http://linked.earth/ontology/paleo_proxy#BIT",
             "label": "BIT"
          },
          "borehole": {
             "id": "http://linked.earth/ontology/paleo_proxy#borehole",
             "label": "borehole"
          },
          "bsi": {
             "id": "http://linked.earth/ontology/paleo_proxy#BSi",
             "label": "BSi"
          },
          "biogenic silica": {
             "id": "http://linked.earth/ontology/paleo_proxy#BSi",
             "label": "BSi"
          },
          "bubble frequency": {
             "id": "http://linked.earth/ontology/paleo_proxy#bubble_frequency",
             "label": "bubble frequency"
          },
          "bubble_frequency": {
             "id": "http://linked.earth/ontology/paleo_proxy#bubble_frequency",
             "label": "bubble frequency"
          },
          "bulk density": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_density",
             "label": "bulk density"
          },
          "bulk_density": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_density",
             "label": "bulk density"
          },
          "gamma": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_density",
             "label": "bulk density"
          },
          "bulk sediment": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_sediment",
             "label": "bulk sediment"
          },
          "bulk_sediment": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_sediment",
             "label": "bulk sediment"
          },
          "dry sediment": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_sediment",
             "label": "bulk sediment"
          },
          "bulksed": {
             "id": "http://linked.earth/ontology/paleo_proxy#bulk_sediment",
             "label": "bulk sediment"
          },
          "c/n": {
             "id": "http://linked.earth/ontology/paleo_proxy#C_N",
             "label": "C/N"
          },
          "c_n": {
             "id": "http://linked.earth/ontology/paleo_proxy#C_N",
             "label": "C/N"
          },
          "carbon/nitrogen": {
             "id": "http://linked.earth/ontology/paleo_proxy#C_N",
             "label": "C/N"
          },
          "ca/k": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ca_K",
             "label": "Ca/K"
          },
          "ca_k": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ca_K",
             "label": "Ca/K"
          },
          "calcium/potassium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ca_K",
             "label": "Ca/K"
          },
          "ca/ti": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ca_Ti",
             "label": "Ca/Ti"
          },
          "ca_ti": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ca_Ti",
             "label": "Ca/Ti"
          },
          "calcium/titanium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ca_Ti",
             "label": "Ca/Ti"
          },
          "caco3": {
             "id": "http://linked.earth/ontology/paleo_proxy#CaCO3",
             "label": "CaCO3"
          },
          "calcium carbonate": {
             "id": "http://linked.earth/ontology/paleo_proxy#CaCO3",
             "label": "CaCO3"
          },
          "calcification rate": {
             "id": "http://linked.earth/ontology/paleo_proxy#calcification_rate",
             "label": "calcification rate"
          },
          "calcification_rate": {
             "id": "http://linked.earth/ontology/paleo_proxy#calcification_rate",
             "label": "calcification rate"
          },
          "calcification": {
             "id": "http://linked.earth/ontology/paleo_proxy#calcification_rate",
             "label": "calcification rate"
          },
          "calcite": {
             "id": "http://linked.earth/ontology/paleo_proxy#calcite",
             "label": "calcite"
          },
          "carbonate": {
             "id": "http://linked.earth/ontology/paleo_proxy#carbonate",
             "label": "carbonate"
          },
          "authigenic carbonate": {
             "id": "http://linked.earth/ontology/paleo_proxy#carbonate",
             "label": "carbonate"
          },
          "carbonate content": {
             "id": "http://linked.earth/ontology/paleo_proxy#carbonate",
             "label": "carbonate"
          },
          "cellulose": {
             "id": "http://linked.earth/ontology/paleo_proxy#cellulose",
             "label": "cellulose"
          },
          "charcoal": {
             "id": "http://linked.earth/ontology/paleo_proxy#charcoal",
             "label": "charcoal"
          },
          "chironomid": {
             "id": "http://linked.earth/ontology/paleo_proxy#chironomid",
             "label": "chironomid"
          },
          "midge": {
             "id": "http://linked.earth/ontology/paleo_proxy#chironomid",
             "label": "chironomid"
          },
          "chlorophyll": {
             "id": "http://linked.earth/ontology/paleo_proxy#chlorophyll",
             "label": "chlorophyll"
          },
          "chrysophyte assemblage": {
             "id": "http://linked.earth/ontology/paleo_proxy#chrysophyte_assemblage",
             "label": "chrysophyte assemblage"
          },
          "chrysophyte_assemblage": {
             "id": "http://linked.earth/ontology/paleo_proxy#chrysophyte_assemblage",
             "label": "chrysophyte assemblage"
          },
          "chrysophyte": {
             "id": "http://linked.earth/ontology/paleo_proxy#chrysophyte_assemblage",
             "label": "chrysophyte assemblage"
          },
          "cladoceran": {
             "id": "http://linked.earth/ontology/paleo_proxy#cladoceran",
             "label": "cladoceran"
          },
          "cladocera": {
             "id": "http://linked.earth/ontology/paleo_proxy#cladoceran",
             "label": "cladoceran"
          },
          "coccolithophore": {
             "id": "http://linked.earth/ontology/paleo_proxy#coccolithophore",
             "label": "coccolithophore"
          },
          "coccolith": {
             "id": "http://linked.earth/ontology/paleo_proxy#coccolithophore",
             "label": "coccolithophore"
          },
          "d13c": {
             "id": "http://linked.earth/ontology/paleo_proxy#d13C",
             "label": "d13C"
          },
          "delta 13c": {
             "id": "http://linked.earth/ontology/paleo_proxy#d13C",
             "label": "d13C"
          },
          "d13cwax": {
             "id": "http://linked.earth/ontology/paleo_proxy#d13C",
             "label": "d13C"
          },
          "d15n": {
             "id": "http://linked.earth/ontology/paleo_proxy#d15N",
             "label": "d15N"
          },
          "delta 15n": {
             "id": "http://linked.earth/ontology/paleo_proxy#d15N",
             "label": "d15N"
          },
          "d15n/d40ar": {
             "id": "http://linked.earth/ontology/paleo_proxy#d15N_d40Ar",
             "label": "d15N/d40Ar"
          },
          "d15n_d40ar": {
             "id": "http://linked.earth/ontology/paleo_proxy#d15N_d40Ar",
             "label": "d15N/d40Ar"
          },
          "15n/40ar fractionation": {
             "id": "http://linked.earth/ontology/paleo_proxy#d15N_d40Ar",
             "label": "d15N/d40Ar"
          },
          "d15nd40ar": {
             "id": "http://linked.earth/ontology/paleo_proxy#d15N_d40Ar",
             "label": "d15N/d40Ar"
          },
          "d18o": {
             "id": "http://linked.earth/ontology/paleo_proxy#d18O",
             "label": "d18O"
          },
          "delta 18o": {
             "id": "http://linked.earth/ontology/paleo_proxy#d18O",
             "label": "d18O"
          },
          "cellulose d18o": {
             "id": "http://linked.earth/ontology/paleo_proxy#d18O",
             "label": "d18O"
          },
          "delta18o": {
             "id": "http://linked.earth/ontology/paleo_proxy#d18O",
             "label": "d18O"
          },
          "foram d18o": {
             "id": "http://linked.earth/ontology/paleo_proxy#d18O",
             "label": "d18O"
          },
          "dd": {
             "id": "http://linked.earth/ontology/paleo_proxy#dD",
             "label": "dD"
          },
          "delta 2h": {
             "id": "http://linked.earth/ontology/paleo_proxy#dD",
             "label": "dD"
          },
          "d2h": {
             "id": "http://linked.earth/ontology/paleo_proxy#dD",
             "label": "dD"
          },
          "ddwax": {
             "id": "http://linked.earth/ontology/paleo_proxy#dD",
             "label": "dD"
          },
          "leaf wax": {
             "id": "http://linked.earth/ontology/paleo_proxy#dD",
             "label": "dD"
          },
          "leafwax": {
             "id": "http://linked.earth/ontology/paleo_proxy#dD",
             "label": "dD"
          },
          "deuterium excess": {
             "id": "http://linked.earth/ontology/paleo_proxy#deuterium_excess",
             "label": "deuterium excess"
          },
          "deuterium_excess": {
             "id": "http://linked.earth/ontology/paleo_proxy#deuterium_excess",
             "label": "deuterium excess"
          },
          "deterium excess": {
             "id": "http://linked.earth/ontology/paleo_proxy#deuterium_excess",
             "label": "deuterium excess"
          },
          "dx": {
             "id": "http://linked.earth/ontology/paleo_proxy#deuterium_excess",
             "label": "deuterium excess"
          },
          "diatom": {
             "id": "http://linked.earth/ontology/paleo_proxy#diatom",
             "label": "diatom"
          },
          "dinocyst": {
             "id": "http://linked.earth/ontology/paleo_proxy#dinocyst",
             "label": "dinocyst"
          },
          "dinoflagellate": {
             "id": "http://linked.earth/ontology/paleo_proxy#dinocyst",
             "label": "dinocyst"
          },
          "dynocist mat": {
             "id": "http://linked.earth/ontology/paleo_proxy#dinocyst",
             "label": "dinocyst"
          },
          "dry bulk density": {
             "id": "http://linked.earth/ontology/paleo_proxy#dry_bulk_density",
             "label": "dry bulk density"
          },
          "dry_bulk_density": {
             "id": "http://linked.earth/ontology/paleo_proxy#dry_bulk_density",
             "label": "dry bulk density"
          },
          "dbd": {
             "id": "http://linked.earth/ontology/paleo_proxy#dry_bulk_density",
             "label": "dry bulk density"
          },
          "eu/zr": {
             "id": "http://linked.earth/ontology/paleo_proxy#Eu_Zr",
             "label": "Eu/Zr"
          },
          "eu_zr": {
             "id": "http://linked.earth/ontology/paleo_proxy#Eu_Zr",
             "label": "Eu/Zr"
          },
          "fe": {
             "id": "http://linked.earth/ontology/paleo_proxy#Fe",
             "label": "Fe"
          },
          "iron": {
             "id": "http://linked.earth/ontology/paleo_proxy#Fe",
             "label": "Fe"
          },
          "fe/al": {
             "id": "http://linked.earth/ontology/paleo_proxy#Fe_Al",
             "label": "Fe/Al"
          },
          "fe_al": {
             "id": "http://linked.earth/ontology/paleo_proxy#Fe_Al",
             "label": "Fe/Al"
          },
          "iron/aluminum": {
             "id": "http://linked.earth/ontology/paleo_proxy#Fe_Al",
             "label": "Fe/Al"
          },
          "foraminifera": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "foraminifer": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "benthic foraminifers": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "n. dutertrei": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "planktonic foraminifera": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "transfer function": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "uvigerina mediterranea": {
             "id": "http://linked.earth/ontology/paleo_proxy#foraminifera",
             "label": "foraminifera"
          },
          "gdgt": {
             "id": "http://linked.earth/ontology/paleo_proxy#GDGT",
             "label": "GDGT"
          },
          "glycerol dialkyl glycerol tetraether": {
             "id": "http://linked.earth/ontology/paleo_proxy#GDGT",
             "label": "GDGT"
          },
          "brgdgt": {
             "id": "http://linked.earth/ontology/paleo_proxy#GDGT",
             "label": "GDGT"
          },
          "grain size": {
             "id": "http://linked.earth/ontology/paleo_proxy#grain_size",
             "label": "grain size"
          },
          "grain_size": {
             "id": "http://linked.earth/ontology/paleo_proxy#grain_size",
             "label": "grain size"
          },
          "particle size": {
             "id": "http://linked.earth/ontology/paleo_proxy#grain_size",
             "label": "grain size"
          },
          "hbi": {
             "id": "http://linked.earth/ontology/paleo_proxy#HBI",
             "label": "HBI"
          },
          "highly-branched isoprenoid alkene": {
             "id": "http://linked.earth/ontology/paleo_proxy#HBI",
             "label": "HBI"
          },
          "historical": {
             "id": "http://linked.earth/ontology/paleo_proxy#historical",
             "label": "historical"
          },
          "documentary": {
             "id": "http://linked.earth/ontology/paleo_proxy#historical",
             "label": "historical"
          },
          "historic": {
             "id": "http://linked.earth/ontology/paleo_proxy#historical",
             "label": "historical"
          },
          "humification": {
             "id": "http://linked.earth/ontology/paleo_proxy#humification",
             "label": "humification"
          },
          "humification index": {
             "id": "http://linked.earth/ontology/paleo_proxy#humification",
             "label": "humification"
          },
          "ice accumulation": {
             "id": "http://linked.earth/ontology/paleo_proxy#ice_accumulation",
             "label": "ice accumulation"
          },
          "ice_accumulation": {
             "id": "http://linked.earth/ontology/paleo_proxy#ice_accumulation",
             "label": "ice accumulation"
          },
          "ice melt": {
             "id": "http://linked.earth/ontology/paleo_proxy#ice_melt",
             "label": "ice melt"
          },
          "ice_melt": {
             "id": "http://linked.earth/ontology/paleo_proxy#ice_melt",
             "label": "ice melt"
          },
          "melt": {
             "id": "http://linked.earth/ontology/paleo_proxy#ice_melt",
             "label": "ice melt"
          },
          "melt layer": {
             "id": "http://linked.earth/ontology/paleo_proxy#ice_melt",
             "label": "ice melt"
          },
          "inorganic carbon": {
             "id": "http://linked.earth/ontology/paleo_proxy#inorganic_carbon",
             "label": "inorganic carbon"
          },
          "inorganic_carbon": {
             "id": "http://linked.earth/ontology/paleo_proxy#inorganic_carbon",
             "label": "inorganic carbon"
          },
          "tic": {
             "id": "http://linked.earth/ontology/paleo_proxy#inorganic_carbon",
             "label": "inorganic carbon"
          },
          "ip25": {
             "id": "http://linked.earth/ontology/paleo_proxy#IP25",
             "label": "IP25"
          },
          "ice proxy with 25 carbon atoms": {
             "id": "http://linked.earth/ontology/paleo_proxy#IP25",
             "label": "IP25"
          },
          "lake level": {
             "id": "http://linked.earth/ontology/paleo_proxy#lake_level",
             "label": "lake level"
          },
          "lake_level": {
             "id": "http://linked.earth/ontology/paleo_proxy#lake_level",
             "label": "lake level"
          },
          "lake stratigraphy and radiocarbon dating of macrofossils": {
             "id": "http://linked.earth/ontology/paleo_proxy#lake_level",
             "label": "lake level"
          },
          "lakelevel": {
             "id": "http://linked.earth/ontology/paleo_proxy#lake_level",
             "label": "lake level"
          },
          "lakestatus": {
             "id": "http://linked.earth/ontology/paleo_proxy#lake_level",
             "label": "lake level"
          },
          "latewood cellulose": {
             "id": "http://linked.earth/ontology/paleo_proxy#latewood_cellulose",
             "label": "latewood cellulose"
          },
          "latewood_cellulose": {
             "id": "http://linked.earth/ontology/paleo_proxy#latewood_cellulose",
             "label": "latewood cellulose"
          },
          "late-wood cellulose": {
             "id": "http://linked.earth/ontology/paleo_proxy#latewood_cellulose",
             "label": "latewood cellulose"
          },
          "ldi": {
             "id": "http://linked.earth/ontology/paleo_proxy#LDI",
             "label": "LDI"
          },
          "long-chain diol index": {
             "id": "http://linked.earth/ontology/paleo_proxy#LDI",
             "label": "LDI"
          },
          "long chain diol": {
             "id": "http://linked.earth/ontology/paleo_proxy#LDI",
             "label": "LDI"
          },
          "macrofossils": {
             "id": "http://linked.earth/ontology/paleo_proxy#macrofossils",
             "label": "macrofossils"
          },
          "plant macrofossils": {
             "id": "http://linked.earth/ontology/paleo_proxy#macrofossils",
             "label": "macrofossils"
          },
          "magnetic": {
             "id": "http://linked.earth/ontology/paleo_proxy#magnetic",
             "label": "magnetic"
          },
          "arm/irm": {
             "id": "http://linked.earth/ontology/paleo_proxy#magnetic",
             "label": "magnetic"
          },
          "irm": {
             "id": "http://linked.earth/ontology/paleo_proxy#magnetic",
             "label": "magnetic"
          },
          "magnetic susceptibility": {
             "id": "http://linked.earth/ontology/paleo_proxy#magnetic_susceptibility",
             "label": "magnetic susceptibility"
          },
          "magnetic_susceptibility": {
             "id": "http://linked.earth/ontology/paleo_proxy#magnetic_susceptibility",
             "label": "magnetic susceptibility"
          },
          "ms": {
             "id": "http://linked.earth/ontology/paleo_proxy#magnetic_susceptibility",
             "label": "magnetic susceptibility"
          },
          "mass accumulation rate": {
             "id": "http://linked.earth/ontology/paleo_proxy#mass_accumulation_rate",
             "label": "mass accumulation rate"
          },
          "mass_accumulation_rate": {
             "id": "http://linked.earth/ontology/paleo_proxy#mass_accumulation_rate",
             "label": "mass accumulation rate"
          },
          "mass per area per time unit": {
             "id": "http://linked.earth/ontology/paleo_proxy#mass_accumulation_rate",
             "label": "mass accumulation rate"
          },
          "mar": {
             "id": "http://linked.earth/ontology/paleo_proxy#mass_accumulation_rate",
             "label": "mass accumulation rate"
          },
          "maximum latewood density": {
             "id": "http://linked.earth/ontology/paleo_proxy#maximum_latewood_density",
             "label": "maximum latewood density"
          },
          "maximum_latewood_density": {
             "id": "http://linked.earth/ontology/paleo_proxy#maximum_latewood_density",
             "label": "maximum latewood density"
          },
          "latewood density": {
             "id": "http://linked.earth/ontology/paleo_proxy#maximum_latewood_density",
             "label": "maximum latewood density"
          },
          "delta density": {
             "id": "http://linked.earth/ontology/paleo_proxy#maximum_latewood_density",
             "label": "maximum latewood density"
          },
          "mxd": {
             "id": "http://linked.earth/ontology/paleo_proxy#maximum_latewood_density",
             "label": "maximum latewood density"
          },
          "mg": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg",
             "label": "Mg"
          },
          "magnesium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg",
             "label": "Mg"
          },
          "mg/ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mg_ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg_Ca",
             "label": "Mg/Ca"
          },
          "magnesium/calcium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg_Ca",
             "label": "Mg/Ca"
          },
          "foram mg/ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Mg_Ca",
             "label": "Mg/Ca"
          },
          "multiproxy": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "multiple proxies": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "hybrid": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "hybrid grain size": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "hybrid-ice": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "hybrid-lake": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "pore ice d2h and d18o": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "ti": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti",
             "label": "Ti"
          },
          "ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "k": {
             "id": "http://linked.earth/ontology/paleo_proxy#multiproxy",
             "label": "multiproxy"
          },
          "needs to be changed": {
             "id": "http://linked.earth/ontology/paleo_proxy#needs_to_be_changed",
             "label": "needs to be changed"
          },
          "needs_to_be_changed": {
             "id": "http://linked.earth/ontology/paleo_proxy#needs_to_be_changed",
             "label": "needs to be changed"
          },
          "pca": {
             "id": "http://linked.earth/ontology/paleo_proxy#needs_to_be_changed",
             "label": "needs to be changed"
          },
          "needstobechanged": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "((( calcium carbonate ))) accumulation /// null": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "3-oh-fatty acids": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "age": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cas": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cia": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "coral": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "element": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "element ratio": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ice": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "isotope": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "isotope diffusion": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mg0": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "middle-wood cellulose": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mineral": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mineralogy": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "percent": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "sediment": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "tds": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "trace element / ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "traceelement": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "u cluster 2": {
             "id": "http://linked.earth/ontology/paleo_proxy#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ostracod": {
             "id": "http://linked.earth/ontology/paleo_proxy#ostracod",
             "label": "ostracod"
          },
          "p-aqueous": {
             "id": "http://linked.earth/ontology/paleo_proxy#P-aqueous",
             "label": "P-aqueous"
          },
          "paq": {
             "id": "http://linked.earth/ontology/paleo_proxy#P-aqueous",
             "label": "P-aqueous"
          },
          "peat ash": {
             "id": "http://linked.earth/ontology/paleo_proxy#peat_ash",
             "label": "peat ash"
          },
          "peat_ash": {
             "id": "http://linked.earth/ontology/paleo_proxy#peat_ash",
             "label": "peat ash"
          },
          "ph": {
             "id": "http://linked.earth/ontology/paleo_proxy#pH",
             "label": "pH"
          },
          "pollen": {
             "id": "http://linked.earth/ontology/paleo_proxy#pollen",
             "label": "pollen"
          },
          "aquatic palynomorphs": {
             "id": "http://linked.earth/ontology/paleo_proxy#pollen",
             "label": "pollen"
          },
          "radiolaria": {
             "id": "http://linked.earth/ontology/paleo_proxy#radiolaria",
             "label": "radiolaria"
          },
          "radiolarian": {
             "id": "http://linked.earth/ontology/paleo_proxy#radiolaria",
             "label": "radiolaria"
          },
          "rb": {
             "id": "http://linked.earth/ontology/paleo_proxy#Rb",
             "label": "Rb"
          },
          "rubidium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Rb",
             "label": "Rb"
          },
          "rb/sr": {
             "id": "http://linked.earth/ontology/paleo_proxy#Rb_Sr",
             "label": "Rb/Sr"
          },
          "rb_sr": {
             "id": "http://linked.earth/ontology/paleo_proxy#Rb_Sr",
             "label": "Rb/Sr"
          },
          "reflectance": {
             "id": "http://linked.earth/ontology/paleo_proxy#reflectance",
             "label": "reflectance"
          },
          "ring width": {
             "id": "http://linked.earth/ontology/paleo_proxy#ring_width",
             "label": "ring width"
          },
          "ring_width": {
             "id": "http://linked.earth/ontology/paleo_proxy#ring_width",
             "label": "ring width"
          },
          "trw": {
             "id": "http://linked.earth/ontology/paleo_proxy#ring_width",
             "label": "ring width"
          },
          "sr": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr",
             "label": "Sr"
          },
          "strontium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr",
             "label": "Sr"
          },
          "sr/ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr_Ca",
             "label": "Sr/Ca"
          },
          "sr_ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr_Ca",
             "label": "Sr/Ca"
          },
          "strontium/calcium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr_Ca",
             "label": "Sr/Ca"
          },
          "ca/sr": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr_Ca",
             "label": "Sr/Ca"
          },
          "coral sr/ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr_Ca",
             "label": "Sr/Ca"
          },
          "srca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Sr_Ca",
             "label": "Sr/Ca"
          },
          "stratigraphy": {
             "id": "http://linked.earth/ontology/paleo_proxy#stratigraphy",
             "label": "stratigraphy"
          },
          "minerogenic layers": {
             "id": "http://linked.earth/ontology/paleo_proxy#stratigraphy",
             "label": "stratigraphy"
          },
          "plant detrital layers": {
             "id": "http://linked.earth/ontology/paleo_proxy#stratigraphy",
             "label": "stratigraphy"
          },
          "sulfur": {
             "id": "http://linked.earth/ontology/paleo_proxy#sulfur",
             "label": "sulfur"
          },
          "s": {
             "id": "http://linked.earth/ontology/paleo_proxy#sulfur",
             "label": "sulfur"
          },
          "tex86": {
             "id": "http://linked.earth/ontology/paleo_proxy#TEX86",
             "label": "TEX86"
          },
          "tetraether index of 86 carbon atoms": {
             "id": "http://linked.earth/ontology/paleo_proxy#TEX86",
             "label": "TEX86"
          },
          "titanium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti",
             "label": "Ti"
          },
          "ti/al": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Al",
             "label": "Ti/Al"
          },
          "ti_al": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Al",
             "label": "Ti/Al"
          },
          "titanium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Al",
             "label": "Ti/Al"
          },
          "ti/ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Ca",
             "label": "Ti/Ca"
          },
          "ti_ca": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Ca",
             "label": "Ti/Ca"
          },
          "titanium/calcium": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Ca",
             "label": "Ti/Ca"
          },
          "ln(ti/ca)": {
             "id": "http://linked.earth/ontology/paleo_proxy#Ti_Ca",
             "label": "Ti/Ca"
          },
          "toc": {
             "id": "http://linked.earth/ontology/paleo_proxy#TOC",
             "label": "TOC"
          },
          "organic carbon": {
             "id": "http://linked.earth/ontology/paleo_proxy#TOC",
             "label": "TOC"
          },
          "total nitrogen": {
             "id": "http://linked.earth/ontology/paleo_proxy#total_nitrogen",
             "label": "total nitrogen"
          },
          "total_nitrogen": {
             "id": "http://linked.earth/ontology/paleo_proxy#total_nitrogen",
             "label": "total nitrogen"
          },
          "tn": {
             "id": "http://linked.earth/ontology/paleo_proxy#total_nitrogen",
             "label": "total nitrogen"
          },
          "varve thickness": {
             "id": "http://linked.earth/ontology/paleo_proxy#varve_thickness",
             "label": "varve thickness"
          },
          "varve_thickness": {
             "id": "http://linked.earth/ontology/paleo_proxy#varve_thickness",
             "label": "varve thickness"
          },
          "varve": {
             "id": "http://linked.earth/ontology/paleo_proxy#varve_thickness",
             "label": "varve thickness"
          },
          "varve property": {
             "id": "http://linked.earth/ontology/paleo_proxy#varve_thickness",
             "label": "varve thickness"
          },
          "varves": {
             "id": "http://linked.earth/ontology/paleo_proxy#varve_thickness",
             "label": "varve thickness"
          }
       },
       "PaleoProxyGeneral": {
          "biogenic": {
             "id": "http://linked.earth/ontology/paleo_proxy#biogenic",
             "label": "biogenic"
          },
          "biological material": {
             "id": "http://linked.earth/ontology/paleo_proxy#biogenic",
             "label": "biogenic"
          },
          "cryophysical": {
             "id": "http://linked.earth/ontology/paleo_proxy#cryophysical",
             "label": "cryophysical"
          },
          "dendrophysical": {
             "id": "http://linked.earth/ontology/paleo_proxy#dendrophysical",
             "label": "dendrophysical"
          },
          "elemental": {
             "id": "http://linked.earth/ontology/paleo_proxy#elemental",
             "label": "elemental"
          },
          "faunal assemblage": {
             "id": "http://linked.earth/ontology/paleo_proxy#faunal_assemblage",
             "label": "faunal assemblage"
          },
          "faunal_assemblage": {
             "id": "http://linked.earth/ontology/paleo_proxy#faunal_assemblage",
             "label": "faunal assemblage"
          },
          "floral assemblage": {
             "id": "http://linked.earth/ontology/paleo_proxy#floral_assemblage",
             "label": "floral assemblage"
          },
          "floral_assemblage": {
             "id": "http://linked.earth/ontology/paleo_proxy#floral_assemblage",
             "label": "floral assemblage"
          },
          "isotopic": {
             "id": "http://linked.earth/ontology/paleo_proxy#isotopic",
             "label": "isotopic"
          },
          "isotope": {
             "id": "http://linked.earth/ontology/paleo_proxy#isotopic",
             "label": "isotopic"
          },
          "mineral": {
             "id": "http://linked.earth/ontology/paleo_proxy#mineral",
             "label": "mineral"
          },
          "pyrogenic": {
             "id": "http://linked.earth/ontology/paleo_proxy#pyrogenic",
             "label": "pyrogenic"
          },
          "fire history": {
             "id": "http://linked.earth/ontology/paleo_proxy#pyrogenic",
             "label": "pyrogenic"
          },
          "sedimentology": {
             "id": "http://linked.earth/ontology/paleo_proxy#sedimentology",
             "label": "sedimentology"
          }
       }
    },
    "UNITS": {
       "PaleoUnit": {
          "atomic ratio": {
             "id": "http://linked.earth/ontology/paleo_units#atomic_ratio",
             "label": "atomic ratio"
          },
          "atomic_ratio": {
             "id": "http://linked.earth/ontology/paleo_units#atomic_ratio",
             "label": "atomic ratio"
          },
          "cgs": {
             "id": "http://linked.earth/ontology/paleo_units#cgs",
             "label": "cgs"
          },
          "dimensionless (cgs system)": {
             "id": "http://linked.earth/ontology/paleo_units#cgs",
             "label": "cgs"
          },
          "cm": {
             "id": "http://linked.earth/ontology/paleo_units#cm",
             "label": "cm"
          },
          "centimeter": {
             "id": "http://linked.earth/ontology/paleo_units#cm",
             "label": "cm"
          },
          "cmblf": {
             "id": "http://linked.earth/ontology/paleo_units#cm",
             "label": "cm"
          },
          "cm/kyr": {
             "id": "http://linked.earth/ontology/paleo_units#cm_kyr",
             "label": "cm/kyr"
          },
          "cm_kyr": {
             "id": "http://linked.earth/ontology/paleo_units#cm_kyr",
             "label": "cm/kyr"
          },
          "centimeter per kiloyear": {
             "id": "http://linked.earth/ontology/paleo_units#cm_kyr",
             "label": "cm/kyr"
          },
          "cm/yr": {
             "id": "http://linked.earth/ontology/paleo_units#cm_yr",
             "label": "cm/yr"
          },
          "cm_yr": {
             "id": "http://linked.earth/ontology/paleo_units#cm_yr",
             "label": "cm/yr"
          },
          "centimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#cm_yr",
             "label": "cm/yr"
          },
          "cm/a": {
             "id": "http://linked.earth/ontology/paleo_units#cm_yr",
             "label": "cm/yr"
          },
          "cm yr-1": {
             "id": "http://linked.earth/ontology/paleo_units#cm_yr",
             "label": "cm/yr"
          },
          "cm3": {
             "id": "http://linked.earth/ontology/paleo_units#cm3",
             "label": "cm3"
          },
          "cubic centimeter": {
             "id": "http://linked.earth/ontology/paleo_units#cm3",
             "label": "cm3"
          },
          "count": {
             "id": "http://linked.earth/ontology/paleo_units#count",
             "label": "count"
          },
          "number": {
             "id": "http://linked.earth/ontology/paleo_units#count",
             "label": "count"
          },
          "#": {
             "id": "http://linked.earth/ontology/paleo_units#count",
             "label": "count"
          },
          "counts": {
             "id": "http://linked.earth/ontology/paleo_units#count",
             "label": "count"
          },
          "dark_sum": {
             "id": "http://linked.earth/ontology/paleo_units#count",
             "label": "count"
          },
          "cts": {
             "id": "http://linked.earth/ontology/paleo_units#count",
             "label": "count"
          },
          "count/century": {
             "id": "http://linked.earth/ontology/paleo_units#count_century",
             "label": "count/century"
          },
          "count_century": {
             "id": "http://linked.earth/ontology/paleo_units#count_century",
             "label": "count/century"
          },
          "count per century": {
             "id": "http://linked.earth/ontology/paleo_units#count_century",
             "label": "count/century"
          },
          "envents/100yrs": {
             "id": "http://linked.earth/ontology/paleo_units#count_century",
             "label": "count/century"
          },
          "count/cm2": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2",
             "label": "count/cm2"
          },
          "count_cm2": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2",
             "label": "count/cm2"
          },
          "count per square centimeter": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2",
             "label": "count/cm2"
          },
          "number/cm2": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2",
             "label": "count/cm2"
          },
          "count/cm2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2_yr",
             "label": "count/cm2/yr"
          },
          "count_cm2_yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2_yr",
             "label": "count/cm2/yr"
          },
          "count per square centimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2_yr",
             "label": "count/cm2/yr"
          },
          "grains>255 micron/cm2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2_yr",
             "label": "count/cm2/yr"
          },
          "no/cm2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm2_yr",
             "label": "count/cm2/yr"
          },
          "count/cm3": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm3",
             "label": "count/cm3"
          },
          "count_cm3": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm3",
             "label": "count/cm3"
          },
          "count per cubic centimeter": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm3",
             "label": "count/cm3"
          },
          "bubbles/cm3": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm3",
             "label": "count/cm3"
          },
          "#/cm3": {
             "id": "http://linked.earth/ontology/paleo_units#count_cm3",
             "label": "count/cm3"
          },
          "count/g": {
             "id": "http://linked.earth/ontology/paleo_units#count_g",
             "label": "count/g"
          },
          "count_g": {
             "id": "http://linked.earth/ontology/paleo_units#count_g",
             "label": "count/g"
          },
          "count per gram": {
             "id": "http://linked.earth/ontology/paleo_units#count_g",
             "label": "count/g"
          },
          "grains/g": {
             "id": "http://linked.earth/ontology/paleo_units#count_g",
             "label": "count/g"
          },
          "millions of valves/g dry sed": {
             "id": "http://linked.earth/ontology/paleo_units#count_g",
             "label": "count/g"
          },
          "count/kyr": {
             "id": "http://linked.earth/ontology/paleo_units#count_kyr",
             "label": "count/kyr"
          },
          "count_kyr": {
             "id": "http://linked.earth/ontology/paleo_units#count_kyr",
             "label": "count/kyr"
          },
          "count per kiloyear": {
             "id": "http://linked.earth/ontology/paleo_units#count_kyr",
             "label": "count/kyr"
          },
          "frequency/1000yrs": {
             "id": "http://linked.earth/ontology/paleo_units#count_kyr",
             "label": "count/kyr"
          },
          "count/ml": {
             "id": "http://linked.earth/ontology/paleo_units#count_mL",
             "label": "count/mL"
          },
          "count_ml": {
             "id": "http://linked.earth/ontology/paleo_units#count_mL",
             "label": "count/mL"
          },
          "count per milliliter": {
             "id": "http://linked.earth/ontology/paleo_units#count_mL",
             "label": "count/mL"
          },
          "count/yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_yr",
             "label": "count/yr"
          },
          "count_yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_yr",
             "label": "count/yr"
          },
          "count per year": {
             "id": "http://linked.earth/ontology/paleo_units#count_yr",
             "label": "count/yr"
          },
          "floods per year": {
             "id": "http://linked.earth/ontology/paleo_units#count_yr",
             "label": "count/yr"
          },
          "floods per yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_yr",
             "label": "count/yr"
          },
          "floods/yr": {
             "id": "http://linked.earth/ontology/paleo_units#count_yr",
             "label": "count/yr"
          },
          "cps": {
             "id": "http://linked.earth/ontology/paleo_units#cps",
             "label": "cps"
          },
          "count per second": {
             "id": "http://linked.earth/ontology/paleo_units#cps",
             "label": "cps"
          },
          "day": {
             "id": "http://linked.earth/ontology/paleo_units#day",
             "label": "day"
          },
          "days": {
             "id": "http://linked.earth/ontology/paleo_units#day",
             "label": "day"
          },
          "degc": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "degree celsius": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "gdd5": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "((( null ))) deg c /// degc": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "degrees": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "\u00bac": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "deg": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "gdd": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "kelvin": {
             "id": "http://linked.earth/ontology/paleo_units#degC",
             "label": "degC"
          },
          "degree": {
             "id": "http://linked.earth/ontology/paleo_units#degree",
             "label": "degree"
          },
          "decimal degrees": {
             "id": "http://linked.earth/ontology/paleo_units#degree",
             "label": "degree"
          },
          "fraction": {
             "id": "http://linked.earth/ontology/paleo_units#fraction",
             "label": "fraction"
          },
          "fractional abundance": {
             "id": "http://linked.earth/ontology/paleo_units#fraction",
             "label": "fraction"
          },
          "fraction 0 to 1": {
             "id": "http://linked.earth/ontology/paleo_units#fraction",
             "label": "fraction"
          },
          "relative abundance": {
             "id": "http://linked.earth/ontology/paleo_units#fraction",
             "label": "fraction"
          },
          "g": {
             "id": "http://linked.earth/ontology/paleo_units#g",
             "label": "g"
          },
          "gram": {
             "id": "http://linked.earth/ontology/paleo_units#g",
             "label": "g"
          },
          "g/cm/yr": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm_yr",
             "label": "g/cm/yr"
          },
          "g_cm_yr": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm_yr",
             "label": "g/cm/yr"
          },
          "gram per centimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm_yr",
             "label": "g/cm/yr"
          },
          "g/cm2": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2",
             "label": "g/cm2"
          },
          "g_cm2": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2",
             "label": "g/cm2"
          },
          "gram per square centimeter": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2",
             "label": "g/cm2"
          },
          "gcm2": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2",
             "label": "g/cm2"
          },
          "g cm-1": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2",
             "label": "g/cm2"
          },
          "g/cm2/kyr": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_kyr",
             "label": "g/cm2/kyr"
          },
          "g_cm2_kyr": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_kyr",
             "label": "g/cm2/kyr"
          },
          "gram per square centimeter per kiloyear": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_kyr",
             "label": "g/cm2/kyr"
          },
          "g/cm2/ka": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_kyr",
             "label": "g/cm2/kyr"
          },
          "g/cm2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "g_cm2_yr": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "gram per square centimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "g/m^2/a": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "gcm-2yr-1": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "g.cm-2.a-1": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "g/cm^2/y": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "gcm-2a-1": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm2_yr",
             "label": "g/cm2/yr"
          },
          "g/cm3": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm3",
             "label": "g/cm3"
          },
          "g_cm3": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm3",
             "label": "g/cm3"
          },
          "gram per cubic centimeter": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm3",
             "label": "g/cm3"
          },
          "g/cc": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm3",
             "label": "g/cm3"
          },
          "grams/cubic cm": {
             "id": "http://linked.earth/ontology/paleo_units#g_cm3",
             "label": "g/cm3"
          },
          "g/l": {
             "id": "http://linked.earth/ontology/paleo_units#g_L",
             "label": "g/L"
          },
          "g_l": {
             "id": "http://linked.earth/ontology/paleo_units#g_L",
             "label": "g/L"
          },
          "gram per liter": {
             "id": "http://linked.earth/ontology/paleo_units#g_L",
             "label": "g/L"
          },
          "g/m2": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2",
             "label": "g/m2"
          },
          "g_m2": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2",
             "label": "g/m2"
          },
          "gram per square meter": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2",
             "label": "g/m2"
          },
          "g/m": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2",
             "label": "g/m2"
          },
          "g/m2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2_yr",
             "label": "g/m2/yr"
          },
          "g_m2_yr": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2_yr",
             "label": "g/m2/yr"
          },
          "gram per square meter per year": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2_yr",
             "label": "g/m2/yr"
          },
          "gm2yr-1": {
             "id": "http://linked.earth/ontology/paleo_units#g_m2_yr",
             "label": "g/m2/yr"
          },
          "grayscale": {
             "id": "http://linked.earth/ontology/paleo_units#grayscale",
             "label": "grayscale"
          },
          "kg/m2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#kg_m2_yr",
             "label": "kg/m2/yr"
          },
          "kg_m2_yr": {
             "id": "http://linked.earth/ontology/paleo_units#kg_m2_yr",
             "label": "kg/m2/yr"
          },
          "kilogram per square meter per year": {
             "id": "http://linked.earth/ontology/paleo_units#kg_m2_yr",
             "label": "kg/m2/yr"
          },
          "kg/m3": {
             "id": "http://linked.earth/ontology/paleo_units#kg_m3",
             "label": "kg/m3"
          },
          "kg_m3": {
             "id": "http://linked.earth/ontology/paleo_units#kg_m3",
             "label": "kg/m3"
          },
          "kilogram per square meter": {
             "id": "http://linked.earth/ontology/paleo_units#kg_m3",
             "label": "kg/m3"
          },
          "km2": {
             "id": "http://linked.earth/ontology/paleo_units#km2",
             "label": "km2"
          },
          "square kilometer": {
             "id": "http://linked.earth/ontology/paleo_units#km2",
             "label": "km2"
          },
          "km3": {
             "id": "http://linked.earth/ontology/paleo_units#km3",
             "label": "km3"
          },
          "cubic kilometer": {
             "id": "http://linked.earth/ontology/paleo_units#km3",
             "label": "km3"
          },
          "log(mg/l)": {
             "id": "http://linked.earth/ontology/paleo_units#log_mg_L_",
             "label": "log(mg/L)"
          },
          "log_mg_l_": {
             "id": "http://linked.earth/ontology/paleo_units#log_mg_L_",
             "label": "log(mg/L)"
          },
          "log mg/l": {
             "id": "http://linked.earth/ontology/paleo_units#log_mg_L_",
             "label": "log(mg/L)"
          },
          "m": {
             "id": "http://linked.earth/ontology/paleo_units#m",
             "label": "m"
          },
          "meter": {
             "id": "http://linked.earth/ontology/paleo_units#m",
             "label": "m"
          },
          "m3/kg": {
             "id": "http://linked.earth/ontology/paleo_units#m3_kg",
             "label": "m3/kg"
          },
          "m3_kg": {
             "id": "http://linked.earth/ontology/paleo_units#m3_kg",
             "label": "m3/kg"
          },
          "cubic meter per kilogram": {
             "id": "http://linked.earth/ontology/paleo_units#m3_kg",
             "label": "m3/kg"
          },
          "m^3 kg^-1": {
             "id": "http://linked.earth/ontology/paleo_units#m3_kg",
             "label": "m3/kg"
          },
          "m3kg-1": {
             "id": "http://linked.earth/ontology/paleo_units#m3_kg",
             "label": "m3/kg"
          },
          "m3kg1": {
             "id": "http://linked.earth/ontology/paleo_units#m3_kg",
             "label": "m3/kg"
          },
          "mg": {
             "id": "http://linked.earth/ontology/paleo_units#mg",
             "label": "mg"
          },
          "milligram": {
             "id": "http://linked.earth/ontology/paleo_units#mg",
             "label": "mg"
          },
          "mg/cm2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#mg_cm2_yr",
             "label": "mg/cm2/yr"
          },
          "mg_cm2_yr": {
             "id": "http://linked.earth/ontology/paleo_units#mg_cm2_yr",
             "label": "mg/cm2/yr"
          },
          "milligram per square centimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#mg_cm2_yr",
             "label": "mg/cm2/yr"
          },
          "mg/g": {
             "id": "http://linked.earth/ontology/paleo_units#mg_g",
             "label": "mg/g"
          },
          "mg_g": {
             "id": "http://linked.earth/ontology/paleo_units#mg_g",
             "label": "mg/g"
          },
          "milligram per gram": {
             "id": "http://linked.earth/ontology/paleo_units#mg_g",
             "label": "mg/g"
          },
          "mg g-1": {
             "id": "http://linked.earth/ontology/paleo_units#mg_g",
             "label": "mg/g"
          },
          "mill/g": {
             "id": "http://linked.earth/ontology/paleo_units#mg_g",
             "label": "mg/g"
          },
          "mg/kg": {
             "id": "http://linked.earth/ontology/paleo_units#mg_kg",
             "label": "mg/kg"
          },
          "mg_kg": {
             "id": "http://linked.earth/ontology/paleo_units#mg_kg",
             "label": "mg/kg"
          },
          "milligram per kilogram": {
             "id": "http://linked.earth/ontology/paleo_units#mg_kg",
             "label": "mg/kg"
          },
          "mg/l": {
             "id": "http://linked.earth/ontology/paleo_units#mg_L",
             "label": "mg/L"
          },
          "mg_l": {
             "id": "http://linked.earth/ontology/paleo_units#mg_L",
             "label": "mg/L"
          },
          "milligram per liter": {
             "id": "http://linked.earth/ontology/paleo_units#mg_L",
             "label": "mg/L"
          },
          "mm": {
             "id": "http://linked.earth/ontology/paleo_units#mm",
             "label": "mm"
          },
          "millimeter": {
             "id": "http://linked.earth/ontology/paleo_units#mm",
             "label": "mm"
          },
          "depth_sample": {
             "id": "http://linked.earth/ontology/paleo_units#mm",
             "label": "mm"
          },
          "mm/day": {
             "id": "http://linked.earth/ontology/paleo_units#mm_day",
             "label": "mm/day"
          },
          "mm_day": {
             "id": "http://linked.earth/ontology/paleo_units#mm_day",
             "label": "mm/day"
          },
          "millimeter per day": {
             "id": "http://linked.earth/ontology/paleo_units#mm_day",
             "label": "mm/day"
          },
          "mm/season": {
             "id": "http://linked.earth/ontology/paleo_units#mm_season",
             "label": "mm/season"
          },
          "mm_season": {
             "id": "http://linked.earth/ontology/paleo_units#mm_season",
             "label": "mm/season"
          },
          "mm/yr": {
             "id": "http://linked.earth/ontology/paleo_units#mm_yr",
             "label": "mm/yr"
          },
          "mm_yr": {
             "id": "http://linked.earth/ontology/paleo_units#mm_yr",
             "label": "mm/yr"
          },
          "millimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#mm_yr",
             "label": "mm/yr"
          },
          "mm/a": {
             "id": "http://linked.earth/ontology/paleo_units#mm_yr",
             "label": "mm/yr"
          },
          "((( null ))) mm /// mm/a": {
             "id": "http://linked.earth/ontology/paleo_units#mm_yr",
             "label": "mm/yr"
          },
          "mmol/mol": {
             "id": "http://linked.earth/ontology/paleo_units#mmol_mol",
             "label": "mmol/mol"
          },
          "mmol_mol": {
             "id": "http://linked.earth/ontology/paleo_units#mmol_mol",
             "label": "mmol/mol"
          },
          "millimole per mole": {
             "id": "http://linked.earth/ontology/paleo_units#mmol_mol",
             "label": "mmol/mol"
          },
          "months/year": {
             "id": "http://linked.earth/ontology/paleo_units#months_year",
             "label": "months/year"
          },
          "months_year": {
             "id": "http://linked.earth/ontology/paleo_units#months_year",
             "label": "months/year"
          },
          "needstobechanged": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "1s": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "a\u20ac\u00b0": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "floods per 30 years": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "floods per 30 yrs (200 yr running average)": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hu": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "layers/200yrs": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "[\u00b1]": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "0.5s": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "1 sigma": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "10-5": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "10^-9 am2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "1sigma": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "a\u0080\u00b0": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "afae\u2019a\u2020a\u20ac\u2122afa\u00a2a\u00a2a\u20acsa\u00aca\u2026a\u00a1afae\u2019a\u00a2a\u201a\u00aca\u00a1afa\u20acsa\u201aaug/g": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "unknown": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mcm": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mwe": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "1041 m3/kg": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "am2kg-1": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "area": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "aug/cm2/ka": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "gomcm2yr-1": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "sum": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "total": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cm2yr-1": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "square mm/cubic cm": {
             "id": "http://linked.earth/ontology/paleo_units#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ng": {
             "id": "http://linked.earth/ontology/paleo_units#ng",
             "label": "ng"
          },
          "nanogram": {
             "id": "http://linked.earth/ontology/paleo_units#ng",
             "label": "ng"
          },
          "ng/sample": {
             "id": "http://linked.earth/ontology/paleo_units#ng",
             "label": "ng"
          },
          "ng/g": {
             "id": "http://linked.earth/ontology/paleo_units#ng_g",
             "label": "ng/g"
          },
          "ng_g": {
             "id": "http://linked.earth/ontology/paleo_units#ng_g",
             "label": "ng/g"
          },
          "nanogram per gram": {
             "id": "http://linked.earth/ontology/paleo_units#ng_g",
             "label": "ng/g"
          },
          "ng/g sed": {
             "id": "http://linked.earth/ontology/paleo_units#ng_g",
             "label": "ng/g"
          },
          "peak area": {
             "id": "http://linked.earth/ontology/paleo_units#peak_area",
             "label": "peak area"
          },
          "peak_area": {
             "id": "http://linked.earth/ontology/paleo_units#peak_area",
             "label": "peak area"
          },
          "peak area integral": {
             "id": "http://linked.earth/ontology/paleo_units#peak_area",
             "label": "peak area"
          },
          "pa/kcps": {
             "id": "http://linked.earth/ontology/paleo_units#peak_area",
             "label": "peak area"
          },
          "percent": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "%": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "((( null ))) % /// percent": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "wt %": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "% abs": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "mol%": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "mole per mole * 100": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "percentbyweight": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "precent": {
             "id": "http://linked.earth/ontology/paleo_units#percent",
             "label": "percent"
          },
          "permil": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "((( null ))) per mil /// permil": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil vs pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "((( null ))) per mil /// unitless": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil (vpdb)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil vs vpdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil (vsmow)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil (pdb)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vs pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil (pdb)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil (smow)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil smow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vsmow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil (vpdb)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vpdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vs vpdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vpdb 1sig": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "\u2030 pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil vsmow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "((( null ))) permil /// unitless": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "+/- permil pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "+/- permil smow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "\u00b1 permil": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "per mil vsmow 1sig": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "((( null ))) permil /// per mil": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "\u2030 smow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "1000*counts/counts": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "d18o": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "pemil": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil (pbd)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil (smow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "not pdb!)": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil v pdb": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vmow": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permil vsmow 1sig": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "permit": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "perml": {
             "id": "http://linked.earth/ontology/paleo_units#permil",
             "label": "permil"
          },
          "ph": {
             "id": "http://linked.earth/ontology/paleo_units#pH",
             "label": "pH"
          },
          "acidity": {
             "id": "http://linked.earth/ontology/paleo_units#pH",
             "label": "pH"
          },
          "ppb": {
             "id": "http://linked.earth/ontology/paleo_units#ppb",
             "label": "ppb"
          },
          "parts per billion": {
             "id": "http://linked.earth/ontology/paleo_units#ppb",
             "label": "ppb"
          },
          "ppm": {
             "id": "http://linked.earth/ontology/paleo_units#ppm",
             "label": "ppm"
          },
          "parts per million": {
             "id": "http://linked.earth/ontology/paleo_units#ppm",
             "label": "ppm"
          },
          "practical salinity unit": {
             "id": "http://linked.earth/ontology/paleo_units#practical_salinity_unit",
             "label": "practical salinity unit"
          },
          "practical_salinity_unit": {
             "id": "http://linked.earth/ontology/paleo_units#practical_salinity_unit",
             "label": "practical salinity unit"
          },
          "psu": {
             "id": "http://linked.earth/ontology/paleo_units#practical_salinity_unit",
             "label": "practical salinity unit"
          },
          "ratio": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "relative unit": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "ratio cps": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "g/g": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "(mg/kg)/(mg/kg)": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "cps/cps": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "grams/dry weight": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "sediment 130um": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "((( null ))) ratio /// unitless": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "mm/m": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "mol_mol": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "mol/mol": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "r660_670": {
             "id": "http://linked.earth/ontology/paleo_units#ratio",
             "label": "ratio"
          },
          "si": {
             "id": "http://linked.earth/ontology/paleo_units#SI",
             "label": "SI"
          },
          "dimensionless (si system)": {
             "id": "http://linked.earth/ontology/paleo_units#SI",
             "label": "SI"
          },
          "10^-6si": {
             "id": "http://linked.earth/ontology/paleo_units#SI",
             "label": "SI"
          },
          "dimensionless (si)": {
             "id": "http://linked.earth/ontology/paleo_units#SI",
             "label": "SI"
          },
          "si 10^-5": {
             "id": "http://linked.earth/ontology/paleo_units#SI",
             "label": "SI"
          },
          "ug/cm2/yr": {
             "id": "http://linked.earth/ontology/paleo_units#ug_cm2_yr",
             "label": "ug/cm2/yr"
          },
          "ug_cm2_yr": {
             "id": "http://linked.earth/ontology/paleo_units#ug_cm2_yr",
             "label": "ug/cm2/yr"
          },
          "microgram per square centimeter per year": {
             "id": "http://linked.earth/ontology/paleo_units#ug_cm2_yr",
             "label": "ug/cm2/yr"
          },
          "ugcm-2yr-1": {
             "id": "http://linked.earth/ontology/paleo_units#ug_cm2_yr",
             "label": "ug/cm2/yr"
          },
          "ug/g": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "ug_g": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "microgram per gram": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "ug/g dry sediment": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "ug/g dry sed": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "ug g-1 dw": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "microg_g": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "[ug/g]": {
             "id": "http://linked.earth/ontology/paleo_units#ug_g",
             "label": "ug/g"
          },
          "um": {
             "id": "http://linked.earth/ontology/paleo_units#um",
             "label": "um"
          },
          "micrometer": {
             "id": "http://linked.earth/ontology/paleo_units#um",
             "label": "um"
          },
          "umol/mol": {
             "id": "http://linked.earth/ontology/paleo_units#umol_mol",
             "label": "umol/mol"
          },
          "umol_mol": {
             "id": "http://linked.earth/ontology/paleo_units#umol_mol",
             "label": "umol/mol"
          },
          "micromole per mole": {
             "id": "http://linked.earth/ontology/paleo_units#umol_mol",
             "label": "umol/mol"
          },
          "unitless": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "dimensionless": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "unitless index": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "index": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "type": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "absorbance units": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "ftirs absorbance units": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "name": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "uk37": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "unitless (anomalies)": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "pc": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "standardized": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "0-10": {
             "id": "http://linked.earth/ontology/paleo_units#unitless",
             "label": "unitless"
          },
          "yr 14c bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "yr_14c_bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "radiocarbon year before present": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "radiocarbon years bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "14c yr bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "yr 14c yr bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "bp14c": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "c14yr bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_14C_BP",
             "label": "yr 14C BP"
          },
          "yr ad": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "yr_ad": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "year common era": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "yr": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "ce": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "ad": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "year ce": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "ad/bc": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "cal yr ad": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "year a.d.": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "year c.e.": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "yr ce": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "yrad/bc": {
             "id": "http://linked.earth/ontology/paleo_units#yr_AD",
             "label": "yr AD"
          },
          "yr b2k": {
             "id": "http://linked.earth/ontology/paleo_units#yr_b2k",
             "label": "yr b2k"
          },
          "yr_b2k": {
             "id": "http://linked.earth/ontology/paleo_units#yr_b2k",
             "label": "yr b2k"
          },
          "b2000": {
             "id": "http://linked.earth/ontology/paleo_units#yr_b2k",
             "label": "yr b2k"
          },
          "cal. bp2000": {
             "id": "http://linked.earth/ontology/paleo_units#yr_b2k",
             "label": "yr b2k"
          },
          "years before 2k": {
             "id": "http://linked.earth/ontology/paleo_units#yr_b2k",
             "label": "yr b2k"
          },
          "yr bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "yr_bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "calendar year before present": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal years bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal year bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal yr bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "year bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "years bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "yr b.p.": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "yrs bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal yr b.p.": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "age=1950-year": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal age bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "cal yrs bp": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "yr bo": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "yr p": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "calibrated": {
             "id": "http://linked.earth/ontology/paleo_units#yr_BP",
             "label": "yr BP"
          },
          "yr ka": {
             "id": "http://linked.earth/ontology/paleo_units#yr_ka",
             "label": "yr ka"
          },
          "yr_ka": {
             "id": "http://linked.earth/ontology/paleo_units#yr_ka",
             "label": "yr ka"
          },
          "calendar kiloyear before present": {
             "id": "http://linked.earth/ontology/paleo_units#yr_ka",
             "label": "yr ka"
          },
          "ka": {
             "id": "http://linked.earth/ontology/paleo_units#yr_ka",
             "label": "yr ka"
          },
          "z score": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          },
          "z_score": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          },
          "standard deviation unit": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          },
          "zscore": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          },
          "sd units": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          },
          "std dev": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          },
          "sd": {
             "id": "http://linked.earth/ontology/paleo_units#z_score",
             "label": "z score"
          }
       }
    },
    "VARIABLES": {
       "PaleoVariable": {
          "acl": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "average chain length": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "acl (27-33)": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "acl25-35": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "acl27-31": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "aclc22-30": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "averagechainlength20to30": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "averagechainlength20to32": {
             "id": "http://linked.earth/ontology/paleo_variables#ACL",
             "label": "ACL"
          },
          "aet/pet": {
             "id": "http://linked.earth/ontology/paleo_variables#AET_PET",
             "label": "AET/PET"
          },
          "aet_pet": {
             "id": "http://linked.earth/ontology/paleo_variables#AET_PET",
             "label": "AET/PET"
          },
          "arm/irm": {
             "id": "http://linked.earth/ontology/paleo_variables#ARM_IRM",
             "label": "ARM/IRM"
          },
          "arm_irm": {
             "id": "http://linked.earth/ontology/paleo_variables#ARM_IRM",
             "label": "ARM/IRM"
          },
          "anhysteretic remanent magnetization/isothermal remanent magnetization": {
             "id": "http://linked.earth/ontology/paleo_variables#ARM_IRM",
             "label": "ARM/IRM"
          },
          "arstan": {
             "id": "http://linked.earth/ontology/paleo_variables#ARSTAN",
             "label": "ARSTAN"
          },
          "arstan chronology method": {
             "id": "http://linked.earth/ontology/paleo_variables#ARSTAN",
             "label": "ARSTAN"
          },
          "ars": {
             "id": "http://linked.earth/ontology/paleo_variables#ARSTAN",
             "label": "ARSTAN"
          },
          "al": {
             "id": "http://linked.earth/ontology/paleo_variables#Al",
             "label": "Al"
          },
          "aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#Al",
             "label": "Al"
          },
          "al peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Al",
             "label": "Al"
          },
          "alprop": {
             "id": "http://linked.earth/ontology/paleo_variables#Al",
             "label": "Al"
          },
          "al2o3": {
             "id": "http://linked.earth/ontology/paleo_variables#Al2O3",
             "label": "Al2O3"
          },
          "aluminum oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#Al2O3",
             "label": "Al2O3"
          },
          "as": {
             "id": "http://linked.earth/ontology/paleo_variables#As",
             "label": "As"
          },
          "arsenic": {
             "id": "http://linked.earth/ontology/paleo_variables#As",
             "label": "As"
          },
          "ppm as": {
             "id": "http://linked.earth/ontology/paleo_variables#As",
             "label": "As"
          },
          "bit": {
             "id": "http://linked.earth/ontology/paleo_variables#BIT",
             "label": "BIT"
          },
          "branched and isoprenoid tetraether index": {
             "id": "http://linked.earth/ontology/paleo_variables#BIT",
             "label": "BIT"
          },
          "bitindex": {
             "id": "http://linked.earth/ontology/paleo_variables#BIT",
             "label": "BIT"
          },
          "bitindex-3pt": {
             "id": "http://linked.earth/ontology/paleo_variables#BIT",
             "label": "BIT"
          },
          "bsi": {
             "id": "http://linked.earth/ontology/paleo_variables#BSi",
             "label": "BSi"
          },
          "biogenic silica": {
             "id": "http://linked.earth/ontology/paleo_variables#BSi",
             "label": "BSi"
          },
          "biosi": {
             "id": "http://linked.earth/ontology/paleo_variables#BSi",
             "label": "BSi"
          },
          "bsi_3pt": {
             "id": "http://linked.earth/ontology/paleo_variables#BSi",
             "label": "BSi"
          },
          "bsi_raw": {
             "id": "http://linked.earth/ontology/paleo_variables#BSi",
             "label": "BSi"
          },
          "inferred bsi": {
             "id": "http://linked.earth/ontology/paleo_variables#BSi",
             "label": "BSi"
          },
          "ba": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba",
             "label": "Ba"
          },
          "barium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba",
             "label": "Ba"
          },
          "ba (ppm)": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba",
             "label": "Ba"
          },
          "ba peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba",
             "label": "Ba"
          },
          "ppm ba": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba",
             "label": "Ba"
          },
          "ba/al": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Al",
             "label": "Ba/Al"
          },
          "ba_al": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Al",
             "label": "Ba/Al"
          },
          "barium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Al",
             "label": "Ba/Al"
          },
          "ppmba/%al": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Al",
             "label": "Ba/Al"
          },
          "ba/ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Ca",
             "label": "Ba/Ca"
          },
          "ba_ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Ca",
             "label": "Ba/Ca"
          },
          "barium/calcium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Ca",
             "label": "Ba/Ca"
          },
          "baca": {
             "id": "http://linked.earth/ontology/paleo_variables#Ba_Ca",
             "label": "Ba/Ca"
          },
          "be": {
             "id": "http://linked.earth/ontology/paleo_variables#Be",
             "label": "Be"
          },
          "beryllium": {
             "id": "http://linked.earth/ontology/paleo_variables#Be",
             "label": "Be"
          },
          "ppm be": {
             "id": "http://linked.earth/ontology/paleo_variables#Be",
             "label": "Be"
          },
          "br": {
             "id": "http://linked.earth/ontology/paleo_variables#Br",
             "label": "Br"
          },
          "bromine": {
             "id": "http://linked.earth/ontology/paleo_variables#Br",
             "label": "Br"
          },
          "c20n-alkenoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20 sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c20n": {
             "id": "http://linked.earth/ontology/paleo_variables#C20n-alkenoicAcid",
             "label": "C20n-alkenoicAcid"
          },
          "c21n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C21n-alkanoicAcid",
             "label": "C21n-alkanoicAcid"
          },
          "c21 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C21n-alkanoicAcid",
             "label": "C21n-alkanoicAcid"
          },
          "c21 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C21n-alkanoicAcid",
             "label": "C21n-alkanoicAcid"
          },
          "c21 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C21n-alkanoicAcid",
             "label": "C21n-alkanoicAcid"
          },
          "c21fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C21n-alkanoicAcid",
             "label": "C21n-alkanoicAcid"
          },
          "c22n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22 sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c22n": {
             "id": "http://linked.earth/ontology/paleo_variables#C22n-alkanoicAcid",
             "label": "C22n-alkanoicAcid"
          },
          "c23n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c23 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c23 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c23 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c23 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c23c31": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c23fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C23n-alkanoicAcid",
             "label": "C23n-alkanoicAcid"
          },
          "c24n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24 sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c24n": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "n c24": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "nc24": {
             "id": "http://linked.earth/ontology/paleo_variables#C24n-alkanoicAcid",
             "label": "C24n-alkanoicAcid"
          },
          "c25_2n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C25_2n-alkanoicAcid",
             "label": "C25_2n-alkanoicAcid"
          },
          "c25:2 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C25_2n-alkanoicAcid",
             "label": "C25_2n-alkanoicAcid"
          },
          "c25n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C25n-alkanoicAcid",
             "label": "C25n-alkanoicAcid"
          },
          "c25 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C25n-alkanoicAcid",
             "label": "C25n-alkanoicAcid"
          },
          "c25 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C25n-alkanoicAcid",
             "label": "C25n-alkanoicAcid"
          },
          "c25 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C25n-alkanoicAcid",
             "label": "C25n-alkanoicAcid"
          },
          "c25 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C25n-alkanoicAcid",
             "label": "C25n-alkanoicAcid"
          },
          "c25fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C25n-alkanoicAcid",
             "label": "C25n-alkanoicAcid"
          },
          "c26n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26 sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26oh0x2f0x28c26oh0x2bc290x29": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c26n": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "n c26": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "nc26": {
             "id": "http://linked.earth/ontology/paleo_variables#C26n-alkanoicAcid",
             "label": "C26n-alkanoicAcid"
          },
          "c27n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C27n-alkanoicAcid",
             "label": "C27n-alkanoicAcid"
          },
          "c27 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C27n-alkanoicAcid",
             "label": "C27n-alkanoicAcid"
          },
          "c27 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C27n-alkanoicAcid",
             "label": "C27n-alkanoicAcid"
          },
          "c27 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C27n-alkanoicAcid",
             "label": "C27n-alkanoicAcid"
          },
          "c27 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C27n-alkanoicAcid",
             "label": "C27n-alkanoicAcid"
          },
          "c27fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C27n-alkanoicAcid",
             "label": "C27n-alkanoicAcid"
          },
          "c28n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28 sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c28n": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "n c28": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "n-c28": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "nc28": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "nc28_err": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "nc28_rep": {
             "id": "http://linked.earth/ontology/paleo_variables#C28n-alkanoicAcid",
             "label": "C28n-alkanoicAcid"
          },
          "c29n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C29n-alkanoicAcid",
             "label": "C29n-alkanoicAcid"
          },
          "c29 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C29n-alkanoicAcid",
             "label": "C29n-alkanoicAcid"
          },
          "c29 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C29n-alkanoicAcid",
             "label": "C29n-alkanoicAcid"
          },
          "c29 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C29n-alkanoicAcid",
             "label": "C29n-alkanoicAcid"
          },
          "c29 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C29n-alkanoicAcid",
             "label": "C29n-alkanoicAcid"
          },
          "c29fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C29n-alkanoicAcid",
             "label": "C29n-alkanoicAcid"
          },
          "c30n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30 fame concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30 sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30 n": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30sem": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c30n": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "nc30_rep": {
             "id": "http://linked.earth/ontology/paleo_variables#C30n-alkanoicAcid",
             "label": "C30n-alkanoicAcid"
          },
          "c31n-alkanoicacid": {
             "id": "http://linked.earth/ontology/paleo_variables#C31n-alkanoicAcid",
             "label": "C31n-alkanoicAcid"
          },
          "c31 n-alkanoic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#C31n-alkanoicAcid",
             "label": "C31n-alkanoicAcid"
          },
          "c31 concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C31n-alkanoicAcid",
             "label": "C31n-alkanoicAcid"
          },
          "c31fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C31n-alkanoicAcid",
             "label": "C31n-alkanoicAcid"
          },
          "c32fameconcentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C31n-alkanoicAcid",
             "label": "C31n-alkanoicAcid"
          },
          "c37alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37Alkenone",
             "label": "C37Alkenone"
          },
          "c37 alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37Alkenone",
             "label": "C37Alkenone"
          },
          "c37.concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#C37Alkenone",
             "label": "C37Alkenone"
          },
          "totalc37": {
             "id": "http://linked.earth/ontology/paleo_variables#C37Alkenone",
             "label": "C37Alkenone"
          },
          "c37:2alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_2Alkenone",
             "label": "C37:2Alkenone"
          },
          "c37_2alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_2Alkenone",
             "label": "C37:2Alkenone"
          },
          "c37:2 alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_2Alkenone",
             "label": "C37:2Alkenone"
          },
          "c37:2": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_2Alkenone",
             "label": "C37:2Alkenone"
          },
          "c37:3aalkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3aAlkenone",
             "label": "C37:3aAlkenone"
          },
          "c37_3aalkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3aAlkenone",
             "label": "C37:3aAlkenone"
          },
          "c37:3 alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3bAlkenone",
             "label": "C37:3bAlkenone"
          },
          "c37:3a": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3aAlkenone",
             "label": "C37:3aAlkenone"
          },
          "c37:3balkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3bAlkenone",
             "label": "C37:3bAlkenone"
          },
          "c37_3balkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3bAlkenone",
             "label": "C37:3bAlkenone"
          },
          "c37:3b": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_3bAlkenone",
             "label": "C37:3bAlkenone"
          },
          "c37:4alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_4Alkenone",
             "label": "C37:4Alkenone"
          },
          "c37_4alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_4Alkenone",
             "label": "C37:4Alkenone"
          },
          "c37:4 alkenone": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_4Alkenone",
             "label": "C37:4Alkenone"
          },
          "c34:4": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_4Alkenone",
             "label": "C37:4Alkenone"
          },
          "c370x3a4": {
             "id": "http://linked.earth/ontology/paleo_variables#C37_4Alkenone",
             "label": "C37:4Alkenone"
          },
          "cbt": {
             "id": "http://linked.earth/ontology/paleo_variables#CBT",
             "label": "CBT"
          },
          "cyclization index of branched tetraethers": {
             "id": "http://linked.earth/ontology/paleo_variables#CBT",
             "label": "CBT"
          },
          "cca1": {
             "id": "http://linked.earth/ontology/paleo_variables#CCA1",
             "label": "CCA1"
          },
          "multivariate eigenvector-based variable": {
             "id": "http://linked.earth/ontology/paleo_variables#CCA2",
             "label": "CCA2"
          },
          "caaxis1": {
             "id": "http://linked.earth/ontology/paleo_variables#CCA1",
             "label": "CCA1"
          },
          "cca2": {
             "id": "http://linked.earth/ontology/paleo_variables#CCA2",
             "label": "CCA2"
          },
          "caaxis2": {
             "id": "http://linked.earth/ontology/paleo_variables#CCA2",
             "label": "CCA2"
          },
          "cpi": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "carbon preference index": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "cpi (27-33)": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "cpi22-30": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "cpi_25-33": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "carbonpreferenceindex20to30": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "carbonpreferenceindex20to32": {
             "id": "http://linked.earth/ontology/paleo_variables#CPI",
             "label": "CPI"
          },
          "c/n": {
             "id": "http://linked.earth/ontology/paleo_variables#C_N",
             "label": "C/N"
          },
          "c_n": {
             "id": "http://linked.earth/ontology/paleo_variables#C_N",
             "label": "C/N"
          },
          "carbon/nitrogen": {
             "id": "http://linked.earth/ontology/paleo_variables#C_N",
             "label": "C/N"
          },
          "c/n organic": {
             "id": "http://linked.earth/ontology/paleo_variables#C_N",
             "label": "C/N"
          },
          "molarcn": {
             "id": "http://linked.earth/ontology/paleo_variables#C_N",
             "label": "C/N"
          },
          "ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "calcium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "% ca-detr": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "% ca-ex": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "ca peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "caprop": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "ca__": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca",
             "label": "Ca"
          },
          "caco3": {
             "id": "http://linked.earth/ontology/paleo_variables#CaCO3",
             "label": "CaCO3"
          },
          "calcium carbonate": {
             "id": "http://linked.earth/ontology/paleo_variables#CaCO3",
             "label": "CaCO3"
          },
          "% caco3-ex": {
             "id": "http://linked.earth/ontology/paleo_variables#CaCO3",
             "label": "CaCO3"
          },
          "caco3-ic": {
             "id": "http://linked.earth/ontology/paleo_variables#CaCO3",
             "label": "CaCO3"
          },
          "cao": {
             "id": "http://linked.earth/ontology/paleo_variables#CaO",
             "label": "CaO"
          },
          "calcium oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#CaO",
             "label": "CaO"
          },
          "ca/k": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_K",
             "label": "Ca/K"
          },
          "ca_k": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_K",
             "label": "Ca/K"
          },
          "calcium/potassium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_K",
             "label": "Ca/K"
          },
          "ca/sr": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Sr",
             "label": "Ca/Sr"
          },
          "ca_sr": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Sr",
             "label": "Ca/Sr"
          },
          "calcium/strontium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Sr",
             "label": "Ca/Sr"
          },
          "ca/ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Ti",
             "label": "Ca/Ti"
          },
          "ca_ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Ti",
             "label": "Ca/Ti"
          },
          "calcium/titanium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Ti",
             "label": "Ca/Ti"
          },
          "ca/ti-z": {
             "id": "http://linked.earth/ontology/paleo_variables#Ca_Ti",
             "label": "Ca/Ti"
          },
          "ti/ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Ca",
             "label": "Ti/Ca"
          },
          "cd": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd",
             "label": "Cd"
          },
          "cadmium": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd",
             "label": "Cd"
          },
          "cd mar (ug/cm2/ky)": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd",
             "label": "Cd"
          },
          "ppm cd": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd",
             "label": "Cd"
          },
          "cd/mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd_Mn",
             "label": "Cd/Mn"
          },
          "cd_mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd_Mn",
             "label": "Cd/Mn"
          },
          "ppm cd/% mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Cd_Mn",
             "label": "Cd/Mn"
          },
          "cl": {
             "id": "http://linked.earth/ontology/paleo_variables#Cl",
             "label": "Cl"
          },
          "chlorine": {
             "id": "http://linked.earth/ontology/paleo_variables#Cl",
             "label": "Cl"
          },
          "cl_": {
             "id": "http://linked.earth/ontology/paleo_variables#Cl",
             "label": "Cl"
          },
          "co": {
             "id": "http://linked.earth/ontology/paleo_variables#Co",
             "label": "Co"
          },
          "cobalt": {
             "id": "http://linked.earth/ontology/paleo_variables#Co",
             "label": "Co"
          },
          "ppm co": {
             "id": "http://linked.earth/ontology/paleo_variables#Co",
             "label": "Co"
          },
          "cr": {
             "id": "http://linked.earth/ontology/paleo_variables#Cr",
             "label": "Cr"
          },
          "chromium": {
             "id": "http://linked.earth/ontology/paleo_variables#Cr",
             "label": "Cr"
          },
          "ppm cr": {
             "id": "http://linked.earth/ontology/paleo_variables#Cr",
             "label": "Cr"
          },
          "cu": {
             "id": "http://linked.earth/ontology/paleo_variables#Cu",
             "label": "Cu"
          },
          "copper": {
             "id": "http://linked.earth/ontology/paleo_variables#Cu",
             "label": "Cu"
          },
          "ppm cu": {
             "id": "http://linked.earth/ontology/paleo_variables#Cu",
             "label": "Cu"
          },
          "dwhi": {
             "id": "http://linked.earth/ontology/paleo_variables#DWHI",
             "label": "DWHI"
          },
          "ecosystem index": {
             "id": "http://linked.earth/ontology/paleo_variables#DWHI",
             "label": "DWHI"
          },
          "dd2h": {
             "id": "http://linked.earth/ontology/paleo_variables#Dd2H",
             "label": "Dd2H"
          },
          "\u03b4\u03b4dterr-aq": {
             "id": "http://linked.earth/ontology/paleo_variables#Dd2H",
             "label": "Dd2H"
          },
          "eps": {
             "id": "http://linked.earth/ontology/paleo_variables#EPS",
             "label": "EPS"
          },
          "expressed population signal": {
             "id": "http://linked.earth/ontology/paleo_variables#EPS",
             "label": "EPS"
          },
          "elninoevent": {
             "id": "http://linked.earth/ontology/paleo_variables#ElNinoEvent",
             "label": "ElNinoEvent"
          },
          "el ni\u00f1o event": {
             "id": "http://linked.earth/ontology/paleo_variables#ElNinoEvent",
             "label": "ElNinoEvent"
          },
          "enso_events": {
             "id": "http://linked.earth/ontology/paleo_variables#ElNinoEvent",
             "label": "ElNinoEvent"
          },
          "eu/zr": {
             "id": "http://linked.earth/ontology/paleo_variables#Eu_Zr",
             "label": "Eu/Zr"
          },
          "eu_zr": {
             "id": "http://linked.earth/ontology/paleo_variables#Eu_Zr",
             "label": "Eu/Zr"
          },
          "eu/zr-z": {
             "id": "http://linked.earth/ontology/paleo_variables#Eu_Zr",
             "label": "Eu/Zr"
          },
          "fe": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe",
             "label": "Fe"
          },
          "iron": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe",
             "label": "Fe"
          },
          "fe peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe",
             "label": "Fe"
          },
          "feprop": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe",
             "label": "Fe"
          },
          "fe2o3": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe2O3",
             "label": "Fe2O3"
          },
          "iron(iii) oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe2O3",
             "label": "Fe2O3"
          },
          "fe/al": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Al",
             "label": "Fe/Al"
          },
          "fe_al": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Al",
             "label": "Fe/Al"
          },
          "iron/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Al",
             "label": "Fe/Al"
          },
          "fe/ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Ca",
             "label": "Fe/Ca"
          },
          "fe_ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Ca",
             "label": "Fe/Ca"
          },
          "iron/calcium": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Ca",
             "label": "Fe/Ca"
          },
          "ln(fe/ca)": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Ca",
             "label": "Fe/Ca"
          },
          "fe/k": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_K",
             "label": "Fe/K"
          },
          "fe_k": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_K",
             "label": "Fe/K"
          },
          "iron/potassium": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_K",
             "label": "Fe/K"
          },
          "fe/mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Mn",
             "label": "Fe/Mn"
          },
          "fe_mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Mn",
             "label": "Fe/Mn"
          },
          "iron/manganese": {
             "id": "http://linked.earth/ontology/paleo_variables#Fe_Mn",
             "label": "Fe/Mn"
          },
          "gdgt": {
             "id": "http://linked.earth/ontology/paleo_variables#GDGT",
             "label": "GDGT"
          },
          "glycerol dialkyl glycerol tetraether": {
             "id": "http://linked.earth/ontology/paleo_variables#GDGT",
             "label": "GDGT"
          },
          "brgdgt": {
             "id": "http://linked.earth/ontology/paleo_variables#GDGT",
             "label": "GDGT"
          },
          "gdgt-0/cren": {
             "id": "http://linked.earth/ontology/paleo_variables#GDGT-0_Cren",
             "label": "GDGT-0/Cren"
          },
          "gdgt-0_cren": {
             "id": "http://linked.earth/ontology/paleo_variables#GDGT-0_Cren",
             "label": "GDGT-0/Cren"
          },
          "ip25": {
             "id": "http://linked.earth/ontology/paleo_variables#IP25",
             "label": "IP25"
          },
          "ice proxy with 25 carbon atoms": {
             "id": "http://linked.earth/ontology/paleo_variables#IP25",
             "label": "IP25"
          },
          "ip25_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#IP25",
             "label": "IP25"
          },
          "irm": {
             "id": "http://linked.earth/ontology/paleo_variables#IRM",
             "label": "IRM"
          },
          "isothermal remanent magnetization": {
             "id": "http://linked.earth/ontology/paleo_variables#IRM",
             "label": "IRM"
          },
          "irm_softflux": {
             "id": "http://linked.earth/ontology/paleo_variables#IRM",
             "label": "IRM"
          },
          "itcz": {
             "id": "http://linked.earth/ontology/paleo_variables#ITCZ",
             "label": "ITCZ"
          },
          "intertropical convergence zone index": {
             "id": "http://linked.earth/ontology/paleo_variables#ITCZ",
             "label": "ITCZ"
          },
          "itcz_index": {
             "id": "http://linked.earth/ontology/paleo_variables#ITCZ",
             "label": "ITCZ"
          },
          "julianday": {
             "id": "http://linked.earth/ontology/paleo_variables#JulianDay",
             "label": "JulianDay"
          },
          "k2o": {
             "id": "http://linked.earth/ontology/paleo_variables#K2O",
             "label": "K2O"
          },
          "potassium oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#K2O",
             "label": "K2O"
          },
          "k37": {
             "id": "http://linked.earth/ontology/paleo_variables#K37",
             "label": "K37"
          },
          "k37s": {
             "id": "http://linked.earth/ontology/paleo_variables#K37",
             "label": "K37"
          },
          "k/al": {
             "id": "http://linked.earth/ontology/paleo_variables#K_Al",
             "label": "K/Al"
          },
          "k_al": {
             "id": "http://linked.earth/ontology/paleo_variables#K_Al",
             "label": "K/Al"
          },
          "potassium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#K_Al",
             "label": "K/Al"
          },
          "ln(k/al)": {
             "id": "http://linked.earth/ontology/paleo_variables#K_Al",
             "label": "K/Al"
          },
          "ldi": {
             "id": "http://linked.earth/ontology/paleo_variables#LDI",
             "label": "LDI"
          },
          "long-chain diol index": {
             "id": "http://linked.earth/ontology/paleo_variables#LDI",
             "label": "LDI"
          },
          "loi": {
             "id": "http://linked.earth/ontology/paleo_variables#LOI",
             "label": "LOI"
          },
          "loss on ignition": {
             "id": "http://linked.earth/ontology/paleo_variables#LOI",
             "label": "LOI"
          },
          "la": {
             "id": "http://linked.earth/ontology/paleo_variables#La",
             "label": "La"
          },
          "lanthanum": {
             "id": "http://linked.earth/ontology/paleo_variables#La",
             "label": "La"
          },
          "ppm la": {
             "id": "http://linked.earth/ontology/paleo_variables#La",
             "label": "La"
          },
          "mar": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "mass per area per time unit": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "bulk mar": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "cordmar": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "mo mar (ug/cm2/ky)": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "bulkmar": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "massacum": {
             "id": "http://linked.earth/ontology/paleo_variables#MAR",
             "label": "MAR"
          },
          "mbt": {
             "id": "http://linked.earth/ontology/paleo_variables#MBT",
             "label": "MBT"
          },
          "methylation index of branched tetraethers": {
             "id": "http://linked.earth/ontology/paleo_variables#MBT",
             "label": "MBT"
          },
          "mbt\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#MBT",
             "label": "MBT"
          },
          "mbt\u20195me": {
             "id": "http://linked.earth/ontology/paleo_variables#MBT",
             "label": "MBT"
          },
          "ms": {
             "id": "http://linked.earth/ontology/paleo_variables#MS",
             "label": "MS"
          },
          "magnetic susceptibility": {
             "id": "http://linked.earth/ontology/paleo_variables#MS",
             "label": "MS"
          },
          "avg_ms_drs1_2a_3_2b_4": {
             "id": "http://linked.earth/ontology/paleo_variables#MS",
             "label": "MS"
          },
          "avg_ms": {
             "id": "http://linked.earth/ontology/paleo_variables#MS",
             "label": "MS"
          },
          "massmagsus": {
             "id": "http://linked.earth/ontology/paleo_variables#MS",
             "label": "MS"
          },
          "si": {
             "id": "http://linked.earth/ontology/paleo_variables#Si",
             "label": "Si"
          },
          "mxd": {
             "id": "http://linked.earth/ontology/paleo_variables#MXD",
             "label": "MXD"
          },
          "latewood density": {
             "id": "http://linked.earth/ontology/paleo_variables#MXD",
             "label": "MXD"
          },
          "mg": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "magnesium": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "% mg": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "%mg": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "mgdetrended": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "mg__": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "detrendmg": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg",
             "label": "Mg"
          },
          "mgo": {
             "id": "http://linked.earth/ontology/paleo_variables#MgO",
             "label": "MgO"
          },
          "magnesium oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#MgO",
             "label": "MgO"
          },
          "mg/ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mg_ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "magnesium/calcium": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "cdr3_mgca": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mg/ca raw": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "ndutertreimg/ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_bulloides": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_crassaformis": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_dutertrei": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_inflata": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_obliquiloculata": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_pachyderma": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_pachyderma_d": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_ruber": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_ruber_lato": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_ruber_pink": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_ruber_stricto": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_sacculifer": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mgca_truncatulinoides": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "planktic.mgca": {
             "id": "http://linked.earth/ontology/paleo_variables#Mg_Ca",
             "label": "Mg/Ca"
          },
          "mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn",
             "label": "Mn"
          },
          "manganese": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn",
             "label": "Mn"
          },
          "% mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn",
             "label": "Mn"
          },
          "ppm mn": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn",
             "label": "Mn"
          },
          "mno": {
             "id": "http://linked.earth/ontology/paleo_variables#MnO",
             "label": "MnO"
          },
          "manganese oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#MnO",
             "label": "MnO"
          },
          "mn/fe": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn_Fe",
             "label": "Mn/Fe"
          },
          "mn_fe": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn_Fe",
             "label": "Mn/Fe"
          },
          "manganese/iron": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn_Fe",
             "label": "Mn/Fe"
          },
          "mn/mo": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn_Mo",
             "label": "Mn/Mo"
          },
          "mn_mo": {
             "id": "http://linked.earth/ontology/paleo_variables#Mn_Mo",
             "label": "Mn/Mo"
          },
          "mo": {
             "id": "http://linked.earth/ontology/paleo_variables#Mo",
             "label": "Mo"
          },
          "molybdenum": {
             "id": "http://linked.earth/ontology/paleo_variables#Mo",
             "label": "Mo"
          },
          "mo_xs": {
             "id": "http://linked.earth/ontology/paleo_variables#Mo",
             "label": "Mo"
          },
          "ppm mo": {
             "id": "http://linked.earth/ontology/paleo_variables#Mo",
             "label": "Mo"
          },
          "no3": {
             "id": "http://linked.earth/ontology/paleo_variables#NO3",
             "label": "NO3"
          },
          "nitrate": {
             "id": "http://linked.earth/ontology/paleo_variables#nitrate",
             "label": "nitrate"
          },
          "no3_": {
             "id": "http://linked.earth/ontology/paleo_variables#NO3",
             "label": "NO3"
          },
          "n/c": {
             "id": "http://linked.earth/ontology/paleo_variables#N_C",
             "label": "N/C"
          },
          "n_c": {
             "id": "http://linked.earth/ontology/paleo_variables#N_C",
             "label": "N/C"
          },
          "nc": {
             "id": "http://linked.earth/ontology/paleo_variables#N_C",
             "label": "N/C"
          },
          "na2o": {
             "id": "http://linked.earth/ontology/paleo_variables#Na2O",
             "label": "Na2O"
          },
          "sodium oxide": {
             "id": "http://linked.earth/ontology/paleo_variables#Na2O",
             "label": "Na2O"
          },
          "ni": {
             "id": "http://linked.earth/ontology/paleo_variables#Ni",
             "label": "Ni"
          },
          "nickel": {
             "id": "http://linked.earth/ontology/paleo_variables#Ni",
             "label": "Ni"
          },
          "ppm ni": {
             "id": "http://linked.earth/ontology/paleo_variables#Ni",
             "label": "Ni"
          },
          "pc1": {
             "id": "http://linked.earth/ontology/paleo_variables#PC1",
             "label": "PC1"
          },
          "empirical orthogonal function": {
             "id": "http://linked.earth/ontology/paleo_variables#PC3",
             "label": "PC3"
          },
          "p1": {
             "id": "http://linked.earth/ontology/paleo_variables#PC1",
             "label": "PC1"
          },
          "pc1gs": {
             "id": "http://linked.earth/ontology/paleo_variables#PC1",
             "label": "PC1"
          },
          "pca1": {
             "id": "http://linked.earth/ontology/paleo_variables#PC1",
             "label": "PC1"
          },
          "droughtindex (pc1)": {
             "id": "http://linked.earth/ontology/paleo_variables#PC1",
             "label": "PC1"
          },
          "pc2": {
             "id": "http://linked.earth/ontology/paleo_variables#PC2",
             "label": "PC2"
          },
          "pca2": {
             "id": "http://linked.earth/ontology/paleo_variables#PC2",
             "label": "PC2"
          },
          "pc3": {
             "id": "http://linked.earth/ontology/paleo_variables#PC3",
             "label": "PC3"
          },
          "paq": {
             "id": "http://linked.earth/ontology/paleo_variables#Paq",
             "label": "Paq"
          },
          "p-aqueous": {
             "id": "http://linked.earth/ontology/paleo_variables#Paq",
             "label": "Paq"
          },
          "pb": {
             "id": "http://linked.earth/ontology/paleo_variables#Pb",
             "label": "Pb"
          },
          "lead": {
             "id": "http://linked.earth/ontology/paleo_variables#Pb",
             "label": "Pb"
          },
          "ppm pb": {
             "id": "http://linked.earth/ontology/paleo_variables#Pb",
             "label": "Pb"
          },
          "picea/artemisia": {
             "id": "http://linked.earth/ontology/paleo_variables#Picea_Artemisia",
             "label": "Picea/Artemisia"
          },
          "picea_artemisia": {
             "id": "http://linked.earth/ontology/paleo_variables#Picea_Artemisia",
             "label": "Picea/Artemisia"
          },
          "picea/artemesia": {
             "id": "http://linked.earth/ontology/paleo_variables#Picea_Artemisia",
             "label": "Picea/Artemisia"
          },
          "picea/pinus": {
             "id": "http://linked.earth/ontology/paleo_variables#Picea_Pinus",
             "label": "Picea/Pinus"
          },
          "picea_pinus": {
             "id": "http://linked.earth/ontology/paleo_variables#Picea_Pinus",
             "label": "Picea/Pinus"
          },
          "pinus/artemisia": {
             "id": "http://linked.earth/ontology/paleo_variables#Pinus_Artemisia",
             "label": "Pinus/Artemisia"
          },
          "pinus_artemisia": {
             "id": "http://linked.earth/ontology/paleo_variables#Pinus_Artemisia",
             "label": "Pinus/Artemisia"
          },
          "poaceae/ephedra": {
             "id": "http://linked.earth/ontology/paleo_variables#Poaceae_Ephedra",
             "label": "Poaceae/Ephedra"
          },
          "poaceae_ephedra": {
             "id": "http://linked.earth/ontology/paleo_variables#Poaceae_Ephedra",
             "label": "Poaceae/Ephedra"
          },
          "r570/r630": {
             "id": "http://linked.earth/ontology/paleo_variables#R570_R630",
             "label": "R570/R630"
          },
          "r570_r630": {
             "id": "http://linked.earth/ontology/paleo_variables#R570_R630",
             "label": "R570/R630"
          },
          "r570_630": {
             "id": "http://linked.earth/ontology/paleo_variables#R570_R630",
             "label": "R570/R630"
          },
          "r650/r700": {
             "id": "http://linked.earth/ontology/paleo_variables#R650_R700",
             "label": "R650/R700"
          },
          "r650_r700": {
             "id": "http://linked.earth/ontology/paleo_variables#R650_R700",
             "label": "R650/R700"
          },
          "r650_700": {
             "id": "http://linked.earth/ontology/paleo_variables#R650_R700",
             "label": "R650/R700"
          },
          "rabd660670": {
             "id": "http://linked.earth/ontology/paleo_variables#RABD660670",
             "label": "RABD660670"
          },
          "r660_670": {
             "id": "http://linked.earth/ontology/paleo_variables#RABD660670",
             "label": "RABD660670"
          },
          "rabd660;670 index": {
             "id": "http://linked.earth/ontology/paleo_variables#RABD660670",
             "label": "RABD660670"
          },
          "rabd660_670": {
             "id": "http://linked.earth/ontology/paleo_variables#RABD660670",
             "label": "RABD660670"
          },
          "ran15": {
             "id": "http://linked.earth/ontology/paleo_variables#RAN15",
             "label": "RAN15"
          },
          "organic compound index": {
             "id": "http://linked.earth/ontology/paleo_variables#RAN15",
             "label": "RAN15"
          },
          "rbar": {
             "id": "http://linked.earth/ontology/paleo_variables#RBAR",
             "label": "RBAR"
          },
          "average correlation coefficient": {
             "id": "http://linked.earth/ontology/paleo_variables#RBAR",
             "label": "RBAR"
          },
          "rb": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb",
             "label": "Rb"
          },
          "rubidium": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb",
             "label": "Rb"
          },
          "rb peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb",
             "label": "Rb"
          },
          "rb87/sr86": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb87_Sr86",
             "label": "Rb87/Sr86"
          },
          "rb87_sr86": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb87_Sr86",
             "label": "Rb87/Sr86"
          },
          "87rb/86sr": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb87_Sr86",
             "label": "Rb87/Sr86"
          },
          "rb/sr": {
             "id": "http://linked.earth/ontology/paleo_variables#Rb87_Sr86",
             "label": "Rb87/Sr86"
          },
          "so4": {
             "id": "http://linked.earth/ontology/paleo_variables#SO4",
             "label": "SO4"
          },
          "sulfate": {
             "id": "http://linked.earth/ontology/paleo_variables#sulfate",
             "label": "sulfate"
          },
          "so4__": {
             "id": "http://linked.earth/ontology/paleo_variables#SO4",
             "label": "SO4"
          },
          "sss": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "sc": {
             "id": "http://linked.earth/ontology/paleo_variables#Sc",
             "label": "Sc"
          },
          "scandium": {
             "id": "http://linked.earth/ontology/paleo_variables#Sc",
             "label": "Sc"
          },
          "ppm sc": {
             "id": "http://linked.earth/ontology/paleo_variables#Sc",
             "label": "Sc"
          },
          "silicon": {
             "id": "http://linked.earth/ontology/paleo_variables#Si",
             "label": "Si"
          },
          "si peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Si",
             "label": "Si"
          },
          "siprop": {
             "id": "http://linked.earth/ontology/paleo_variables#Si",
             "label": "Si"
          },
          "norm silicon": {
             "id": "http://linked.earth/ontology/paleo_variables#Si",
             "label": "Si"
          },
          "si/al": {
             "id": "http://linked.earth/ontology/paleo_variables#Si_Al",
             "label": "Si/Al"
          },
          "si_al": {
             "id": "http://linked.earth/ontology/paleo_variables#Si_Al",
             "label": "Si/Al"
          },
          "silicon/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#Si_Ti",
             "label": "Si/Ti"
          },
          "si/ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Si_Ti",
             "label": "Si/Ti"
          },
          "si_ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Si_Ti",
             "label": "Si/Ti"
          },
          "norm si/ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Si_Ti",
             "label": "Si/Ti"
          },
          "sr": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr",
             "label": "Sr"
          },
          "strontium": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr",
             "label": "Sr"
          },
          "sr (ppm)": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr",
             "label": "Sr"
          },
          "sr peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr",
             "label": "Sr"
          },
          "ppm sr": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr",
             "label": "Sr"
          },
          "sr/ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "sr_ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "strontium/calcium": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "cdr3_srca": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "srca": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "srca_annual": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "wr11_srca": {
             "id": "http://linked.earth/ontology/paleo_variables#Sr_Ca",
             "label": "Sr/Ca"
          },
          "tds": {
             "id": "http://linked.earth/ontology/paleo_variables#TDS",
             "label": "TDS"
          },
          "total dissolved solids": {
             "id": "http://linked.earth/ontology/paleo_variables#TDS",
             "label": "TDS"
          },
          "tex86": {
             "id": "http://linked.earth/ontology/paleo_variables#TEX86",
             "label": "TEX86"
          },
          "tetraether index of 86 carbon atoms": {
             "id": "http://linked.earth/ontology/paleo_variables#TEX86",
             "label": "TEX86"
          },
          "tex86l": {
             "id": "http://linked.earth/ontology/paleo_variables#TEX86",
             "label": "TEX86"
          },
          "tic": {
             "id": "http://linked.earth/ontology/paleo_variables#TIC",
             "label": "TIC"
          },
          "inorganic carbon": {
             "id": "http://linked.earth/ontology/paleo_variables#TIC",
             "label": "TIC"
          },
          "% ic": {
             "id": "http://linked.earth/ontology/paleo_variables#TIC",
             "label": "TIC"
          },
          "toc": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "organic carbon": {
             "id": "http://linked.earth/ontology/paleo_variables#organicCarbon",
             "label": "organicCarbon"
          },
          "% oc": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "% organic carbon": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "corg": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "oc-mar (g)": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "oc-mar (mg)": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "organic carbon concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "toc_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "tocmg": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC",
             "label": "TOC"
          },
          "toc/tn": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC_TN",
             "label": "TOC/TN"
          },
          "toc_tn": {
             "id": "http://linked.earth/ontology/paleo_variables#TOC_TN",
             "label": "TOC/TN"
          },
          "ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "titanium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "% ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "%ti": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "ti peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "tiprop": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "tiash": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti",
             "label": "Ti"
          },
          "tio2": {
             "id": "http://linked.earth/ontology/paleo_variables#TiO2",
             "label": "TiO2"
          },
          "titanium dioxide": {
             "id": "http://linked.earth/ontology/paleo_variables#TiO2",
             "label": "TiO2"
          },
          "ti/al": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Al",
             "label": "Ti/Al"
          },
          "ti_al": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Al",
             "label": "Ti/Al"
          },
          "titanium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Al",
             "label": "Ti/Al"
          },
          "ti_ca": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Ca",
             "label": "Ti/Ca"
          },
          "titanium/calcium": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Ca",
             "label": "Ti/Ca"
          },
          "ln(ti/ca)": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Ca",
             "label": "Ti/Ca"
          },
          "log(ti/ca)": {
             "id": "http://linked.earth/ontology/paleo_variables#Ti_Ca",
             "label": "Ti/Ca"
          },
          "uk37": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37",
             "label": "Uk37"
          },
          "alkenone unsaturation index uk37": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37",
             "label": "Uk37"
          },
          "sumuk37": {
             "id": "http://linked.earth/ontology/paleo_variables#UK37",
             "label": "UK37"
          },
          "uk37-sfs values": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37",
             "label": "Uk37"
          },
          "uk37\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37_",
             "label": "Uk37\u2019"
          },
          "uk37_": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37_",
             "label": "Uk37\u2019"
          },
          "alkenone unsaturation index uk37 prime": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37_",
             "label": "Uk37\u2019"
          },
          "uk\u201937": {
             "id": "http://linked.earth/ontology/paleo_variables#Uk37_",
             "label": "Uk37\u2019"
          },
          "v": {
             "id": "http://linked.earth/ontology/paleo_variables#V",
             "label": "V"
          },
          "vanadium": {
             "id": "http://linked.earth/ontology/paleo_variables#V",
             "label": "V"
          },
          "ppm v": {
             "id": "http://linked.earth/ontology/paleo_variables#V",
             "label": "V"
          },
          "v/al": {
             "id": "http://linked.earth/ontology/paleo_variables#V_Al",
             "label": "V/Al"
          },
          "v_al": {
             "id": "http://linked.earth/ontology/paleo_variables#V_Al",
             "label": "V/Al"
          },
          "vanadium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#V_Al",
             "label": "V/Al"
          },
          "y": {
             "id": "http://linked.earth/ontology/paleo_variables#Y",
             "label": "Y"
          },
          "yttrium": {
             "id": "http://linked.earth/ontology/paleo_variables#Y",
             "label": "Y"
          },
          "ppm y": {
             "id": "http://linked.earth/ontology/paleo_variables#Y",
             "label": "Y"
          },
          "zn": {
             "id": "http://linked.earth/ontology/paleo_variables#Zn",
             "label": "Zn"
          },
          "zinc": {
             "id": "http://linked.earth/ontology/paleo_variables#Zn",
             "label": "Zn"
          },
          "ppm zn": {
             "id": "http://linked.earth/ontology/paleo_variables#Zn",
             "label": "Zn"
          },
          "zr": {
             "id": "http://linked.earth/ontology/paleo_variables#Zr",
             "label": "Zr"
          },
          "zirconium": {
             "id": "http://linked.earth/ontology/paleo_variables#Zr",
             "label": "Zr"
          },
          "ppm zr": {
             "id": "http://linked.earth/ontology/paleo_variables#Zr",
             "label": "Zr"
          },
          "zr/al": {
             "id": "http://linked.earth/ontology/paleo_variables#Zr_Al",
             "label": "Zr/Al"
          },
          "zr_al": {
             "id": "http://linked.earth/ontology/paleo_variables#Zr_Al",
             "label": "Zr/Al"
          },
          "zirconium/aluminum": {
             "id": "http://linked.earth/ontology/paleo_variables#Zr_Al",
             "label": "Zr/Al"
          },
          "accumulation": {
             "id": "http://linked.earth/ontology/paleo_variables#accumulation",
             "label": "accumulation"
          },
          "accumulation rate": {
             "id": "http://linked.earth/ontology/paleo_variables#accumulation",
             "label": "accumulation"
          },
          "accumulation rate ice (kg/m2/yr)": {
             "id": "http://linked.earth/ontology/paleo_variables#accumulation",
             "label": "accumulation"
          },
          "ice accumulation": {
             "id": "http://linked.earth/ontology/paleo_variables#accumulation",
             "label": "accumulation"
          },
          "acc": {
             "id": "http://linked.earth/ontology/paleo_variables#accumulation",
             "label": "accumulation"
          },
          "age": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "age_original": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "intcal09age": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "marine09": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "median cal age": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "shcal04age": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agebacon": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agebchron": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "ageduplicate": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "ageensemble": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agemarine09": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agemedian": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agemedianbacon": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "ageoriginal": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "ageother": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "ageoxcal": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agerounded": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agestalage": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "age_calibrated": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "age_alt": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agecopra": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agelininterp": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "agelinreg": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "medianage": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "varvecountedagead0x2fbc": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "varvecountedageka": {
             "id": "http://linked.earth/ontology/paleo_variables#age",
             "label": "age"
          },
          "age14c": {
             "id": "http://linked.earth/ontology/paleo_variables#age14C",
             "label": "age14C"
          },
          "radiocarbon year": {
             "id": "http://linked.earth/ontology/paleo_variables#age14C",
             "label": "age14C"
          },
          "c14age": {
             "id": "http://linked.earth/ontology/paleo_variables#age14C",
             "label": "age14C"
          },
          "radiocarbondatesad0x2fbc": {
             "id": "http://linked.earth/ontology/paleo_variables#age14C",
             "label": "age14C"
          },
          "ammonium": {
             "id": "http://linked.earth/ontology/paleo_variables#ammonium",
             "label": "ammonium"
          },
          "nh4_": {
             "id": "http://linked.earth/ontology/paleo_variables#ammonium",
             "label": "ammonium"
          },
          "amps": {
             "id": "http://linked.earth/ontology/paleo_variables#amps",
             "label": "amps"
          },
          "ampere": {
             "id": "http://linked.earth/ontology/paleo_variables#amps",
             "label": "amps"
          },
          "aragonite": {
             "id": "http://linked.earth/ontology/paleo_variables#aragonite",
             "label": "aragonite"
          },
          "ash": {
             "id": "http://linked.earth/ontology/paleo_variables#ash",
             "label": "ash"
          },
          "boron": {
             "id": "http://linked.earth/ontology/paleo_variables#boron",
             "label": "boron"
          },
          "b": {
             "id": "http://linked.earth/ontology/paleo_variables#boron",
             "label": "boron"
          },
          "brgdgt-iiia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa",
             "label": "brGDGT-IIIa"
          },
          "branched glycerol dialkyl glycerol tetraether": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Id",
             "label": "brGDGT-Id"
          },
          "br1050": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa",
             "label": "brGDGT-IIIa"
          },
          "iiia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa",
             "label": "brGDGT-IIIa"
          },
          "brgdgtiiia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa",
             "label": "brGDGT-IIIa"
          },
          "brgdgt-iiia\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa_",
             "label": "brGDGT-IIIa\u2019"
          },
          "brgdgt-iiia_": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa_",
             "label": "brGDGT-IIIa\u2019"
          },
          "iiia\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIa_",
             "label": "brGDGT-IIIa\u2019"
          },
          "brgdgt-iiib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb",
             "label": "brGDGT-IIIb"
          },
          "br1048": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb",
             "label": "brGDGT-IIIb"
          },
          "iiib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb",
             "label": "brGDGT-IIIb"
          },
          "brgdgtiiib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb",
             "label": "brGDGT-IIIb"
          },
          "brgdgt-iiib\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb_",
             "label": "brGDGT-IIIb\u2019"
          },
          "brgdgt-iiib_": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb_",
             "label": "brGDGT-IIIb\u2019"
          },
          "iiib\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIb_",
             "label": "brGDGT-IIIb\u2019"
          },
          "brgdgt-iiic": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIc",
             "label": "brGDGT-IIIc"
          },
          "iiic": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIc",
             "label": "brGDGT-IIIc"
          },
          "brgdgt-iiic\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIc_",
             "label": "brGDGT-IIIc\u2019"
          },
          "brgdgt-iiic_": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIc_",
             "label": "brGDGT-IIIc\u2019"
          },
          "iiic\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIIc_",
             "label": "brGDGT-IIIc\u2019"
          },
          "brgdgt-iia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa",
             "label": "brGDGT-IIa"
          },
          "br1036": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa",
             "label": "brGDGT-IIa"
          },
          "iia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa",
             "label": "brGDGT-IIa"
          },
          "brgdgtiia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa",
             "label": "brGDGT-IIa"
          },
          "brgdgt-iia\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa_",
             "label": "brGDGT-IIa\u2019"
          },
          "brgdgt-iia_": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa_",
             "label": "brGDGT-IIa\u2019"
          },
          "iia\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIa_",
             "label": "brGDGT-IIa\u2019"
          },
          "brgdgt-iib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIb",
             "label": "brGDGT-IIb"
          },
          "iib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIb",
             "label": "brGDGT-IIb"
          },
          "brgdgtiib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIb",
             "label": "brGDGT-IIb"
          },
          "brgdgt-iib\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIb_",
             "label": "brGDGT-IIb\u2019"
          },
          "brgdgt-iib_": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIb_",
             "label": "brGDGT-IIb\u2019"
          },
          "iib\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIb_",
             "label": "brGDGT-IIb\u2019"
          },
          "brgdgt-iic": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIc",
             "label": "brGDGT-IIc"
          },
          "iic": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIc",
             "label": "brGDGT-IIc"
          },
          "brgdgt-iic\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIc_",
             "label": "brGDGT-IIc\u2019"
          },
          "brgdgt-iic_": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIc_",
             "label": "brGDGT-IIc\u2019"
          },
          "iic\u2019": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-IIc_",
             "label": "brGDGT-IIc\u2019"
          },
          "brgdgt-ia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ia",
             "label": "brGDGT-Ia"
          },
          "ia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ia",
             "label": "brGDGT-Ia"
          },
          "brgdgtia": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ia",
             "label": "brGDGT-Ia"
          },
          "brgdgt-ib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ib",
             "label": "brGDGT-Ib"
          },
          "br1020": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ib",
             "label": "brGDGT-Ib"
          },
          "ib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ib",
             "label": "brGDGT-Ib"
          },
          "brgdgtib": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ib",
             "label": "brGDGT-Ib"
          },
          "brgdgt-ic": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ic",
             "label": "brGDGT-Ic"
          },
          "ic": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Ic",
             "label": "brGDGT-Ic"
          },
          "brgdgt-id": {
             "id": "http://linked.earth/ontology/paleo_variables#brGDGT-Id",
             "label": "brGDGT-Id"
          },
          "id": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "bubblenumberdensity": {
             "id": "http://linked.earth/ontology/paleo_variables#bubbleNumberDensity",
             "label": "bubbleNumberDensity"
          },
          "bulkdensity": {
             "id": "http://linked.earth/ontology/paleo_variables#bulkDensity",
             "label": "bulkDensity"
          },
          "bulk density": {
             "id": "http://linked.earth/ontology/paleo_variables#bulkDensity",
             "label": "bulkDensity"
          },
          "calcificationrate": {
             "id": "http://linked.earth/ontology/paleo_variables#calcificationRate",
             "label": "calcificationRate"
          },
          "calcification rate": {
             "id": "http://linked.earth/ontology/paleo_variables#calcificationRate",
             "label": "calcificationRate"
          },
          "calcification": {
             "id": "http://linked.earth/ontology/paleo_variables#calcificationRate",
             "label": "calcificationRate"
          },
          "calcite": {
             "id": "http://linked.earth/ontology/paleo_variables#calcite",
             "label": "calcite"
          },
          "carbon": {
             "id": "http://linked.earth/ontology/paleo_variables#carbon",
             "label": "carbon"
          },
          "% tc": {
             "id": "http://linked.earth/ontology/paleo_variables#carbon",
             "label": "carbon"
          },
          "% total c": {
             "id": "http://linked.earth/ontology/paleo_variables#carbon",
             "label": "carbon"
          },
          "%_tc": {
             "id": "http://linked.earth/ontology/paleo_variables#carbon",
             "label": "carbon"
          },
          "c": {
             "id": "http://linked.earth/ontology/paleo_variables#carbon",
             "label": "carbon"
          },
          "x_c": {
             "id": "http://linked.earth/ontology/paleo_variables#carbon",
             "label": "carbon"
          },
          "carbonate": {
             "id": "http://linked.earth/ontology/paleo_variables#carbonate",
             "label": "carbonate"
          },
          "% carbonate": {
             "id": "http://linked.earth/ontology/paleo_variables#carbonate",
             "label": "carbonate"
          },
          "charcoal": {
             "id": "http://linked.earth/ontology/paleo_variables#charcoal",
             "label": "charcoal"
          },
          "chacoal_influx": {
             "id": "http://linked.earth/ontology/paleo_variables#charcoal",
             "label": "charcoal"
          },
          "chloride": {
             "id": "http://linked.earth/ontology/paleo_variables#chloride",
             "label": "chloride"
          },
          "circulationindex": {
             "id": "http://linked.earth/ontology/paleo_variables#circulationIndex",
             "label": "circulationIndex"
          },
          "circulation index": {
             "id": "http://linked.earth/ontology/paleo_variables#circulationIndex",
             "label": "circulationIndex"
          },
          "goe": {
             "id": "http://linked.earth/ontology/paleo_variables#circulationIndex",
             "label": "circulationIndex"
          },
          "gof": {
             "id": "http://linked.earth/ontology/paleo_variables#circulationIndex",
             "label": "circulationIndex"
          },
          "clay": {
             "id": "http://linked.earth/ontology/paleo_variables#clay",
             "label": "clay"
          },
          "%_clay": {
             "id": "http://linked.earth/ontology/paleo_variables#clay",
             "label": "clay"
          },
          "x_clay": {
             "id": "http://linked.earth/ontology/paleo_variables#clay",
             "label": "clay"
          },
          "cluster": {
             "id": "http://linked.earth/ontology/paleo_variables#cluster",
             "label": "cluster"
          },
          "statistical variable": {
             "id": "http://linked.earth/ontology/paleo_variables#index",
             "label": "index"
          },
          "cluster2": {
             "id": "http://linked.earth/ontology/paleo_variables#cluster",
             "label": "cluster"
          },
          "composite": {
             "id": "http://linked.earth/ontology/paleo_variables#composite",
             "label": "composite"
          },
          "proxy composite": {
             "id": "http://linked.earth/ontology/paleo_variables#composite",
             "label": "composite"
          },
          "hybrid": {
             "id": "http://linked.earth/ontology/paleo_variables#composite",
             "label": "composite"
          },
          "concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#concentration",
             "label": "concentration"
          },
          "concentration unit": {
             "id": "http://linked.earth/ontology/paleo_variables#concentration",
             "label": "concentration"
          },
          "concentration (c25-35)": {
             "id": "http://linked.earth/ontology/paleo_variables#concentration",
             "label": "concentration"
          },
          "friedel-3-ene concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#concentration",
             "label": "concentration"
          },
          "hop-17(21)-ene concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#concentration",
             "label": "concentration"
          },
          "core": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "core id": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "core name": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "core section": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "corename": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "coresect1h": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "core_number": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "dune_a": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "stal.id": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "originalcorename": {
             "id": "http://linked.earth/ontology/paleo_variables#core",
             "label": "core"
          },
          "correction": {
             "id": "http://linked.earth/ontology/paleo_variables#correction",
             "label": "correction"
          },
          "corrected": {
             "id": "http://linked.earth/ontology/paleo_variables#correction",
             "label": "correction"
          },
          "iso adjustment for ocean calibration": {
             "id": "http://linked.earth/ontology/paleo_variables#correction",
             "label": "correction"
          },
          "years for ocean correction": {
             "id": "http://linked.earth/ontology/paleo_variables#correction",
             "label": "correction"
          },
          "hasaragonitecorrection": {
             "id": "http://linked.earth/ontology/paleo_variables#correction",
             "label": "correction"
          },
          "hasaragonitecorrectioncomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#correction",
             "label": "correction"
          },
          "correlationcoefficient": {
             "id": "http://linked.earth/ontology/paleo_variables#correlationCoefficient",
             "label": "correlationCoefficient"
          },
          "correlation coefficient": {
             "id": "http://linked.earth/ontology/paleo_variables#correlationCoefficient",
             "label": "correlationCoefficient"
          },
          "corrs": {
             "id": "http://linked.earth/ontology/paleo_variables#correlationCoefficient",
             "label": "correlationCoefficient"
          },
          "count": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleCount",
             "label": "sampleCount"
          },
          "numbe_counted": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "number_counted": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "slide count": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "totalammoniabeccarii": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "total_grains_counted": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "varve_number": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "abundance": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "count_analyses_b3": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "count_analyses_c2": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "count_analyses_c3": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "count_analyses_c5": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "count_analyses_c6": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "numinzone": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "number": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "sampledensity": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "total": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "total_non_chaetoceros_counted": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "total_xount": {
             "id": "http://linked.earth/ontology/paleo_variables#count",
             "label": "count"
          },
          "d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "delta 13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "bulk om d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c13bulk": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c21 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c23 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c25 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c25:2 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c27 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c28 d13c vs.\u00a0vpdb": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c29 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c29 \u03b413c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c31 d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c31 \u03b413c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c31d13c_pdb": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "c33 \u03b413c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "cdr3_d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_c28": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "friedel-3-ene d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "hop-17(21)-ene d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "taraxer-14-ene d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13/12c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c18 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c18 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c20 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c20 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c21 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c21 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c22 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c22 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c23 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c23 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c24 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c24 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c25": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c25 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c25 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c26 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c26 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c27": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c27 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c27 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c28 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c28 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c29": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c29 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c29 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c30 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c30 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c31": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c31 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c31 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c32 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c32 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c33 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c33 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c34 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c34 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c35 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c c35 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c vpdb": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c bulk": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c bulk calcite": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c carbonate": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c organic": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c ostracod": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13ccomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cmean": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cpisid": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cprecisioncomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cstandardcomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_c31": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_org": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13ccarb": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc27": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc27err": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc29": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc29err": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc31": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc31err": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc33": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cleafwaxc33err": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13cwax": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_bulloides": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_dutertrei": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_pachyderma": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_pachyderma_d": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_ruber": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_ruber_pink": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d13c_sacculifer": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "planktic.d13c": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "\u03b413c n-alkanes": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "\u03b413c n-alkanes std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#d13C",
             "label": "d13C"
          },
          "d15n": {
             "id": "http://linked.earth/ontology/paleo_variables#d15N",
             "label": "d15N"
          },
          "delta 15n": {
             "id": "http://linked.earth/ontology/paleo_variables#d15N",
             "label": "d15N"
          },
          "bulk om d15n": {
             "id": "http://linked.earth/ontology/paleo_variables#d15N",
             "label": "d15N"
          },
          "d15n/14n": {
             "id": "http://linked.earth/ontology/paleo_variables#d15N",
             "label": "d15N"
          },
          "dn15": {
             "id": "http://linked.earth/ontology/paleo_variables#d15N",
             "label": "d15N"
          },
          "dn15_corrected": {
             "id": "http://linked.earth/ontology/paleo_variables#d15N",
             "label": "d15N"
          },
          "d18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "delta 18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "cdr3_d18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "chironomid d18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "g. ruber w \u03b418o\u00a0[\u2030 pdb]": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "gbulloidesd18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "ndutertreid18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "wr11_d18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "bagd18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d180_corrc": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o (sea level corrected)": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o avg": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o chironomid": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o lake water": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o vpdb": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o bulk calcite": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o carbonate": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o carbonate corrected for dolomite": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o encrustation": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o ostracod": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o pore ice": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o pore ice sw corr": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18obsi": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18ocomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18opisid": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18oterrestrialgastropods": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_210yr": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_gb": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_grass_leaf": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_pdb": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_smow": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_sphagnum": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_annual": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_sw": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_sw_annual": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_swcorr": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_vpdb": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_vp\u2013sp": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18ocarb": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18odiatom": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18og.rub": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18omean": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18osw": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18osw-g.rub": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18osw-sl-g.rubw": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18otr": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18otr+": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18otr-": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_acicula": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_bulloides": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_crassaformis": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_dutertrei": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_inflata": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_mabahethi": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_marginata": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_menardii": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_obliquiloculata": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_pachyderma": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_pachyderma_d": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_peregrina": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_quinqueloba": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_ruber": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_ruber_lato": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_ruber_pink": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_ruber_stricto": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_sacculifer": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d18o_tumida": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "dd18o5pt": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "nonreliabled18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "planktic.d18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "ruberd18": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "x18o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "x18orub_": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "\u03b418o": {
             "id": "http://linked.earth/ontology/paleo_variables#d18O",
             "label": "d18O"
          },
          "d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "delta 2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c20 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c20 d2h sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c20d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c21 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c22 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c22 d2h sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c22d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c23 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c23 \u03b4d": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c24 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c24d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c25 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c25 \u03b4d": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c25:2 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c26 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c26 d2h sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c26d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c27 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c28 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c28 d2h sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c28_dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c28_ddiv": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c28d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29 dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29 \u03b4d": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29 \u03b4d corrected": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29 \u03b4d ice volume adjusted": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29 \u03b4d ice volume and vegetation adjusted": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c29-c31 \u03b4d": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c30 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c30 d2h sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c30 dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c30 dd iv corrected (3\u00b0c)": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c30 dd iv corrected (7\u00b0c)": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c30d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c31 d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c31 dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c31 \u03b4d": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c31dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c31ddsd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c32 dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "c33 \u03b4d": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "friedel-3-ene d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "hop-17(21)-ene d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "long chain n-alkane avg d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "long chain n-acid avg d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "mid-chain n-acid avg d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "midchain n-alkane avg d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "precip d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "taraxer-14-ene d2h": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "bagdd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c20": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c20 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c20 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c21 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c21 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c22": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c22 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c22 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c23": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c23 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c23 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c24 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c24 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c25": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c25 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c25 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c25 error": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c25:2": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c26 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c26 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c27": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c27 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c27 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c27 error": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c28 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c28 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c29": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c29 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c29 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c29 error": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c30": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c30 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c30 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c31": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c31 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c31 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c31 error": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c32 fame": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c32 fame sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c33 alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h c33 alkane sem": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h avg": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h pore ice": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h pore ice sw corr": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h precip": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hc24": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hc26": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hc28": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hc29": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hc30": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h_c16": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h_c26": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h_c28": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2h_c30": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hleafwaxc29": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hleafwaxc29err": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hleafwaxc31": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hleafwaxc31err": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hleafwaxc33": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hleafwaxc33err": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2hsw": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd iv": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddc29": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddc31": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddp": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd_c29": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd_c31": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd_c31_sd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd_ivandbio": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd_ivonly": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "dd_swcorr": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddwax": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddwax corrected": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddwax_corr": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "ddwax_iv": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "nc28_dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "nc30_dd": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "\u03b4daq": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "\u03b4dterr": {
             "id": "http://linked.earth/ontology/paleo_variables#d2H",
             "label": "d2H"
          },
          "d2huncertaintyhigh80": {
             "id": "http://linked.earth/ontology/paleo_variables#d2HUncertaintyHigh80",
             "label": "d2HUncertaintyHigh80"
          },
          "precip dd 90 ci": {
             "id": "http://linked.earth/ontology/paleo_variables#d2HUncertaintyHigh80",
             "label": "d2HUncertaintyHigh80"
          },
          "d2huncertaintylow80": {
             "id": "http://linked.earth/ontology/paleo_variables#d2HUncertaintyLow80",
             "label": "d2HUncertaintyLow80"
          },
          "precip dd 10 ci": {
             "id": "http://linked.earth/ontology/paleo_variables#d2HUncertaintyLow80",
             "label": "d2HUncertaintyLow80"
          },
          "deleteme": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "a": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "cal": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "calibrated": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "imon1953/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "lazerprofiler": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "rcs.ars": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "saug/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "sete/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "sfev/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "shiv/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "tete/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "tfev/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "thiv/3": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "unkowncolumn": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "average c26 c28": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "hobdob": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "interval": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "noid": {
             "id": "http://linked.earth/ontology/paleo_variables#deleteMe",
             "label": "deleteMe"
          },
          "deltarelativehumidity": {
             "id": "http://linked.earth/ontology/paleo_variables#deltaRelativeHumidity",
             "label": "deltaRelativeHumidity"
          },
          "\u2206rh_mid": {
             "id": "http://linked.earth/ontology/paleo_variables#deltaRelativeHumidity",
             "label": "deltaRelativeHumidity"
          },
          "deltatemperature": {
             "id": "http://linked.earth/ontology/paleo_variables#deltaTemperature",
             "label": "deltaTemperature"
          },
          "deltat": {
             "id": "http://linked.earth/ontology/paleo_variables#deltaTemperature",
             "label": "deltaTemperature"
          },
          "density": {
             "id": "http://linked.earth/ontology/paleo_variables#density",
             "label": "density"
          },
          "depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "adjusted depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "composite depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "composite depth in core": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "composite depth mid": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "composite_depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "core depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth blf": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "drillhole depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "midpointdepth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "section depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "compositedepth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "cor_depth_cm": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth corrected": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depthbycore": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depthcomp": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depthcomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth_cmbs": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth_core": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth_core1": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth_corr_cm": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth_merge": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depth_merged": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depthice": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depthwe": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "drive-depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "mean depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "originalcoredepth": {
             "id": "http://linked.earth/ontology/paleo_variables#depth",
             "label": "depth"
          },
          "depthbottom": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "depth at sample start": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "bot": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "bottom depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "bottom_depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "composite depth bottom": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "section depth bottom": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "bottom depth in section": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "bottomdepth": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "depth.bottom": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "depth_bot": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "depth_bottom": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "uncorrected_depth_bot": {
             "id": "http://linked.earth/ontology/paleo_variables#depthBottom",
             "label": "depthBottom"
          },
          "depthtop": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "acetic acid": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "composite depth top": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "section depth top": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "top": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "top depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "top_depth": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "depth.top": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "depth_top": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "depth_top_m": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "logdepthtop": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "logdepthtop-edc99": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "logdepttop": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "top depth in section": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "topdepth": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "uncorrected_depth_top": {
             "id": "http://linked.earth/ontology/paleo_variables#depthTop",
             "label": "depthTop"
          },
          "deuteriumexcess": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "deuterium excess": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "bagdexcess": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "d-excess": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "d-excess pore ice": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "d-excess pore ice sw corr": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "d-excess sw": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "d-excess_swcorr": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "deutex": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "dxs": {
             "id": "http://linked.earth/ontology/paleo_variables#deuteriumExcess",
             "label": "deuteriumExcess"
          },
          "diatom": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%benthic": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%indif.": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%saline": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%benth.dia": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%fresh": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%plank.dia": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "%saline.dia": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "sumdiatoms": {
             "id": "http://linked.earth/ontology/paleo_variables#diatom",
             "label": "diatom"
          },
          "diatomcount": {
             "id": "http://linked.earth/ontology/paleo_variables#diatomCount",
             "label": "diatomCount"
          },
          "diatom index": {
             "id": "http://linked.earth/ontology/paleo_variables#diatomCount",
             "label": "diatomCount"
          },
          "diatoms_per_traverse": {
             "id": "http://linked.earth/ontology/paleo_variables#diatomCount",
             "label": "diatomCount"
          },
          "diatom_abundance": {
             "id": "http://linked.earth/ontology/paleo_variables#diatomCount",
             "label": "diatomCount"
          },
          "seaicediatoms": {
             "id": "http://linked.earth/ontology/paleo_variables#diatomCount",
             "label": "diatomCount"
          },
          "dinocyst": {
             "id": "http://linked.earth/ontology/paleo_variables#dinocyst",
             "label": "dinocyst"
          },
          "total dinocysts": {
             "id": "http://linked.earth/ontology/paleo_variables#dinocyst",
             "label": "dinocyst"
          },
          "flux_dino": {
             "id": "http://linked.earth/ontology/paleo_variables#dinocyst",
             "label": "dinocyst"
          },
          "dolomite": {
             "id": "http://linked.earth/ontology/paleo_variables#dolomite",
             "label": "dolomite"
          },
          "% dolomite": {
             "id": "http://linked.earth/ontology/paleo_variables#dolomite",
             "label": "dolomite"
          },
          "drybulkdensity": {
             "id": "http://linked.earth/ontology/paleo_variables#dryBulkDensity",
             "label": "dryBulkDensity"
          },
          "dbd": {
             "id": "http://linked.earth/ontology/paleo_variables#dryBulkDensity",
             "label": "dryBulkDensity"
          },
          "dry bulk density": {
             "id": "http://linked.earth/ontology/paleo_variables#dryBulkDensity",
             "label": "dryBulkDensity"
          },
          "estdrybd": {
             "id": "http://linked.earth/ontology/paleo_variables#dryBulkDensity",
             "label": "dryBulkDensity"
          },
          "dry_bd": {
             "id": "http://linked.earth/ontology/paleo_variables#dryBulkDensity",
             "label": "dryBulkDensity"
          },
          "duration": {
             "id": "http://linked.earth/ontology/paleo_variables#duration",
             "label": "duration"
          },
          "duration unit": {
             "id": "http://linked.earth/ontology/paleo_variables#duration",
             "label": "duration"
          },
          "yearspersample": {
             "id": "http://linked.earth/ontology/paleo_variables#duration",
             "label": "duration"
          },
          "dust": {
             "id": "http://linked.earth/ontology/paleo_variables#dust",
             "label": "dust"
          },
          "0.50_quantile_dust_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#dust",
             "label": "dust"
          },
          "dmar": {
             "id": "http://linked.earth/ontology/paleo_variables#dust",
             "label": "dust"
          },
          "dustflux": {
             "id": "http://linked.earth/ontology/paleo_variables#dust",
             "label": "dust"
          },
          "effectiveprecipitation": {
             "id": "http://linked.earth/ontology/paleo_variables#effectivePrecipitation",
             "label": "effectivePrecipitation"
          },
          "precipitation minus evaporation": {
             "id": "http://linked.earth/ontology/paleo_variables#effectivePrecipitation",
             "label": "effectivePrecipitation"
          },
          "moisture_index": {
             "id": "http://linked.earth/ontology/paleo_variables#effectivePrecipitation",
             "label": "effectivePrecipitation"
          },
          "effectivemoisture": {
             "id": "http://linked.earth/ontology/paleo_variables#effectivePrecipitation",
             "label": "effectivePrecipitation"
          },
          "waterbalance": {
             "id": "http://linked.earth/ontology/paleo_variables#effectivePrecipitation",
             "label": "effectivePrecipitation"
          },
          "elevation": {
             "id": "http://linked.earth/ontology/paleo_variables#elevation",
             "label": "elevation"
          },
          "collection elevation": {
             "id": "http://linked.earth/ontology/paleo_variables#zscore",
             "label": "zscore"
          },
          "elevation a.s.l.": {
             "id": "http://linked.earth/ontology/paleo_variables#elevation",
             "label": "elevation"
          },
          "elevation sample": {
             "id": "http://linked.earth/ontology/paleo_variables#elevation",
             "label": "elevation"
          },
          "epsilonc28c22": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC28C22",
             "label": "epsilonC28C22"
          },
          "epsilon c28-c22": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC28C22",
             "label": "epsilonC28C22"
          },
          "epsilon28-22": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC28C22",
             "label": "epsilonC28C22"
          },
          "epsilonc28c24": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC28C24",
             "label": "epsilonC28C24"
          },
          "epsilon c28-c24": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC28C24",
             "label": "epsilonC28C24"
          },
          "epsilonc29c23": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC29C23",
             "label": "epsilonC29C23"
          },
          "epsilon c29-c23": {
             "id": "http://linked.earth/ontology/paleo_variables#epsilonC29C23",
             "label": "epsilonC29C23"
          },
          "equilibriumlinealtitude": {
             "id": "http://linked.earth/ontology/paleo_variables#equilibriumLineAltitude",
             "label": "equilibriumLineAltitude"
          },
          "equilibrium line altitude": {
             "id": "http://linked.earth/ontology/paleo_variables#equilibriumLineAltitude",
             "label": "equilibriumLineAltitude"
          },
          "ela": {
             "id": "http://linked.earth/ontology/paleo_variables#equilibriumLineAltitude",
             "label": "equilibriumLineAltitude"
          },
          "ela_alt": {
             "id": "http://linked.earth/ontology/paleo_variables#equilibriumLineAltitude",
             "label": "equilibriumLineAltitude"
          },
          "event": {
             "id": "http://linked.earth/ontology/paleo_variables#event",
             "label": "event"
          },
          "eventlayer": {
             "id": "http://linked.earth/ontology/paleo_variables#eventLayer",
             "label": "eventLayer"
          },
          "event layer": {
             "id": "http://linked.earth/ontology/paleo_variables#eventLayer",
             "label": "eventLayer"
          },
          "layer": {
             "id": "http://linked.earth/ontology/paleo_variables#eventLayer",
             "label": "eventLayer"
          },
          "layer_type": {
             "id": "http://linked.earth/ontology/paleo_variables#eventLayer",
             "label": "eventLayer"
          },
          "facies": {
             "id": "http://linked.earth/ontology/paleo_variables#facies",
             "label": "facies"
          },
          "lithologic unit": {
             "id": "http://linked.earth/ontology/paleo_variables#facies",
             "label": "facies"
          },
          "lithology": {
             "id": "http://linked.earth/ontology/paleo_variables#facies",
             "label": "facies"
          },
          "feldspar": {
             "id": "http://linked.earth/ontology/paleo_variables#feldspar",
             "label": "feldspar"
          },
          "feldspar group": {
             "id": "http://linked.earth/ontology/paleo_variables#feldspar",
             "label": "feldspar"
          },
          "flood": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "m-flood": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "m-flood 200 yr avg": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "m-flood 30 yr sum": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "p-flood": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "p-flood 200 yr avg": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "p-flood 30 yr sum": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "floods": {
             "id": "http://linked.earth/ontology/paleo_variables#flood",
             "label": "flood"
          },
          "fluorine": {
             "id": "http://linked.earth/ontology/paleo_variables#fluorine",
             "label": "fluorine"
          },
          "f": {
             "id": "http://linked.earth/ontology/paleo_variables#fluorine",
             "label": "fluorine"
          },
          "f_": {
             "id": "http://linked.earth/ontology/paleo_variables#fluorine",
             "label": "fluorine"
          },
          "foraminifera": {
             "id": "http://linked.earth/ontology/paleo_variables#foraminifera",
             "label": "foraminifera"
          },
          "foraminifer": {
             "id": "http://linked.earth/ontology/paleo_variables#foraminifera",
             "label": "foraminifera"
          },
          "foram": {
             "id": "http://linked.earth/ontology/paleo_variables#foraminifera",
             "label": "foraminifera"
          },
          "gamma": {
             "id": "http://linked.earth/ontology/paleo_variables#gamma",
             "label": "gamma"
          },
          "gamma radiation": {
             "id": "http://linked.earth/ontology/paleo_variables#gamma",
             "label": "gamma"
          },
          "glaciercoverage": {
             "id": "http://linked.earth/ontology/paleo_variables#glacierCoverage",
             "label": "glacierCoverage"
          },
          "globigerinoidesruber": {
             "id": "http://linked.earth/ontology/paleo_variables#globigerinoidesRuber",
             "label": "globigerinoidesRuber"
          },
          "globigerinoides ruber": {
             "id": "http://linked.earth/ontology/paleo_variables#globigerinoidesRuber",
             "label": "globigerinoidesRuber"
          },
          "gruber": {
             "id": "http://linked.earth/ontology/paleo_variables#globigerinoidesRuber",
             "label": "globigerinoidesRuber"
          },
          "grainsize": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "grain size": {
             "id": "http://linked.earth/ontology/paleo_variables#lithics",
             "label": "lithics"
          },
          "250-31 um": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "63-4 um": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "<16 \u03bcm": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "<2 um": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "<2um": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "<4 um": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          ">63 um": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "d50": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "grain size mean": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "grainsizemode": {
             "id": "http://linked.earth/ontology/paleo_variables#grainSize",
             "label": "grainSize"
          },
          "grayscale": {
             "id": "http://linked.earth/ontology/paleo_variables#grayscale",
             "label": "grayscale"
          },
          "grayscale20lp_detrended": {
             "id": "http://linked.earth/ontology/paleo_variables#grayscale",
             "label": "grayscale"
          },
          "grey_scale": {
             "id": "http://linked.earth/ontology/paleo_variables#grayscale",
             "label": "grayscale"
          },
          "growing degree days": {
             "id": "http://linked.earth/ontology/paleo_variables#growing_degree_days",
             "label": "growing degree days"
          },
          "growing_degree_days": {
             "id": "http://linked.earth/ontology/paleo_variables#growing_degree_days",
             "label": "growing degree days"
          },
          "gdd5": {
             "id": "http://linked.earth/ontology/paleo_variables#growing_degree_days",
             "label": "growing degree days"
          },
          "growthrate": {
             "id": "http://linked.earth/ontology/paleo_variables#growthRate",
             "label": "growthRate"
          },
          "growth rate": {
             "id": "http://linked.earth/ontology/paleo_variables#growthRate",
             "label": "growthRate"
          },
          "hasgap": {
             "id": "http://linked.earth/ontology/paleo_variables#hasGap",
             "label": "hasGap"
          },
          "hashiatus": {
             "id": "http://linked.earth/ontology/paleo_variables#hasHiatus",
             "label": "hasHiatus"
          },
          "hashiatuscomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#hasHiatus",
             "label": "hasHiatus"
          },
          "hole": {
             "id": "http://linked.earth/ontology/paleo_variables#hole",
             "label": "hole"
          },
          "humidificationindex": {
             "id": "http://linked.earth/ontology/paleo_variables#humidificationIndex",
             "label": "humidificationIndex"
          },
          "humification index": {
             "id": "http://linked.earth/ontology/paleo_variables#humidificationIndex",
             "label": "humidificationIndex"
          },
          "hindex": {
             "id": "http://linked.earth/ontology/paleo_variables#humidificationIndex",
             "label": "humidificationIndex"
          },
          "icemelt": {
             "id": "http://linked.earth/ontology/paleo_variables#iceMelt",
             "label": "iceMelt"
          },
          "ice melt": {
             "id": "http://linked.earth/ontology/paleo_variables#iceMelt",
             "label": "iceMelt"
          },
          "ice_melt_fraction": {
             "id": "http://linked.earth/ontology/paleo_variables#iceMelt",
             "label": "iceMelt"
          },
          "melt": {
             "id": "http://linked.earth/ontology/paleo_variables#iceMelt",
             "label": "iceMelt"
          },
          "meltlayerfrequency": {
             "id": "http://linked.earth/ontology/paleo_variables#iceMelt",
             "label": "iceMelt"
          },
          "meltlayers": {
             "id": "http://linked.earth/ontology/paleo_variables#iceMelt",
             "label": "iceMelt"
          },
          "icerafteddebris": {
             "id": "http://linked.earth/ontology/paleo_variables#iceRaftedDebris",
             "label": "iceRaftedDebris"
          },
          "ice rafted debris": {
             "id": "http://linked.earth/ontology/paleo_variables#iceRaftedDebris",
             "label": "iceRaftedDebris"
          },
          "ird": {
             "id": "http://linked.earth/ontology/paleo_variables#iceRaftedDebris",
             "label": "iceRaftedDebris"
          },
          "inc/coh": {
             "id": "http://linked.earth/ontology/paleo_variables#inc_coh",
             "label": "inc/coh"
          },
          "inc_coh": {
             "id": "http://linked.earth/ontology/paleo_variables#inc_coh",
             "label": "inc/coh"
          },
          "incoherent:coherent scattering": {
             "id": "http://linked.earth/ontology/paleo_variables#inc_coh",
             "label": "inc/coh"
          },
          "index": {
             "id": "http://linked.earth/ontology/paleo_variables#index",
             "label": "index"
          },
          "pls-1": {
             "id": "http://linked.earth/ontology/paleo_variables#index",
             "label": "index"
          },
          "pls-2": {
             "id": "http://linked.earth/ontology/paleo_variables#index",
             "label": "index"
          },
          "sm/illitechlorite": {
             "id": "http://linked.earth/ontology/paleo_variables#index",
             "label": "index"
          },
          "isreliable": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliabieyn1": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliabieyn2": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable?": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable 1": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable 2": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable_1": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable_2": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable_3": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "reliable_4": {
             "id": "http://linked.earth/ontology/paleo_variables#isReliable",
             "label": "isReliable"
          },
          "lakearea": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeArea",
             "label": "lakeArea"
          },
          "lake area": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeArea",
             "label": "lakeArea"
          },
          "lakelevel": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "lake level": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "lake level a.s.l.": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "lakedepth": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "lakelevel_cm_": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "depth.lake": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "lakelevelrelative": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "lakestatus": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeLevel",
             "label": "lakeLevel"
          },
          "laketrend": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeTrend",
             "label": "lakeTrend"
          },
          "lakevolume": {
             "id": "http://linked.earth/ontology/paleo_variables#lakeVolume",
             "label": "lakeVolume"
          },
          "landscapecover": {
             "id": "http://linked.earth/ontology/paleo_variables#landscapeCover",
             "label": "landscapeCover"
          },
          "ecosystem quantity": {
             "id": "http://linked.earth/ontology/paleo_variables#percent",
             "label": "percent"
          },
          "openvegetation___": {
             "id": "http://linked.earth/ontology/paleo_variables#landscapeCover",
             "label": "landscapeCover"
          },
          "latitude": {
             "id": "http://linked.earth/ontology/paleo_variables#latitude",
             "label": "latitude"
          },
          "latitude sample": {
             "id": "http://linked.earth/ontology/paleo_variables#latitude",
             "label": "latitude"
          },
          "layerthickness": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "layer thickness": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "fld lay thick": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "flood lay (annual)": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "flood lay (fall)": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "flood lay (spring)": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "flood lay (summer)": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "flood lay (winter)": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "laminathickenss": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "lamina_thickness": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "debrislaythick": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "eventlayerthick": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "floodlaythick": {
             "id": "http://linked.earth/ontology/paleo_variables#layerThickness",
             "label": "layerThickness"
          },
          "lithics": {
             "id": "http://linked.earth/ontology/paleo_variables#lithics",
             "label": "lithics"
          },
          "%_lithics": {
             "id": "http://linked.earth/ontology/paleo_variables#lithics",
             "label": "lithics"
          },
          "lithic flux": {
             "id": "http://linked.earth/ontology/paleo_variables#lithics",
             "label": "lithics"
          },
          "longitude": {
             "id": "http://linked.earth/ontology/paleo_variables#longitude",
             "label": "longitude"
          },
          "longitude sample": {
             "id": "http://linked.earth/ontology/paleo_variables#longitude",
             "label": "longitude"
          },
          "material": {
             "id": "http://linked.earth/ontology/paleo_variables#material",
             "label": "material"
          },
          "reconstruction material": {
             "id": "http://linked.earth/ontology/paleo_variables#material",
             "label": "material"
          },
          "mineralogy": {
             "id": "http://linked.earth/ontology/paleo_variables#mineralogy",
             "label": "mineralogy"
          },
          "identified mineral": {
             "id": "http://linked.earth/ontology/paleo_variables#mineralogy",
             "label": "mineralogy"
          },
          "mineral_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#mineralogy",
             "label": "mineralogy"
          },
          "mineralogycomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#mineralogy",
             "label": "mineralogy"
          },
          "needstobechanged": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "((( null ))) ac ratio? /// pollenratio": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "-": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "10%max": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "10%min": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "100yrsum": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "10yrrun.avg.": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "20%max": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "20%min": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "30%max": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "30%min": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "50%max": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "50%min": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "80%max": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "80%min": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "a odd (25-35)": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "a/c": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "a/c ratio": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "alkenones": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "analogues": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "analogues#": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "bs": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "bs_comx": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "bs_landscape_openness": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "bag": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "benthic": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "c170x2d28": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cast1": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cast2": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ci": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cia": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cmt": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cmt_max": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cmt_min": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cmtmax": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "cmtmin": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ct": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "d": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "dec": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "di": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "dryelements": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "e2hterr-2haq": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "em1": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "em2": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "em3": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "emi": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "eaq-p": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hc/g": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hii (h-set)": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hii (n-set)": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hii std (h-set)": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hii std (n-set)": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "hulunnuur": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "imi": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "intv0x2e": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "jult-esep": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "lorca": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "lsr (cm/ky)": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "laminae": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "lyc.added": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mg0": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mst": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mshellcrn": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mag0x2e": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mark add": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mark found": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mean consensus": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mean_anomaly": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "minidiscus?": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mode": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "moistelements": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ne.ars": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "oep": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ppexp": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "rra": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "reconstructed": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "s52": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "tct": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "totc": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "ts": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "tsar": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "tsar5pt": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "tt": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "taraxer-14-ene concentration": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "th13c": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "u_xs": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "unit": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wacls": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wacls_total": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wainv": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wainv_total": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wapls-2": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "wmt": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "water/relict ice age": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "aridity": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "bagdepth": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "benth": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "d0x2800x2e10x29": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "d0x2800x2e50x29": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "d0x2800x2e90x29": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "d13o_pachyderma": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "distance": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "dln": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "drive-type": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "esep_pls_c2": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "esep_wmat": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "kyryr bp2": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "log[em3/(em1+em2)]": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "lower band": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "mineral": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "n-alkane": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "s": {
             "id": "http://linked.earth/ontology/paleo_variables#sulfur",
             "label": "sulfur"
          },
          "stage": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "tempsource": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "thin-mid": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "thisshouldntbeempty": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "thisshouldntbeempty1": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "unnamed": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "water": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x00x2e020xb5m0x2d30x2e890xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x10000x2e010xb5m0x2d20000x2e000xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x1250x2e000xb5m0x2d2490x2e990xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x150x2e600xb5m0x2d300x2e990xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x2500x2e000xb5m0x2d4990x2e990xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x30x2e900xb5m0x2d70x2e790xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x310x2e000xb5m0x2d620x2e490xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x5000x2e000xb5m0x2d10000x2e000xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x620x2e500xb5m0x2d1240x2e990xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "x70x2e800xb5m0x2d150x2e590xb5m": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeChanged",
             "label": "needsToBeChanged"
          },
          "needstobesplitintomultiplecolumns": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeSplitIntoMultipleColumns",
             "label": "needsToBeSplitIntoMultipleColumns"
          },
          "depth-range": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeSplitIntoMultipleColumns",
             "label": "needsToBeSplitIntoMultipleColumns"
          },
          "depthrange": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeSplitIntoMultipleColumns",
             "label": "needsToBeSplitIntoMultipleColumns"
          },
          "depth_range": {
             "id": "http://linked.earth/ontology/paleo_variables#needsToBeSplitIntoMultipleColumns",
             "label": "needsToBeSplitIntoMultipleColumns"
          },
          "nitrogen": {
             "id": "http://linked.earth/ontology/paleo_variables#nitrogen",
             "label": "nitrogen"
          },
          "n": {
             "id": "http://linked.earth/ontology/paleo_variables#nitrogen",
             "label": "nitrogen"
          },
          "notes": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "bsi_regime": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "codename": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "commentregardingreliability": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "commentregardingreliability1": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "commentregardingreliability2": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "commentregardingreliability3": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "commentregardingreliability4": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "reworked": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "color": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "entityname": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "note": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "notes_c5": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "repeats": {
             "id": "http://linked.earth/ontology/paleo_variables#notes",
             "label": "notes"
          },
          "organiccarbon": {
             "id": "http://linked.earth/ontology/paleo_variables#organicCarbon",
             "label": "organicCarbon"
          },
          "acc rate toc": {
             "id": "http://linked.earth/ontology/paleo_variables#organicCarbon",
             "label": "organicCarbon"
          },
          "c_organic_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#organicCarbon",
             "label": "organicCarbon"
          },
          "corg dens": {
             "id": "http://linked.earth/ontology/paleo_variables#organicCarbon",
             "label": "organicCarbon"
          },
          "organicmatter": {
             "id": "http://linked.earth/ontology/paleo_variables#organicMatter",
             "label": "organicMatter"
          },
          "organic matter": {
             "id": "http://linked.earth/ontology/paleo_variables#organicMatter",
             "label": "organicMatter"
          },
          "%_tom": {
             "id": "http://linked.earth/ontology/paleo_variables#organicMatter",
             "label": "organicMatter"
          },
          "om": {
             "id": "http://linked.earth/ontology/paleo_variables#organicMatter",
             "label": "organicMatter"
          },
          "om dens": {
             "id": "http://linked.earth/ontology/paleo_variables#organicMatter",
             "label": "organicMatter"
          },
          "organic": {
             "id": "http://linked.earth/ontology/paleo_variables#organicMatter",
             "label": "organicMatter"
          },
          "organicnitrogen": {
             "id": "http://linked.earth/ontology/paleo_variables#organicNitrogen",
             "label": "organicNitrogen"
          },
          "norg": {
             "id": "http://linked.earth/ontology/paleo_variables#organicNitrogen",
             "label": "organicNitrogen"
          },
          "oxygen": {
             "id": "http://linked.earth/ontology/paleo_variables#oxygen",
             "label": "oxygen"
          },
          "%o": {
             "id": "http://linked.earth/ontology/paleo_variables#oxygen",
             "label": "oxygen"
          },
          "ph": {
             "id": "http://linked.earth/ontology/paleo_variables#pH",
             "label": "pH"
          },
          "phsoil": {
             "id": "http://linked.earth/ontology/paleo_variables#pH",
             "label": "pH"
          },
          "soilph": {
             "id": "http://linked.earth/ontology/paleo_variables#pH",
             "label": "pH"
          },
          "peat": {
             "id": "http://linked.earth/ontology/paleo_variables#peat",
             "label": "peat"
          },
          "peatflux": {
             "id": "http://linked.earth/ontology/paleo_variables#peat",
             "label": "peat"
          },
          "percent": {
             "id": "http://linked.earth/ontology/paleo_variables#percent",
             "label": "percent"
          },
          "woodycover___": {
             "id": "http://linked.earth/ontology/paleo_variables#percent",
             "label": "percent"
          },
          "phosphorus": {
             "id": "http://linked.earth/ontology/paleo_variables#phosphorus",
             "label": "phosphorus"
          },
          "%p": {
             "id": "http://linked.earth/ontology/paleo_variables#phosphorus",
             "label": "phosphorus"
          },
          "potassium": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "% k": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "%k": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "k": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "k peak area": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "kprop": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "k_": {
             "id": "http://linked.earth/ontology/paleo_variables#potassium",
             "label": "potassium"
          },
          "precipitation": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "annual precipitation": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "map": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "p": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "pannom": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "panom": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "precip": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "summer precipitation": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "winter precipitation": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "precip51yr": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "precip5yr": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "precipitation (with h-set)": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "precipobs": {
             "id": "http://linked.earth/ontology/paleo_variables#precipitation",
             "label": "precipitation"
          },
          "productivity": {
             "id": "http://linked.earth/ontology/paleo_variables#productivity",
             "label": "productivity"
          },
          "pyrite": {
             "id": "http://linked.earth/ontology/paleo_variables#pyrite",
             "label": "pyrite"
          },
          "quartz": {
             "id": "http://linked.earth/ontology/paleo_variables#quartz",
             "label": "quartz"
          },
          "reflectance": {
             "id": "http://linked.earth/ontology/paleo_variables#reflectance",
             "label": "reflectance"
          },
          "brightness": {
             "id": "http://linked.earth/ontology/paleo_variables#reflectance",
             "label": "reflectance"
          },
          "x_radiograph_dark_layer": {
             "id": "http://linked.earth/ontology/paleo_variables#reflectance",
             "label": "reflectance"
          },
          "blueintensity": {
             "id": "http://linked.earth/ontology/paleo_variables#reflectance",
             "label": "reflectance"
          },
          "red_color_intensity_units": {
             "id": "http://linked.earth/ontology/paleo_variables#reflectance",
             "label": "reflectance"
          },
          "redness": {
             "id": "http://linked.earth/ontology/paleo_variables#reflectance",
             "label": "reflectance"
          },
          "relativehumidity": {
             "id": "http://linked.earth/ontology/paleo_variables#relativeHumidity",
             "label": "relativeHumidity"
          },
          "relative humidity": {
             "id": "http://linked.earth/ontology/paleo_variables#relativeHumidity",
             "label": "relativeHumidity"
          },
          "rh": {
             "id": "http://linked.earth/ontology/paleo_variables#relativeHumidity",
             "label": "relativeHumidity"
          },
          "residualchronology": {
             "id": "http://linked.earth/ontology/paleo_variables#residualChronology",
             "label": "residualChronology"
          },
          "residual chronology method": {
             "id": "http://linked.earth/ontology/paleo_variables#residualChronology",
             "label": "residualChronology"
          },
          "residual": {
             "id": "http://linked.earth/ontology/paleo_variables#residualChronology",
             "label": "residualChronology"
          },
          "ringwidth": {
             "id": "http://linked.earth/ontology/paleo_variables#ringWidth",
             "label": "ringWidth"
          },
          "ring width": {
             "id": "http://linked.earth/ontology/paleo_variables#ringWidth",
             "label": "ringWidth"
          },
          "trw": {
             "id": "http://linked.earth/ontology/paleo_variables#ringWidth",
             "label": "ringWidth"
          },
          "trsgi": {
             "id": "http://linked.earth/ontology/paleo_variables#ringWidth",
             "label": "ringWidth"
          },
          "salinity": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "saug": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "sete": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "sfev": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "shiv": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "logsalinity": {
             "id": "http://linked.earth/ontology/paleo_variables#salinity",
             "label": "salinity"
          },
          "samplecount": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleCount",
             "label": "sampleCount"
          },
          "num_samples": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleCount",
             "label": "sampleCount"
          },
          "sampleid": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample identification": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "dateid": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "lab code": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "lab id": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "originalsampleid": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample id": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample label": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample interval": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "label": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "plotname": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sambleid": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample # in section": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sampleida": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sampleidb": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sampleidc": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "samplenumber": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample_code": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sample_number": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "samples": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sisalsampleid": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sisalsampleidcomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "smapleid": {
             "id": "http://linked.earth/ontology/paleo_variables#sampleID",
             "label": "sampleID"
          },
          "sand": {
             "id": "http://linked.earth/ontology/paleo_variables#sand",
             "label": "sand"
          },
          "%_sand": {
             "id": "http://linked.earth/ontology/paleo_variables#sand",
             "label": "sand"
          },
          "x_sand": {
             "id": "http://linked.earth/ontology/paleo_variables#sand",
             "label": "sand"
          },
          "seaice": {
             "id": "http://linked.earth/ontology/paleo_variables#seaIce",
             "label": "seaIce"
          },
          "sea ice cover": {
             "id": "http://linked.earth/ontology/paleo_variables#seaIce",
             "label": "seaIce"
          },
          "imon1953": {
             "id": "http://linked.earth/ontology/paleo_variables#seaIce",
             "label": "seaIce"
          },
          "sea_ice_conc": {
             "id": "http://linked.earth/ontology/paleo_variables#seaIce",
             "label": "seaIce"
          },
          "sea_ice_months": {
             "id": "http://linked.earth/ontology/paleo_variables#seaIce",
             "label": "seaIce"
          },
          "section": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "sec label": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "section #": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "section [#]": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "section number": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "core_section": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "section name": {
             "id": "http://linked.earth/ontology/paleo_variables#section",
             "label": "section"
          },
          "sedimentdry": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "dry sediment": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "clastic": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "clastic_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "dry sample mass": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "mass dry": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "mass dry 106 to 1000 um": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "mass dry 63 to 106 um": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "mass dry >1mm": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "massdry": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "massdry_1mm": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "sedimentweight": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentDry",
             "label": "sedimentDry"
          },
          "sedimentationrate": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentationRate",
             "label": "sedimentationRate"
          },
          "sedimentation rate": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentationRate",
             "label": "sedimentationRate"
          },
          "mean sedim rate": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentationRate",
             "label": "sedimentationRate"
          },
          "sedim rate": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentationRate",
             "label": "sedimentationRate"
          },
          "sed rate": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentationRate",
             "label": "sedimentationRate"
          },
          "sedrate": {
             "id": "http://linked.earth/ontology/paleo_variables#sedimentationRate",
             "label": "sedimentationRate"
          },
          "segmentlength": {
             "id": "http://linked.earth/ontology/paleo_variables#segmentLength",
             "label": "segmentLength"
          },
          "segment": {
             "id": "http://linked.earth/ontology/paleo_variables#segmentLength",
             "label": "segmentLength"
          },
          "sequence": {
             "id": "http://linked.earth/ontology/paleo_variables#sequence",
             "label": "sequence"
          },
          "pollen sequence": {
             "id": "http://linked.earth/ontology/paleo_variables#sequence",
             "label": "sequence"
          },
          "silt": {
             "id": "http://linked.earth/ontology/paleo_variables#silt",
             "label": "silt"
          },
          "%_silt": {
             "id": "http://linked.earth/ontology/paleo_variables#silt",
             "label": "silt"
          },
          "x_silt": {
             "id": "http://linked.earth/ontology/paleo_variables#silt",
             "label": "silt"
          },
          "site": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "coresite": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "drilling project": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "lakename": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "region": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "sitename": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "site/hole": {
             "id": "http://linked.earth/ontology/paleo_variables#site",
             "label": "site"
          },
          "sitecount": {
             "id": "http://linked.earth/ontology/paleo_variables#siteCount",
             "label": "siteCount"
          },
          "#ofsites": {
             "id": "http://linked.earth/ontology/paleo_variables#siteCount",
             "label": "siteCount"
          },
          "sodium": {
             "id": "http://linked.earth/ontology/paleo_variables#sodium",
             "label": "sodium"
          },
          "na": {
             "id": "http://linked.earth/ontology/paleo_variables#sodium",
             "label": "sodium"
          },
          "na_": {
             "id": "http://linked.earth/ontology/paleo_variables#sodium",
             "label": "sodium"
          },
          "solarirradiance": {
             "id": "http://linked.earth/ontology/paleo_variables#solarIrradiance",
             "label": "solarIrradiance"
          },
          "solar irradiance": {
             "id": "http://linked.earth/ontology/paleo_variables#solarIrradiance",
             "label": "solarIrradiance"
          },
          "sunfrac": {
             "id": "http://linked.earth/ontology/paleo_variables#solarIrradiance",
             "label": "solarIrradiance"
          },
          "streamflow": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "aprq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "augq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "decq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "febq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "janq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "julyq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "juneq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "marchq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "mayq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "novq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "octq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "septq": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "discharge": {
             "id": "http://linked.earth/ontology/paleo_variables#streamflow",
             "label": "streamflow"
          },
          "sulfur": {
             "id": "http://linked.earth/ontology/paleo_variables#sulfur",
             "label": "sulfur"
          },
          "sulphur": {
             "id": "http://linked.earth/ontology/paleo_variables#sulfur",
             "label": "sulfur"
          },
          "temperature": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature variable": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "apr": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "aug": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "fra06 air temperature": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "feb": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "ice_core_c": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "jul": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "jun": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "jan": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "jultanom": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "jultanomloess": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "maat": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "mat": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "may": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "msat": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "msat russell 2018": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "meant": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nov": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "oct": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "pls_c2_temp": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "pollen_t": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sbt": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sep": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst-d18o": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst_ldi": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst_amj": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst_from_uk37": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst_from_planktic0x2emgca": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "sst_from_planktic0x2ed18o": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "t anomaly": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tete": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tfev": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "thiv": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tanom": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom 10 ci": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom 25": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom 75": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom 90": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom best": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom for15": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom fra06": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp anom fra06-tr": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tsource": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "deep.temp": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "interpolatedtemperature": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature 1": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature_1": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature_2": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature_3": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature_4": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "nonreliabletemperature 2": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "smoothedtemp": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "soiltemp": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "subt": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "t-source": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp2": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temp2s": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tempav0": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tempav8": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tempk": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tempnoelevcorrection": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tempnosourcecorrection": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temppartialcorrect": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "tempsmooth5": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature 1": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature 2": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperaturecomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature_1": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature_2": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature_3": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperature_4": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "temperaturer2": {
             "id": "http://linked.earth/ontology/paleo_variables#temperature",
             "label": "temperature"
          },
          "thickness": {
             "id": "http://linked.earth/ontology/paleo_variables#thickness",
             "label": "thickness"
          },
          "samp thick": {
             "id": "http://linked.earth/ontology/paleo_variables#thickness",
             "label": "thickness"
          },
          "sample thickness": {
             "id": "http://linked.earth/ontology/paleo_variables#thickness",
             "label": "thickness"
          },
          "sample_thickness": {
             "id": "http://linked.earth/ontology/paleo_variables#thickness",
             "label": "thickness"
          },
          "thicknesscomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#thickness",
             "label": "thickness"
          },
          "totalcarbon": {
             "id": "http://linked.earth/ontology/paleo_variables#totalCarbon",
             "label": "totalCarbon"
          },
          "tc": {
             "id": "http://linked.earth/ontology/paleo_variables#totalCarbon",
             "label": "totalCarbon"
          },
          "totalnitrogen": {
             "id": "http://linked.earth/ontology/paleo_variables#totalNitrogen",
             "label": "totalNitrogen"
          },
          "tn": {
             "id": "http://linked.earth/ontology/paleo_variables#totalNitrogen",
             "label": "totalNitrogen"
          },
          "totalpollen": {
             "id": "http://linked.earth/ontology/paleo_variables#totalPollen",
             "label": "totalPollen"
          },
          "pollen": {
             "id": "http://linked.earth/ontology/paleo_variables#totalPollen",
             "label": "totalPollen"
          },
          "treepollen": {
             "id": "http://linked.earth/ontology/paleo_variables#totalPollen",
             "label": "totalPollen"
          },
          "treecover": {
             "id": "http://linked.earth/ontology/paleo_variables#treeCover",
             "label": "treeCover"
          },
          "uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "unspecified margin of error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "13cleafwaxc29-33err": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "a_site_std": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "age_uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "annual precipitation error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "c20 total unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "c22 total unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "c24 total unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "c26 total unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "c28 total unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "c30 total unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "calibration error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "dmar_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "dmar_uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "epsilon c28-c22 uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "epsilon c28-c24 uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "epsilon uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "epsilon28-22uncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "jas_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "jaserror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "srcauncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "summer precipitation error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "tterror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "t_site_std": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uk37_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uk_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "winter precipitation error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "ageerror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "ageuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "ageuncertaintyother": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "bubblenumberdensityerror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d13c error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d13c std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d13cprecision": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d13cstandard": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d13c_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18o error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18oprecision": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18oprecisioncomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18ostandard": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18ostandardcomposite": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18ouncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18o_grass_leaf_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18o_sphagnum_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d18o_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "d2hleafwaxc28err": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "dd error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "dd unc": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "dduncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "err": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "error1": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "error2": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "error3": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "lakeareaerror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "lakevolumeerror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "nc30_err": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "precipitationuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "range": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "temperror": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "temperatureuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "temperature_error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty (\u00b1)": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty.temperature": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty_1": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty_2": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty_3": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty_4": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty_temperature": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty",
             "label": "uncertainty"
          },
          "uncertainty1s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "68% confidence interval margin of error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "2h_dino_1sig": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c23 stdev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c23 \u03b4d std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c24 d2h stdev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c25 stdev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c25 \u03b4d std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c27 stdev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 d13c std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 dd std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 stdev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 \u03b413c std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 \u03b413c std dev\u00a0[\u00b1]": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 \u03b4d std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c29 \u03b4d std dev\u00a0[\u00b1]": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c30 dd std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c31 d13c std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c31 dd std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c31 \u03b413c std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c31 \u03b4d std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c31d13csd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c33 \u03b413c std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "c33 \u03b4d std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "cbtsd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "map1-sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "mbtsd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "mg_ca_sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "sd_anomaly": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "se": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdev c28 dd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "u371sigmauncertainty-": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "wmt1-sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "d excess stdev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "d13c_c31_sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "dd std dev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "from_68": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "precipitation std": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "precipitation std (with h-set)": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "std": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stddev": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stddev___": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdev c24": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdev c26": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdev c28": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdev weighted average": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc24": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc25": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc26": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc27": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc28": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc29": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "stdevc31": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "to_68": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty1s",
             "label": "uncertainty1s"
          },
          "uncertainty2s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "95% confidence interval margin of error": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "2 sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "map2-sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "wmt2-sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "from_95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "to_95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertainty2s",
             "label": "uncertainty2s"
          },
          "uncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "unspecified error upper bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "acc max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "ageold": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "age_max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "chironomid d18o max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "imon1953_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "jas+": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "map_max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "mat_max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "matmax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "maxelevm": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "pannommax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "pannommaxuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "panommax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "panommaxuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "pmax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "saug_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "sete_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "sfev_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "shiv_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "sunfracmax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "tete_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "tfev_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "thiv_s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "treecover_max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "uncertaintydust0x5b0x250x5d0x28plus0x29": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "wmt_max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "wmtmax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "age max": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agebaconuncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agebchronuncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agemax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "ageoxcaluncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agestalageuncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "ageuncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "age_old": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agecoprauncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agelininterpuncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "agelinreguncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "cal_age_range_old": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "d18ouncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "errorup": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "errorup2": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "error_older_age": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "lakelevelhi": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "lakelevelmax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "max age": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "max rh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "maxage": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "meltuncertaintyhigh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "precip+": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "temperrorplus": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "temperrorupper": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "temperaturewarm": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "uncertainty_plus": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "upper band": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "uppererr": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "uppererr2": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "year_old": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "\u2206rh_upper": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh",
             "label": "uncertaintyHigh"
          },
          "uncertaintyhigh1s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "68% confidence interval upper bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "p+sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "q0.84": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "t+sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "t.plussd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "temperature 1 sigma range high": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "age_y_bp+1s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "ddp_1s_upper": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "deltat + 1 sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "ice volume adjusted": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "ice volume and vegetation adjusted": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "precip_1s_upper": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "precip_1s_uppper": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh1s",
             "label": "uncertaintyHigh1s"
          },
          "uncertaintyhigh50": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh50",
             "label": "uncertaintyHigh50"
          },
          "50% confidence interval upper bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh50",
             "label": "uncertaintyHigh50"
          },
          "0.25_quantile_dust_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh50",
             "label": "uncertaintyHigh50"
          },
          "0.75_quantile_dust_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh50",
             "label": "uncertaintyHigh50"
          },
          "precip dd 75 ci": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh50",
             "label": "uncertaintyHigh50"
          },
          "uncertaintyhigh90": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh90",
             "label": "uncertaintyHigh90"
          },
          "90% confidence interval upper bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh90",
             "label": "uncertaintyHigh90"
          },
          "pcpanomci95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh90",
             "label": "uncertaintyHigh90"
          },
          "uncertaintyhigh95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "95% confidence interval upper bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "0.975_quantile_dust_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "95upperage": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "q0.975": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "age95conmax": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "age_97.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "age_calbp95+": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "d13c_97.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "d18o_97.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "maxage95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "max_age_95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "upper95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyHigh95",
             "label": "uncertaintyHigh95"
          },
          "uncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "unspecified error lower bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "acc min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "age_min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "chironomid d18o min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "imon1953_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "jas-": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "map_min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "mat_min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "matmin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "minelevm": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "pannommin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "pannomminuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "panommin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "panomminuncertainty": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "pmin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "saug_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "sete_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "sfev_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "shiv_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "sunfracmin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "tete_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "tfev_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "thiv_i": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "treecover_min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "uncertaintydust0x5b0x250x5d0x28minus0x29": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "wmt_min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "wmtmin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "age min": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agebaconuncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agebchronuncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agemin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "ageoxcaluncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agestalageuncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "ageuncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "ageyoung": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "age_young": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agecoprauncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agelininterpuncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "agelinreguncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "cal_age_range_young": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "d18ouncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "errorlow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "errorlow2": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "error_younger_age": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "lakelevello": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "lakelevelmin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "lowererr": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "meltuncertaintylow": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "min age": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "min rh": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "minage": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "precip-": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "temperrorlower": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "temperaturecold": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "undertainty_minus": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "yearbottom": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "yeartop": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "\u2206rh_lower": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow",
             "label": "uncertaintyLow"
          },
          "uncertaintylow1s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "68% confidence interval lower bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "p-sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "q0.16": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "t-sd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "t.minussd": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "temperature 1 sigma range low": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "age_y_bp-1s": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "ddp_1s_lower": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "deltat - 1 sigma": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "precip_1s_lower": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow1s",
             "label": "uncertaintyLow1s"
          },
          "uncertaintylow90": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow90",
             "label": "uncertaintyLow90"
          },
          "90% confidence interval lower bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow90",
             "label": "uncertaintyLow90"
          },
          "age97.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow90",
             "label": "uncertaintyLow90"
          },
          "age_5thpercentile": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow90",
             "label": "uncertaintyLow90"
          },
          "age_95thpercentile": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow90",
             "label": "uncertaintyLow90"
          },
          "uncertaintylow95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "95% confidence interval lower bound": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "0.025_quantile_dust_flux": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "95lowerage": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "precip dd 25 ci": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "q0.025": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "age2.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "age95confmin": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "age_2.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "age_calbp95-": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "d13c_2.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "d18o_2.5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "lower95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "lowererr2": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "minage95": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "pcpanomci5": {
             "id": "http://linked.earth/ontology/paleo_variables#uncertaintyLow95",
             "label": "uncertaintyLow95"
          },
          "upwelling": {
             "id": "http://linked.earth/ontology/paleo_variables#upwelling",
             "label": "upwelling"
          },
          "upwelling index": {
             "id": "http://linked.earth/ontology/paleo_variables#upwelling",
             "label": "upwelling"
          },
          "uranium": {
             "id": "http://linked.earth/ontology/paleo_variables#uranium",
             "label": "uranium"
          },
          "u": {
             "id": "http://linked.earth/ontology/paleo_variables#uranium",
             "label": "uranium"
          },
          "varvethickness": {
             "id": "http://linked.earth/ontology/paleo_variables#varveThickness",
             "label": "varveThickness"
          },
          "varve thickness": {
             "id": "http://linked.earth/ontology/paleo_variables#varveThickness",
             "label": "varveThickness"
          },
          "varve_width": {
             "id": "http://linked.earth/ontology/paleo_variables#varveThickness",
             "label": "varveThickness"
          },
          "volume": {
             "id": "http://linked.earth/ontology/paleo_variables#volume",
             "label": "volume"
          },
          "samp vol": {
             "id": "http://linked.earth/ontology/paleo_variables#volume",
             "label": "volume"
          },
          "watercontent": {
             "id": "http://linked.earth/ontology/paleo_variables#waterContent",
             "label": "waterContent"
          },
          "water content": {
             "id": "http://linked.earth/ontology/paleo_variables#waterContent",
             "label": "waterContent"
          },
          "watertabledepth": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "water table depth": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "water table": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "water table detrended": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "water_tabledepth": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "water wm": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "water_table_depth": {
             "id": "http://linked.earth/ontology/paleo_variables#waterTableDepth",
             "label": "waterTableDepth"
          },
          "wetbulkdensity": {
             "id": "http://linked.earth/ontology/paleo_variables#wetBulkDensity",
             "label": "wetBulkDensity"
          },
          "wetbd": {
             "id": "http://linked.earth/ontology/paleo_variables#wetBulkDensity",
             "label": "wetBulkDensity"
          },
          "year": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "recon0x2edate": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "year b2k": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "age_ce": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "year start": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "yearensemble": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "yearrounded": {
             "id": "http://linked.earth/ontology/paleo_variables#year",
             "label": "year"
          },
          "zscore": {
             "id": "http://linked.earth/ontology/paleo_variables#zscore",
             "label": "zscore"
          },
          "z_score": {
             "id": "http://linked.earth/ontology/paleo_variables#zscore",
             "label": "zscore"
          }
       }
    }
}

// Reverse synonyms mapping from ID to label
export const RSYNONYMS: { [id: string]: string } = {};

// Populate RSYNONYMS by iterating through SYNONYMS
for (const category in SYNONYMS) {
    for (const className in SYNONYMS[category as keyof typeof SYNONYMS]) {
        const categoryObj = SYNONYMS[category as keyof typeof SYNONYMS];
        if (categoryObj) {
            const synonyms: any = categoryObj[className as keyof typeof categoryObj];
            if (synonyms) {
                for (const synonym in synonyms) {
                    const synObj = synonyms[synonym];
                    RSYNONYMS[synObj.id] = synObj.label;
                }
            }
        }
    }
}
